{
  "accept_invitation": {
    "account_exists": {
      "description_prefix": "ఈ ఇమెయిల్‌తో ఖాతా",
      "description_suffix": "ఇప్పటికే ఉంది. ఆహ్వానం ఆమోదించడానికి లాగిన్ అవ్వండి.",
      "title": "ఖాతా ఇప్పటికే ఉంది"
    },
    "actions": {
      "create_and_accept": "ఖాతా సృష్టించి ఆమోదించండి",
      "creating_account": "ఖాతా సృష్టిస్తోంది...",
      "go_to_login": "లాగిన్‌కు వెళ్ళండి",
      "login_to_accept": "ఆమోదించడానికి లాగిన్ అవ్వండి"
    },
    "errors": {
      "accept_failed": "ఆహ్వానాన్ని ఆమోదించడంలో విఫలమైంది",
      "all_fields_required": "అన్ని ఫీల్డ్స్ అవసరం",
      "invalid_link": "చెల్లని ఆహ్వాన లింక్",
      "password_min_length": "పాస్‌వర్డ్ కనీసం 8 అక్షరాలు ఉండాలి",
      "verify_failed": "ఆహ్వానాన్ని ధృవీకరించడంలో విఫలమైంది"
    },
    "form": {
      "first_name": "మొదటి పేరు",
      "last_name": "చివరి పేరు",
      "new_account_needed": "కొత్త ఖాతా అవసరం. దయచేసి మీ వివరాలు ఇవ్వండి.",
      "password": "పాస్‌వర్డ్",
      "subtitle": "సంస్థలో చేరడానికి మీ నమోదు పూర్తిచేయండి",
      "title": "ఆహ్వానాన్ని ఆమోదించండి",
      "username_note": "మీ యూజర్‌నేమ్ మీ పేరుతో ఆటోమేటిక్‌గా సృష్టించబడుతుంది."
    },
    "invalid": {
      "title": "చెల్లని ఆహ్వానం"
    },
    "joining": {
      "adding_you_to": "మీరు చేరుతున్న సంస్థ",
      "title": "సంస్థలో చేరుస్తున్నాం"
    },
    "loading": {
      "verify_invitation": "మీ ఆహ్వానం ధృవీకరిస్తున్నాం..."
    }
  },
  "account": {
    "notifications": {
      "daily_usage_digest": "రోజువారీ వినియోగ సారాంశం",
      "daily_usage_digest_desc": "AI వినియోగం మరియు వాలెట్ బ్యాలెన్స్ యొక్క రోజువారీ ఇమెయిల్ సారాంశం పొందండి (ఇమెయిల్ నోటిఫికేషన్లు అవసరం)."
    }
  },
  "activity_logs": {
    "action": "చర్య",
    "card_description": "అన్ని వినియోగదారు మరియు సిస్టమ్ కార్యకలాపాలు క్రింద జాబితా చేయబడ్డాయి.",
    "card_title": "లాగ్‌లు",
    "count_one": "{{count}} మొత్తం కార్యకలాపాలు",
    "count_other": "{{count}} మొత్తం కార్యకలాపాలు",
    "create_index_link": "ఫైర్‌బేస్ కన్సోల్‌లో సూచికను సృష్టించండి",
    "date": "తేదీ",
    "description": "అన్ని సిస్టమ్ కార్యకలాపాలు మరియు ఆడిట్ లాగ్‌లను వీక్షించండి.",
    "details": "వివరాలు",
    "filters": {
      "all_actions": "అన్ని చర్యలు"
    },
    "headers": {
      "action": "చర్య",
      "details": "వివరాలు",
      "timestamp": "సమయము",
      "user": "వినియోగదారు"
    },
    "no_logs_desc": "నిర్దిష్ట కాలంలో ఈ వినియోగదారు కోసం ఎటువంటి ఈవెంట్‌లు నమోదు చేయబడలేదు.",
    "recent_events": "ఇటీవలి ఈవెంట్‌లు",
    "retry_instruction": "(తరువాత క్రింద మళ్లీ ప్రయత్నించండి).",
    "search_placeholder": "లాగ్‌లను శోధించండి...",
    "title": "కార్యకలాప లాగ్‌లు"
  },
  "admin_dashboard": {
    "organizations": {
      "active_orgs": "క్రియాశీల బిల్డర్‌లు",
      "desc": "బిల్డర్ గణాంకాలు మరియు నిర్వహణ యొక్క అవలోకనం.",
      "manage_btn": "బిల్డర్‌లను నిర్వహించండి",
      "new_orgs_week": "ఈ వారం కొత్త బిల్డర్‌లు",
      "title": "బిల్డర్‌లు",
      "total_orgs": "మొత్తం బిల్డర్‌లు"
    },
    "rbac": {
      "active_assignments": "క్రియాశీల పనులను",
      "desc": "పాత్రలు, అనుమతులు మరియు యాక్సెస్ నియంత్రణ యొక్క అవలోకనం.",
      "manage_roles_btn": "పాత్రలను నిర్వహించండి",
      "new_assignments": "పనులను",
      "title": "పాత్ర-ఆధారిత యాక్సెస్ నియంత్రణ",
      "total_permissions": "మొత్తం అనుమతులు",
      "total_roles": "మొత్తం పాత్రలు",
      "view_perms_btn": "అనుమతులను వీక్షించండి"
    },
    "user_management": {
      "active_users": "క్రియాశీల వినియోగదారులు",
      "desc": "వినియోగదారు గణాంకాలు మరియు నిర్వహణ యొక్క అవలోకనం.",
      "manage_btn": "వినియోగదారులను నిర్వహించండి",
      "new_users_week": "ఈ వారం కొత్త వినియోగదారులు",
      "title": "వినియోగదారు నిర్వహణ",
      "total_users": "మొత్తం వినియోగదారులు"
    }
  },
  "admin_subs": {
    "description": "ప్లాట్‌ఫారమ్‌లోని అన్ని సబ్‌స్క్రిప్షన్‌లను పర్యవేక్షించండి మరియు నిర్వహించండి",
    "headers": {
      "auto_renew": "ఆటో రెన్యూ",
      "end_date": "ముగింపు తేదీ",
      "organization": "సంస్థ",
      "plan": "ప్రణాళిక",
      "price": "ధర",
      "start_date": "ప్రారంభ తేదీ",
      "stripe_id": "స్ట్రైప్ ఐడి",
      "user": "వినియోగదారు"
    },
    "stats": {
      "active_subscriptions": "క్రియాశీల సబ్‌స్క్రిప్షన్‌లు",
      "monthly_revenue": "నెలవారీ ఆదాయం",
      "total_subscriptions": "మొత్తం సబ్‌స్క్రిప్షన్‌లు"
    },
    "table": {
      "description": "ఫిల్టరింగ్ మరియు శోధన సామర్థ్యాలతో అన్ని సబ్‌స్క్రిప్షన్‌ల వివరణాత్మక వీక్షణ",
      "title": "అన్ని సబ్‌స్క్రిప్షన్‌లు"
    },
    "title": "అన్ని సబ్‌స్క్రిప్షన్‌లను నిర్వహించండి"
  },
  "admin_user_detail": {
    "actions": {
      "edit_identifier": "ఐడెంటిఫయర్ సవరించు",
      "reset_password": "పాస్‌వర్డ్ రీసెట్",
      "return_dashboard": "డాష్‌బోర్డ్‌కు తిరిగి వెళ్ళు",
      "return_org_users": "ఆర్గ్ యూజర్లకు తిరిగి వెళ్ళు"
    },
    "activity": {
      "description": "ఖాతా మరియు సిస్టమ్ ఈవెంట్ల సమయ క్రమ రికార్డ్.",
      "empty": "చర్యలు లేవు.",
      "system_event": "సిస్టమ్ ఈవెంట్ ట్రిగ్గర్ అయింది.",
      "title": "చర్యల లాగ్"
    },
    "errors": {
      "access_denied": "ప్రవేశం నిరాకరించబడింది",
      "identity_not_found": "అభ్యర్థించిన గుర్తింపు కనుగొనబడలేదు.",
      "load_user_failed": "యూజర్ వివరాలు లోడ్ చేయలేకపోయాం.",
      "transmission_failed": "ప్రసారం విఫలమైంది",
      "update_status_failed": "స్థితి అప్డేట్ విఫలమైంది"
    },
    "labels": {
      "organization_users": "సంస్థ యూజర్లు",
      "system_users": "సిస్టమ్ యూజర్లు"
    },
    "loading_profile": "యూజర్ ప్రొఫైల్ లోడ్ అవుతోంది",
    "organizations": {
      "description": "ఈ యూజర్‌కు సంబంధించిన సంస్థల జాబితా.",
      "independent_user": "స్వతంత్ర యూజర్ (సంస్థ లేదు)",
      "title": "సంస్థ సభ్యత్వాలు"
    },
    "profile": {
      "access_enabled": "యూజర్‌కు ప్లాట్‌ఫామ్ యాక్సెస్ ఉంది",
      "access_restricted": "యాక్సెస్ పరిమితం చేయబడింది",
      "account_status": "ఖాతా స్థితి",
      "active_status": "యాక్టివ్ స్థితి",
      "awaiting_verification": "ధృవీకరణ కోసం వేచి ఉంది",
      "billing_wallet": "",
      "email": "ఇమెయిల్",
      "email_notifications": "ఇమెయిల్ నోటిఫికేషన్లు",
      "email_verified": "ఇమెయిల్ ధృవీకరించబడింది",
      "identity_confirmed": "గుర్తింపు నిర్ధారించబడింది",
      "in_app_notifications": "ఇన్-యాప్ నోటిఫికేషన్లు",
      "info": "ప్రొఫైల్ సమాచారం",
      "language": "భాష",
      "last_login": "చివరి లాగిన్",
      "member_since": "సభ్యత్వం ప్రారంభం",
      "never": "ఎప్పుడూ కాదు",
      "notifications": "నోటిఫికేషన్లు",
      "phone": "ఫోన్",
      "username": "యూజర్‌నేమ్"
    },
    "roles_tab": {
      "assigned_roles": "కేటాయించిన రోల్స్",
      "description": "ఈ యూజర్‌కు కేటాయించిన ప్రస్తుత అనుమతులు.",
      "direct_role": "నేరుగా కేటాయించిన రోల్",
      "global_access": "గ్లోబల్ యాక్సెస్",
      "organization_scoped": "సంస్థ పరిమిత",
      "platform_wide_role": "ప్లాట్‌ఫామ్-వైడ్ రోల్",
      "total_one": "",
      "total_other": ""
    },
    "tabs": {
      "activity": "చర్య",
      "organizations": "సంస్థలు",
      "profile": "ప్రొఫైల్",
      "roles": "రోల్స్",
      "usage": "వినియోగం & క్రెడిట్లు"
    },
    "toasts": {
      "recovery_initiated": "రికవరీ ప్రారంభించబడింది",
      "user_activated": "యూజర్ విజయవంతంగా యాక్టివేట్ అయ్యాడు",
      "user_deactivated": "యూజర్ విజయవంతంగా డీయాక్టివేట్ అయ్యాడు"
    },
    "usage": {
      "amount_inr": "",
      "amount_placeholder": "0.00",
      "amount_usd": "మొత్తం (USD)",
      "credits_added_to": "క్రెడిట్లు జోడించబడతాయి",
      "current_balance": "ప్రస్తుత బ్యాలెన్స్",
      "description": "వివరణ",
      "description_placeholder": "ఉద్దేశ్యం (ఉదా: Refund, Bonus)",
      "errors": {
        "grant_failed": "క్రెడిట్లు ఇవ్వడం విఫలమైంది"
      },
      "grant_credits": "క్రెడిట్లు ఇవ్వండి",
      "grant_org": "ఆర్గ్ వాలెట్‌కు ఇవ్వండి",
      "grant_org_desc": "సంస్థ షేర్ చేసిన వాలెట్‌కు క్రెడిట్లు జోడించండి.",
      "grant_personal": "పర్సనల్ వాలెట్‌కు ఇవ్వండి",
      "grant_personal_desc": "ఈ యూజర్ ఖాతాకు వినియోగ క్రెడిట్లు జోడించండి.",
      "lifetime_credits": "మొత్తం క్రెడిట్లు",
      "lifetime_usage": "మొత్తం వినియోగం",
      "no_transactions": "లావాదేవీలు లేవు.",
      "org_wallet": "ఆర్గ్ వాలెట్",
      "toast": {
        "org_granted": "{{amount}} క్రెడిట్లు {{orgName}} ఆర్గ్ వాలెట్‌కు ఇచ్చాం",
        "personal_granted": "{{amount}} క్రెడిట్లు పర్సనల్ వాలెట్‌కు ఇచ్చాం"
      },
      "transaction_history": "లావాదేవీ చరితం",
      "transaction_history_desc": "బ్యాలెన్స్ మరియు వినియోగ మార్పుల చరితం."
    }
  },
  "admin_users": {
    "access_denied": {
      "description": "వినియోగదారు నిర్వహణను వీక్షించడానికి మీకు అవసరమైన అనుమతులు లేవు.",
      "title": "యాక్సెస్ తిరస్కరించబడింది"
    },
    "add_user": "వినియోగదారుని జోడించండి",
    "billing_country": "",
    "billing_country_locked": "",
    "billing_country_super_admin_only": "",
    "bulk_actions": {
      "activate": "యాక్టివేట్ చేయండి",
      "activate_now": "వినియోగదారులను యాక్టివేట్ చేయండి",
      "confirm_activate": "అడ్మిన్ వినియోగదారుల బల్క్ చర్యలు యాక్టివేషన్ నిర్ధారణ",
      "confirm_deactivate": "అడ్మిన్ వినియోగదారుల బల్క్ చర్యలు డియాక్టివేషన్ నిర్ధారణ",
      "confirm_reset_password": "అడ్మిన్ యూజర్స్ బల్క్ యాక్షన్స్ పాస్‌వర్డ్‌ను రీసెట్ చేయడాన్ని నిర్ధారించండి",
      "deactivate": "డియాక్టివేట్ చేయండి",
      "deactivate_now": "వినియోగదారులను డియాక్టివేట్ చేయండి",
      "description": "ఎంచుకున్న పాల్గొనేవారందరికీ వర్తించే చర్యను ఎంచుకోండి.",
      "export": "CSV ఎగుమతి చేయండి",
      "grant_button": "ఇప్పుడు క్రెడిట్‌లను మంజూరు చేయండి",
      "grant_credits": "క్రెడిట్‌లను మంజూరు చేయండి",
      "grant_credits_failed": "కొంతమంది వినియోగదారులకు క్రెడిట్‌లను మంజూరు చేయడంలో విఫలమైంది.",
      "grant_to_multiple": "ఒకేసారి బహుళ వినియోగదారులకు క్రెడిట్‌లను మంజూరు చేయండి.",
      "reset_password": "పాస్‌వర్డ్ రీసెట్ లింక్‌లను పంపండి",
      "reset_password_success": "అడ్మిన్ యూజర్స్ బల్క్ యాక్షన్స్ పాస్‌వర్డ్ రీసెట్ విజయవంతం",
      "selected": "యూజర్‌లు ఎంపిక చేయబడ్డారు",
      "selected_users": "ఎంచుకున్న వినియోగదారులు",
      "send_now": "ఇప్పుడే లింక్‌లను పంపండి",
      "users_affected": "వినియోగదారులు ప్రభావితమవుతారు"
    },
    "cannot_deactivate_self": "మీ స్వంత ఖాతాను నిష్క్రియం చేయలేరు.",
    "card": {
      "description": "మీ సిస్టమ్‌లోని వినియోగదారులందరి జాబితా.",
      "title": "వినియోగదారులందరూ"
    },
    "edit_user": "పాల్గొనేవారిని సవరించండి",
    "email_reset": "ఇమెయిల్ రీసెట్ లింక్",
    "email_reset_desc": "వినియోగదారు ఇమెయిల్ ద్వారా ప్రామాణిక ప్రవాహం",
    "errors": {
      "fetch_failed": "వినియోగదారులను లేదా పాత్రలను పొందడంలో విఫలమైంది.",
      "no_users": "వినియోగదారులు లేరు"
    },
    "filters": {
      "all": "అన్నీ",
      "all_roles": "అన్ని పాత్రలు",
      "all_status": "అన్ని స్థితి"
    },
    "invalid_amount": "దయచేసి సరైన మొత్తాన్ని నమోదు చేయండి.",
    "list_description": "నమోదిత ఖాతాలన్నింటికీ మరియు వాటి యాక్సెస్ స్థాయిలకు సంబంధించిన కేంద్రీకృత జాబితా.",
    "pagination_info": "{{total}} మంది పాల్గొనేవారిలో {{start}} నుండి {{end}} వరకు చూపుతోంది",
    "pending": {
      "aadhaar": "ఆధార్ పెండింగ్‌లో ఉంది",
      "all_complete": "పూర్తయింది",
      "country": "దేశం లేదు",
      "email": "ఇమెయిల్ ధృవీకరించబడలేదు",
      "phone": "ఫోన్ లేదు"
    },
    "search_placeholder": "వినియోగదారులను శోధించండి...",
    "sections": {
      "access": "యాక్సెస్ & గుర్తింపు",
      "billing": "",
      "personal": "వ్యక్తిగత ప్రొఫైల్",
      "preferences": "సిస్టమ్ ప్రాధాన్యతలు",
      "security": "భద్రతా నిర్వహణ"
    },
    "send_link": "లింక్ పంపండి",
    "set_password": "అడ్మినిస్ట్రేటివ్ పాస్‌వర్డ్ రీసెట్",
    "status_modal": {
      "activate_desc": "కోసం ఖాతా సక్రియంను నిర్ధారించండి",
      "activate_title": "ఖాతాను సక్రియం చేయండి",
      "activate_warning": "ఈ ఖాతాను సక్రియం చేయడం వలన అన్ని ప్లాట్‌ఫారమ్ అధికారాలు వెంటనే పునరుద్ధరించబడతాయి.",
      "deactivate_desc": "కోసం ఖాతా నిష్క్రియంను నిర్ధారించండి",
      "deactivate_title": "ఖాతాను నిష్క్రియం చేయండి",
      "deactivate_warning": "ఈ ఖాతాను నిష్క్రియం చేయడం వలన, మళ్లీ సక్రియం చేసే వరకు అన్ని ప్లాట్‌ఫారమ్ యాక్సెస్ వెంటనే రద్దు చేయబడుతుంది."
    },
    "status_update_failed": "వినియోగదారు స్థితిని నవీకరించడం విఫలమైంది",
    "subtitle": "మీ సంస్థ వినియోగదారులను నిర్వహించండి.",
    "system_participants": "సిస్టమ్ పార్టిసిపెంట్స్",
    "table": {
      "aadhaar": "",
      "aadhaar_last_four": "",
      "aadhaar_not_verified": "",
      "aadhaar_verified": "",
      "actions": "చర్యలు",
      "country_currency": "దేశం / కరెన్సీ",
      "created": "సృష్టించబడింది",
      "email_verified": "ఇమెయిల్ ధృవీకరణ",
      "id": "ఐడి",
      "member_since": "సభ్యత్వం అప్పటి నుండి",
      "name": "పేరు",
      "roles": "పాత్రలు",
      "status": "స్థితి",
      "view_usage": "వినియోగాన్ని వీక్షించండి"
    },
    "title": "వినియోగదారులు",
    "total_users": "మొత్తం వినియోగదారులు",
    "unverification_success": "",
    "usage_sheet": {
      "amount": "మొత్తం",
      "amount_inr": "",
      "amount_usd": "మొత్తం (USD)",
      "date": "తేదీ",
      "description": "వివరణ (ఐచ్ఛికం)",
      "description_placeholder": "ఉదాహరణకు: ప్రచార క్రెడిట్‌లు",
      "grant_button": "క్రెడిట్‌లను మంజూరు చేయండి",
      "grant_credits": "క్రెడిట్‌లను మంజూరు చేయండి",
      "grant_org_button": "",
      "grant_success": "",
      "ledger": "ఇటీవలి లెడ్జర్",
      "no_entries": "ఇప్పటివరకు ఎటువంటి లెడ్జర్ ఎంట్రీలు లేవు.",
      "org_wallet": "",
      "personal_balance": "",
      "personal_wallet": "",
      "select_wallet_label": "",
      "title": "క్రెడిట్‌లు & వినియోగం",
      "type": "రకం"
    },
    "user_activated": "వినియోగదారు ఖాతా సక్రియం చేయబడింది",
    "user_deactivated": "వినియోగదారు ఖాతా నిష్క్రియం చేయబడింది",
    "verification_error": "",
    "verification_success": "",
    "verify_desc": "ఇమెయిల్ ధృవీకరణ స్థితి కోసం మాన్యువల్ ఓవర్‌రైడ్",
    "wallet_currency": "",
    "wallet_currency_locked": "",
    "wallet_currency_pending": ""
  },
  "analytics": {
    "actions": {
      "export_data": "డేటాను ఎగుమతి చేయండి",
      "view_detailed_report": "వివరణాత్మక నివేదికను చూడండి",
      "view_system_logs": "సిస్టమ్ లాగ్‌లను చూడండి"
    },
    "activity": {
      "desc_super_admin": "ఎకోసిస్టమ్‌లోని తాజా అప్‌డేట్‌లు.",
      "desc_user": "ఈ నెలలో ఎక్కువగా వీక్షించబడిన ఆస్తులు.",
      "title_super_admin": "ప్లాట్‌ఫాం కార్యాచరణ",
      "title_user": "అత్యుత్తమ పనితీరు కనబరుస్తున్న జాబితాలు"
    },
    "charts": {
      "engagement_overview": "ఎంగేజ్‌మెంట్ అవలోకనం",
      "engagement_overview_desc": "అన్ని ఆస్తులలో రోజువారీ వీక్షణలు మరియు విచారణలు.",
      "growth_revenue": "వృద్ధి మరియు ఆదాయం",
      "growth_revenue_desc": "నెలవారీ పునరావృత ఆదాయం మరియు వినియోగదారుల సముపార్జన పోకడలు."
    },
    "description_super_admin": "ప్లాట్‌ఫారమ్ ఆరోగ్యం, వినియోగదారుల వృద్ధి మరియు వ్యాపార కొలమానాలను పర్యవేక్షించండి.",
    "description_user": "మీ జాబితాల పనితీరు మరియు నిశ్చితార్థ కొలమానాలను ట్రాక్ చేయండి.",
    "filters": {
      "last_30_days": "చివరి 30 రోజులు"
    },
    "metrics": {
      "inquiries": "విచారణలు",
      "views_count_one": "{{count}} వీక్షణలు",
      "views_count_other": "{{count}} వీక్షణలు"
    },
    "stats": {
      "interested_tenants": "ఆసక్తిగల అద్దెదారులు",
      "total_properties": "మొత్తం ఆస్తులు",
      "total_views": "మొత్తం వీక్షణలు"
    },
    "super_admin": {
      "active_organizations": "యాక్టివ్ సంస్థలు",
      "estimated_revenue": "అంచనా ఆదాయం",
      "total_platform_users": "మొత్తం ప్లాట్‌ఫారమ్ వినియోగదారులు"
    },
    "title_super_admin": "ప్లాట్‌ఫారమ్ అవలోకనం",
    "title_user": "పనితీరు విశ్లేషణలు"
  },
  "analytics_report_modal": {
    "actions": {
      "export_csv": "CSV ఎగుమతి చేయండి"
    },
    "description": "వ్యూలు మరియు ఎంగేజ్‌మెంట్ ఆధారంగా మీ అగ్ర ప్రదర్శన చేస్తున్న ఆస్తుల విశ్లేషణ.",
    "empty": "ఈ నివేదికకు డేటా అందుబాటులో లేదు.",
    "errors": {
      "load_failed": "నివేదిక డేటా లోడ్ చేయడంలో విఫలమైంది"
    },
    "loading": "నివేదిక డేటా లోడ్ అవుతోంది...",
    "success": {
      "exported": "నివేదిక విజయవంతంగా డౌన్‌లోడ్ అయింది"
    },
    "table": {
      "inquiries": "విచారణలు",
      "location": "స్థానం",
      "price": "ధర",
      "property": "ఆస్తి",
      "status": "స్థితి",
      "views": "వ్యూలు"
    },
    "title": "వివరమైన కంటెంట్ పనితీరు నివేదిక"
  },
  "api_usage": {
    "description": "అభ్యర్థనల సంఖ్య, వినియోగదారు లేదా సంస్థ ద్వారా వినియోగం మరియు రోజువారీ విశ్లేషణను వీక్షించండి. సూపర్‌అడ్మిన్‌లకు మాత్రమే.",
    "summary": {
      "card_description": "ఎంచుకున్న కాలానికి మొత్తం API అభ్యర్థనలు మరియు ఎండ్‌పాయింట్ వారీగా విశ్లేషణ.",
      "card_title": "సారాంశం"
    },
    "tabs": {
      "by_org": "సంస్థ ద్వారా",
      "by_user": "వినియోగదారు ద్వారా",
      "daily": "రోజువారీ",
      "recent": "ఇటీవలి",
      "summary": "సారాంశం"
    },
    "title": "API వినియోగం"
  },
  "assistant": {
    "badge_search": "శోధన",
    "confirm_delete_desc": "మీరు నిజంగా ఈ శోధనను తొలగించాలనుకుంటున్నారా? చాట్ మరియు సేవ్ చేసిన ఫలితాలు శాశ్వతంగా తొలగించబడతాయి.",
    "confirm_delete_title": "శోధనను తొలగించాలా?",
    "delete_search": "శోధనను తొలగించు",
    "exit_dashboard": "డాష్‌బోర్డ్‌కు వెళ్లండి",
    "header_credits_hint": "వినియోగం మరియు బిల్లింగ్",
    "header_home_aria": "హోమ్‌కు వెళ్లండి",
    "header_profile_aria": "ఖాతా మెనూ",
    "header_sign_in_aria": "సైన్ ఇన్",
    "hero_greeting": "ఈరోజు మీరు ఏమి కనుగొనాలనుకుంటున్నారు?",
    "hero_tagline": "ఇళ్లు, ప్లాట్లు మరియు కార్యాలయాలు—సాదా భాషలో అడగండి.",
    "hide_map": "మ్యాప్ దాచు",
    "language": "భాష",
    "map_city_center_short": "{{city}} పై కేంద్రీకృతమైంది",
    "map_pin_count_one": "మ్యాప్‌లో {{count}}",
    "map_pin_count_other": "మ్యాప్‌లో {{count}}",
    "map_short": "మ్యాప్",
    "no_searches_yet": "ఇంకా శోధనలు లేవు. ప్రాపర్టీలను కనుగొనడానికి సంభాషణ ప్రారంభించండి.",
    "on_map": "మ్యాప్‌లో",
    "placeholder": "మీకు కావలసిన ప్రాపర్టిని వివరించండి…",
    "quick_menu_aria": "రూపం మరియు సెట్టింగ్‌లు",
    "recent_searches": "ఇటీవలి శోధనలు",
    "results_map": "శోధన ఫలితాల మ్యాప్",
    "resume": {
      "continue": "మునుపటి శోధనను కొనసాగించండి",
      "description": "మీకు ఇటీవలి ప్రాపర్టీ శోధన ఉంది. అక్కడి నుంచి కొనసాగించండి, లేదా కొత్త శోధన మొదలుపెట్టండి.",
      "start_new": "కొత్త శోధన మొదలుపెట్టండి",
      "title": "మునుపటి శోధనను కొనసాగించాలా?"
    },
    "search_delete_failed": "శోధన తొలగించడం విఫలమైంది",
    "search_deleted": "శోధన తొలగించబడింది",
    "searching_hint": "మీ ప్రాంతంలో ప్రాపర్టీలను స్కాన్ చేస్తోంది…",
    "searching_status": "సరిపోలే ప్రాపర్టీలను కనుగొంటోంది",
    "sidebar_title": "నా శోధనలు",
    "theme": "థీమ్",
    "theme_dark": "డార్క్",
    "theme_light": "లైట్",
    "voice_toggle": "వాయిస్ ప్రారంభం / ఆపడానికి నొక్కండి"
  },
  "auth": {
    "accept_terms_required": "మీరు నిబంధనలను అంగీకరించాలి",
    "after_verifying": "మీ ఇమెయిల్‌ను ధృవీకరించిన తర్వాత.",
    "agree_to_terms": "నేను అంగీకరిస్తున్నాను",
    "already_have_account": "మీకు ఇప్పటికే ఖాతా ఉందా?",
    "and": "మరియు",
    "billing_country": "నివాస దేశం",
    "billing_country_hint": "మీ వాలెట్ {{currency}} ఉపయోగిస్తుంది. ఇది నమోదు సమయంలో సెట్ అవుతుంది మరియు తర్వాత మార్చలేరు.",
    "checking_availability": "లభ్యతను తనిఖీ చేస్తోంది...",
    "city": "నగరం",
    "confirm_password": "పాస్‌వర్డ్‌ను నిర్ధారించండి",
    "confirm_your_password": "మీ పాస్‌వర్డ్‌ను నిర్ధారించండి",
    "continue_with_facebook": "Facebookతో కొనసాగండి",
    "continue_with_google": "Googleతో కొనసాగండి",
    "continue_with_phone": "ఫోన్‌తో కొనసాగండి",
    "create_account": "మీ ఖాతాను సృష్టించండి",
    "create_password": "పాస్‌వర్డ్‌ను సృష్టించండి",
    "creating_account": "ఖాతాను సృష్టిస్తోంది...",
    "dont_have_account": "ఖాతా లేదా?",
    "email": "ఇమెయిల్",
    "email_or_username": "ఇమెయిల్ లేదా వినియోగదారు పేరు",
    "enter_city": "ఉదాహరణకు: హైదరాబాద్, అహ్మదాబాద్",
    "enter_credentials": "మీ ఖాతాను ప్రాప్యత చేయడానికి మీ ఆధారాలను నమోదు చేయండి",
    "enter_email": "మీ ఇమెయిల్‌ను నమోదు చేయండి",
    "enter_email_or_username": "మీ ఇమెయిల్ లేదా వినియోగదారు పేరు నమోదు చేయండి",
    "enter_first_name": "జాన్",
    "enter_info": "మీ ఖాతాను సృష్టించడానికి మీ సమాచారాన్ని నమోదు చేయండి",
    "enter_last_name": "డో",
    "enter_organization_name": "మీ బిల్డర్ పేరు",
    "enter_password": "మీ పాస్‌వర్డ్‌ను నమోదు చేయండి",
    "enter_phone": "9876543210",
    "enter_phone_national": "మీ ఫోన్ నంబర్ నమోదు చేయండి",
    "enter_username": "జాన్‌డో",
    "fill_all_required": "దయచేసి ఎంచుకున్న నమోదు రకం కోసం అవసరమైన అన్ని ఫీల్డ్లను పూరించండి",
    "first_name": "మొదటి పేరు",
    "first_name_required": "మొదటి పేరు అవసరం",
    "forgot_password": "పాస్‌వర్డ్ మర్చిపోయారా?",
    "forgot_password_page": {
      "description": "మీ ఇమెయిల్ చిరునామాను నమోదు చేయండి మరియు మీ పాస్‌వర్డ్‌ను రీసెట్ చేయడానికి మేము మీకు లింక్‌ను పంపుతాము.",
      "email_label": "ఇమెయిల్ చిరునామా",
      "email_placeholder": "you@example.com",
      "error_generic": "ఏదో తప్పు జరిగింది. దయచేసి మళ్ళీ ప్రయత్నించండి.",
      "send_link": "రీసెట్ లింక్ పంపండి",
      "sending": "పంపిస్తోంది...",
      "success_check": "మీ ఇన్‌బాక్స్ మరియు స్పామ్ ఫోల్డర్‌ను తనిఖీ చేయండి.",
      "success_title": "ఈమెయిల్ ఉనికిలో ఉంటే, పాస్‌వర్డ్ రీసెట్ లింక్ పంపబడింది.",
      "title": "మీ పాస్‌వర్డ్ మర్చిపోయారా?"
    },
    "google_signin_failed": "Google సైన్-ఇన్ విఫలమైంది. దయచేసి మళ్లి ప్రయత్నించండి.",
    "i_am_a": "నేను ఒక",
    "identifier_required": "ఇమెయిల్ లేదా వినియోగదారు పేరు అవసరం",
    "identifier_too_long": "254 అక్షరాలు లేదా అంతకంటే తక్కువ ఉండాలి",
    "individual_desc": "వెతకండి, అద్దెకు తీసుకోండి, కొనండి లేదా మీ ఆస్తిని జాబితా చేయండి",
    "invalid_session": "చెల్లని సెషన్",
    "last_name": "చివరి పేరు",
    "last_name_required": "చివరి పేరు అవసరం",
    "list_properties": "ఆస్తులను జాబితా చేయండి",
    "login_failed": "లాగిన్ విఫలమైంది. దయచేసి మళ్ళీ ప్రయత్నించండి.",
    "login_here": "ఇక్కడ లాగిన్ అవ్వండి",
    "looking_for_properties": "ఆస్తుల కోసం చూస్తున్నాను",
    "or_continue_with": "లేదా దీనితో కొనసాగండి",
    "org_desc": "నేను రియల్ ఎస్టేట్ ప్రాజెక్టులను అభివృద్ధి చేస్తాను లేదా అమ్ముతాను",
    "organization_name": "బిల్డర్ పేరు",
    "organization_slug": "బిల్డర్ స్లగ్",
    "password": "పాస్‌వర్డ్",
    "password_complexity": "పాస్‌వర్డ్‌లో అప్పర్‌కేస్, లోయర్‌కేస్ మరియు ఒక సంఖ్య ఉండాలి",
    "password_min_length": "పాస్‌వర్డ్ తప్పనిసరిగా కనీసం 6 అక్షరాలను కలిగి ఉండాలి",
    "passwords_dont_match": "పాస్‌వర్డ్‌లు సరిపోలడం లేదు",
    "phone": {
      "code_placeholder": "123456",
      "description": "మేము మీ ఫోన్ నంబర్‌కు ఒకసారి ఉపయోగించే కోడ్‌ను పంపుతాము.",
      "errors": {
        "code_expired": "కోడ్ గడువు ముగిసింది. దయచేసి ధృవీకరణ కోడ్‌ను మళ్ళీ పంపండి.",
        "invalid_code": "చెల్లని ధృవీకరణ కోడ్. దయచేసి మళ్ళీ ప్రయత్నించండి.",
        "invalid_phone": "చెల్లని ఫోన్ నంబర్. దయచేసి E.164 ఫార్మాట్‌ను ఉపయోగించండి (ఉదా. +1 650-555-3434).",
        "missing_confirmation": "సమర్పణ స్థితి లేదు. దయచేసి కోడ్‌ను మళ్లీ పంపండి."
      },
      "format_hint": "E.164 ఫార్మాట్‌ను ఉపయోగించండి (+ తో మొదలవుతుంది).",
      "label": "ఫోన్ నంబర్",
      "localhost_note": "గమనిక: App Check ప్రారంభించబడిన/అమలు చేయబడినట్లయితే, లోకల్ హోస్ట్‌కు డీబగ్ టోకెన్ అవసరం. స్థానికంగా టెస్ట్ ఫోన్ నంబర్‌లను ఉపయోగించండి లేదా App Check డీబగ్ టోకెన్‌ను కాన్ఫిగర్ చేయండి.",
      "placeholder": "+1 650-555-3434",
      "send_code": "కోడ్‌ను పంపండి",
      "sending": "పంపుతోంది…",
      "title": "ఫోన్‌తో కొనసాగించండి",
      "verification_code": "ధృవీకరణ కోడ్",
      "verify_continue": "ధృవీకరించి కొనసాగించు",
      "verifying": "ధృవీకరిస్తోంది…"
    },
    "phone_number": "ఫోన్ నంబర్",
    "phone_session_expired": "మీ ఫోన్ ధృవీకరణ సెషన్ గడువు ముగిసింది. దయచేసి మళ్లి ప్రయత్నించండి.",
    "phone_verified": "ఫోన్ నంబర్ ధృవీకరించబడింది",
    "pm_desc": "నేను యజమానుల కోసం బహుళ ఆస్తులను నిర్వహిస్తాను",
    "privacy_policy": "గోప్యతా విధానం",
    "register": "నమోదు చేయండి",
    "register_btn": "ఖాతాను సృష్టించండి",
    "registering_as_builder": "బిల్డర్‌గా నమోదు చేసుకుంటున్నారు",
    "registering_as_individual": "మీ వ్యక్తిగత ఖాతా సృష్టించబడుతోంది",
    "registering_as_pm": "ప్రాపర్టీ మేనేజర్‌గా నమోదు చేసుకుంటున్నారు",
    "registration_failed": "నమోదు విఫలమైంది. దయచేసి మళ్లీ ప్రయత్నించండి.",
    "registration_failed_title": "నమోదు విఫలమైంది",
    "registration_success_desc": "మీ ఖాతా విజయవంతంగా సృష్టించబడింది, {{name}}!",
    "registration_success_message": "దాదాపు పూర్తయింది! మీ ఖాతాను సక్రియం చేయడానికి దయచేసి మీ ఇమెయిల్‌ను తనిఖీ చేసి, మీ చిరునామాను ధృవీకరించండి. మీరు ధృవీకరణ లింక్‌ను క్లిక్ చేసిన తర్వాత మాత్రమే మీ ఖాతా సృష్టించబడుతుంది.",
    "remember_me": "నన్ను గుర్తుంచుకో",
    "role_org_desc": "నేను రియల్ ఎస్టేట్ ప్రాజెక్టులను అభివృద్ధి చేస్తాను లేదా అమ్ముతాను",
    "role_pm_desc": "నేను యజమానుల కోసం అనేక ఆస్తులను నిర్వహిస్తాను",
    "search_country_or_code": "దేశం లేదా కోడ్ వెతుకోండి…",
    "select_billing_country": "మీ దేశాన్ని ఎంచుకోండి",
    "sign_in": "సైన్ ఇన్",
    "sign_in_link": "సైన్ ఇన్ చేయండి",
    "sign_in_subtitle": "కొనసాగడానికి మీ ఖాతాలోకి సైన్ ఇన్ చేయండి",
    "sign_up": "సైన్ అప్",
    "signing_in": "సైన్ ఇన్ అవుతోంది...",
    "start_free_trial": "ఈరోజే మీ ఉచిత ట్రయల్ ప్రారంభించండి",
    "start_trial": "ఈరోజే మీ ఉచిత ట్రయల్‌ను ప్రారంభించండి",
    "success_login_message": "మీరు ఈ ట్యాబ్‌ను మూసివేయవచ్చు లేదా",
    "tabs": {
      "organization": "బిల్డర్",
      "property_manager": "ఆస్తి నిర్వాహకుడు"
    },
    "terms_service": "సేవా నిబంధనలు",
    "try_suggestions": "ప్రయత్నించండి:",
    "username": "వినియోగదారు పేరు",
    "username_available": "వినియోగదారు పేరు అందుబాటులో ఉంది!",
    "username_min_length": "వినియోగదారు పేరు కనీసం 3 అక్షరాలు ఉండాలి",
    "username_taken": "యూజర్‌నేమ్ ఇప్పటికే ఉంది. వీటిలో ఒకదాన్ని ప్రయత్నించండి:",
    "valid_email": "దయచేసి సరైన ఇమెయిల్ చిరునామాను నమోదు చేయండి",
    "welcome_back": "తిరిగి స్వాగతం",
    "welcome_title": "LetMeIn కి స్వాగతం! 🎉",
    "work_city": "మీరు పని చేసే నగరం"
  },
  "auto_test": {
    "card_1": {
      "button": "అన్ని ఆస్తులను వీక్షించండి",
      "desc": "మీ ప్రాంతంలో అందుబాటులో ఉన్న ఆస్తులను బ్రౌజ్ చేయండి.",
      "title": "రియల్ ఎస్టేట్ జాబితాలు"
    },
    "card_2": {
      "button": "AI శోధనను ప్రారంభించండి",
      "desc": "సహజ భాషను ఉపయోగించి మీ కలల ఇంటిని కనుగొనండి.",
      "title": "స్మార్ట్ AI శోధన"
    },
    "card_3": {
      "button": "నోటిఫికేషన్‌లను ప్రారంభించండి",
      "desc": "కొత్త డీల్ మీ ప్రొఫైల్‌కు సరిపోలిన వెంటనే నోటిఫికేషన్‌లను పొందండి.",
      "title": "తక్షణ నోటిఫికేషన్‌లు"
    },
    "footer_message": "ఈ పేజీ 100% ఆటోమేటెడ్ అనువాద వర్క్‌ఫ్లోను పరీక్షించడానికి నిర్మించబడింది.",
    "page_subtitle": "సిస్టమ్ ఈ మొత్తం పేజీని ఎలా స్వయంచాలకంగా గుర్తిస్తుంది, సంగ్రహిస్తుంది మరియు అనువదిస్తుందో చూడండి.",
    "page_title": "AI అనువాద మాయాజాలం"
  },
  "automation_test": {
    "action_button": "ఆటోమేషన్ పరీక్ష చర్య బటన్",
    "description": "ఆటోమేషన్ పరీక్ష వివరణ",
    "title": "ఆటోమేషన్ పరీక్ష శీర్షిక"
  },
  "billing": {
    "add_credits": "క్రెడిట్‌లు జోడించండి",
    "amount": "మొత్తం",
    "balance": "బ్యాలెన్స్",
    "billing_country": "బిల్లింగ్ దేశం",
    "billing_locale": "బిల్లింగ్ & వాలెట్",
    "billing_locale_desc": "క్రెడిట్లు మరియు వాడక్ కోసం మీ బిల్లింగ్ దేశం మరియు వాలెట్ కరెన్సీ.",
    "country_currency_mismatch_note": "క్రెడిట్లు వేరే కరెన్సీలో ఇవ్వబడినప్పుడుతే, మీ వాలెట్ కరెన్సీ బిల్లింగ్ దేశం నుంచి వేరు కావచ్చు.",
    "date": "తేదీ",
    "description": "వివరణ",
    "est_cost": "అంచనా ఖర్చు",
    "last_days": "చివరి {{days}} రోజులు",
    "ledger_description": "ఇటీవలి క్రెడిట్ కదలికలు",
    "near_cap_warning": "మీరు మీ వినియోగ పరిమితికి దగ్గరగా ఉన్నారు.",
    "no_transactions": "ఇంకా లావాదేవీలు లేవు.",
    "no_usage": "వినియోగ డేటా లేదు",
    "over_cap_warning": "మీరు మీ వినియోగ పరిమితికి చేరుకున్నారు. తదుపరి కాలం వరకు తదుపరి ఛార్జీలు నిరోధించబడవచ్చు.",
    "showing_range": "{{total}}లో {{from}}–{{to}} చూపిస్తోంది",
    "topup_success": "క్రెడిట్‌లు విజయవంతంగా జోడించబడ్డాయి. మీ బ్యాలెన్స్ అప్‌డేట్ అయింది.",
    "total_calls": "మొత్తం కాల్స్",
    "total_cost": "మొత్తం ఖర్చు",
    "total_tokens": "మొత్తం టోకెన్లు",
    "transaction_history": "లావాదేవీల చరిత్ర",
    "type": "రకం",
    "upgrade_plan": "ప్లాన్‌ను అప్‌గ్రేడ్ చేయండి",
    "usage_cap": "వినియోగ పరిమితి",
    "usage_cap_description": "మీ ప్లాన్ నుండి ప్రస్తుత కాలానికి ఖర్చు పరిమితి.",
    "usage_description": "మీ క్రెడిట్‌ల బ్యాలెన్స్, API వినియోగం మరియు లావాదేవీల చరిత్రను వీక్షించండి.",
    "usage_this_period": "ఈ కాలానికి వినియోగం",
    "usage_title": "వినియోగం & బిల్లింగ్",
    "used_this_period": "ఈ కాలంలో ఉపయోగించబడింది",
    "wallet_currency": "వాలెట్ కరెన్సీ"
  },
  "brokerage": {
    "actions": {
      "accept": "అంగీకరించు",
      "cancel_invite": "ఆహ్వానాన్ని రద్దు చేయండి",
      "decline": "తిరస్కరించు",
      "revoke_access": "యాక్సెస్ రద్దు చేయండి",
      "view_building": "భవనాన్ని వీక్షించండి"
    },
    "description": "మీ పోర్ట్‌ఫోలియో అంతటా ఆస్తి కేటాయింపులు, వృత్తిపరమైన కనెక్షన్‌లు మరియు కార్యకలాపాలను నిర్వహించండి.",
    "empty_states": {
      "invitations_desc": "ఇన్‌కమింగ్ మరియు అవుట్‌గోయింగ్ అభ్యర్థనలు ఇక్కడ కనిపిస్తాయి.",
      "no_active": "ఇంకా క్రియాశీల కేటాయింపులు లేవు.",
      "no_invitations": "ప్రస్తుతానికి పెండింగ్‌లో ఉన్న ఆహ్వానాలు లేవు."
    },
    "invite_manager": "మేనేజర్‌ను ఆహ్వానించండి",
    "labels": {
      "full_access": "పూర్తి కార్యాచరణ యాక్సెస్",
      "incoming": "లోపలికి వచ్చేవి",
      "invited_manager": "ఆహ్వానించినది: {{manager}}",
      "managed_by": "దీనిచే నిర్వహించబడుతుంది:",
      "manager_fallback": "మేనేజర్",
      "outgoing": "బయటకు వెళ్లేవి",
      "owner": "యజమాని:",
      "owner_fallback": "యజమాని",
      "property_fallback": "ఆస్తి",
      "requested_perms": "అభ్యర్థించిన అనుమతులు:"
    },
    "messages": {
      "status_update_failed": "ఆహ్వానాన్ని అప్‌డేట్ చేయడంలో విఫలమైంది",
      "status_updated": "స్థితి నవీకరించబడింది"
    },
    "modals": {
      "choose_manager": "-- ఒక మేనేజర్‌ను ఎంచుకోండి --",
      "choose_property": "-- ఆస్తిని ఎంచుకోండి --",
      "default_permissions": "డిఫాల్ట్ అనుమతులు",
      "invite_desc": "మీ ఆస్తిని ఒక ప్రొఫెషనల్ బ్రోకర్‌తో కనెక్ట్ చేయండి.",
      "invite_failed": "ఆహ్వానం పంపడంలో విఫలమైంది",
      "invite_success": "ఆహ్వానం విజయవంతంగా పంపబడింది!",
      "invite_title": "ఆస్తి మేనేజర్‌ను ఆహ్వానించండి",
      "no_managers": "సిస్టమ్‌లో ఇంకా ఆస్తి నిర్వాహకులు కనుగొనబడలేదు.",
      "permissions_note": "నిర్వాహకులు రోజువారీ కార్యకలాపాలను వీక్షించవచ్చు మరియు నిర్వహించవచ్చు కానీ ఆస్తిని తొలగించలేరు.",
      "select_manager": "ప్రాపర్టీ మేనేజర్‌ను ఎంచుకోండి",
      "select_property": "ఆస్తిని ఎంచుకోండి",
      "send_invitation": "ఆహ్వానాన్ని పంపండి",
      "sending": "పంపుతోంది..."
    },
    "permissions": {
      "edit_details": "వివరాలు సవరించు",
      "manage_tenants": "టెనెంట్లను నిర్వహించు",
      "send_alerts": "అలర్ట్లు పంపు"
    },
    "status": {
      "active": "యాక్టివ్",
      "managed": "నిర్వహించబడింది",
      "pending": "పెండింగ్‌లో ఉంది",
      "rejected": "తిరస్కరించబడింది",
      "revoked": "రద్దు చేయబడింది"
    },
    "tabs": {
      "active_portfolio": "క్రియాశీల పోర్ట్‌ఫోలియో",
      "invitations": "ఆహ్వానాలు",
      "maintenance": "నిర్వహణ"
    },
    "title": "బ్రోకరేజ్ & అధికారికీకరణ"
  },
  "buttons": {
    "submit": "సమర్పించు"
  },
  "chat": {
    "add_credits": "క్రెడిట్‌లను జోడించండి",
    "assistant_status": "మీ తదుపరి ఇంటిని కనుగొనడానికి సిద్ధంగా ఉన్నాను",
    "assistant_title": "AI ప్రాపర్టీ అసిస్టెంట్",
    "error_generic": "క్షమించండి, లోపం సంభవించింది. దయచేసి మళ్ళీ ప్రయత్నించండి.",
    "error_voice": "క్షమించండి, మీ వాయిస్ ఇన్‌పుట్‌ను ప్రాసెస్ చేయడంలో నాకు సమస్య ఎదురైంది.",
    "greeting": "నమస్కారం! మీ సరైన ఆస్తిని కనుగొనడంలో మీకు సహాయం చేయడానికి నేను ఇక్కడ ఉన్నాను. మీరు ఏమి వెతుకుతున్నారో నాకు చెప్పండి - రకం, స్థానం, బడ్జెట్, సౌకర్యాలు లేదా ఏదైనా నిర్దిష్ట అవసరాలు.",
    "guest_limit_reached": "ఇల్లా ఉచిత ఉచిత ఆస్తి శోధన పరిమితిని చేరుకున్నారు. మరిన్ని శోధనల కోసం నమోదు లేదా సైన్ ఇన్ చేయండి.",
    "guest_limit_reached_mid": "లేదా",
    "guest_limit_reached_prefix": "మీరు నేటి ఉచిత సెర్చ్ పరిమితిని చేరుకున్నారు.",
    "guest_limit_reached_suffix": "మరిన్ని సెర్చ్‌ల కోసం నమోదు చేయండి లేదా సైన్ ఇన్ చేయండి లేదా రేపు మళ్ళీ ప్రయత్నించండి.",
    "history_title": "సంభాషణ చరిత్ర",
    "image_alert_size": "చిత్రం 10 MB లోపు ఉండాలి.",
    "image_alert_type": "దయచేసి JPEG, PNG లేదా WebP చిత్రాన్ని ఎంచుకోండి.",
    "image_input_placeholder": "స్థాన సందర్భాన్ని జోడించండి ఉదా. \"గచ్చిబౌలి సమీపంలో\" (ఐచ్ఛికం)...",
    "image_search_badge": "ఇమేజ్ సెర్చ్",
    "image_search_failed_generic": "చిత్ర శోధన విఫలమైంది. దయచేసి మళ్లి ప్రయత్నించండి.",
    "image_search_label": "🔍 ఇమేజ్ సెర్చ్",
    "input_placeholder": "మీ సందేశాన్ని ఇక్కడ టైప్ చేయండి...",
    "insufficient_balance": "మీ క్రెడిట్ బ్యాలన్స్ అయిపోయింది. కొనసాగించడానికి క్రెడిట్లు జోడండి.",
    "insufficient_balance_prefix": "మీ క్రెడిట్ బ్యాలెన్స్ అయిపోయింది.",
    "insufficient_balance_suffix": "కొనసాగించడానికి.",
    "location_dialog": {
      "description": "మీ కోసం ఉత్తమమైన ప్రాపర్టీలను కనుగొనడానికి, మీరు ఏ నగరంపై ఆసక్తి కలిగి ఉన్నారో మేము తెలుసుకోవాలి.",
      "footer": "మీ ప్రాంతంలో ఖచ్చితమైన మ్యాచ్‌లను కనుగొనడంలో మీ స్థానం మా AIకి సహాయపడుతుంది.",
      "title": "స్థానం అవసరం"
    },
    "may_take_a_while": "ఇది కొంత సమయం పట్టవచ్చు...",
    "my_location_unavailable": "మీ ప్రస్తుత లోకేషన్ ప్రాప్తం కాలేదు. బ్రౌజర్లో లోకేషన్ అనుమతి ప్రారంభించి మళ్లి ప్రయత్నించండి.",
    "new_chat": "కొత్త చాట్",
    "new_search": "కొత్త శోధన",
    "posting_greeting": "నమస్కారం! ఆస్తి లిస్ట్ చేయడానికి సహాయం చేస్తాను. పిన్‌కోడ్ లేదా పూర్తి చిరునామా ఉత్తమం — లేదా రకం, ప్రాంతం/నగరం, ధర, ఫోటోలు చెప్పండి.",
    "processing_details": "వివరాలు ప్రాసెస్ చేయబడుతున్నాయి…",
    "register": "నమోదు",
    "search": "శోధించు",
    "search_by_image": "చిత్రంతో శోధించు",
    "search_by_image_title": "చిత్రంతో శోధించు",
    "search_conversations": "సంభాషణాలను వెతుకోండి…",
    "search_image": "చిత్రాన్ని శోధించు",
    "setting_up": "తదుపరి దశ సిద్ధమవుతోంది…",
    "sign_in": "సైన్ ఇన్",
    "voice_label": "వాయిస్",
    "wait_for_moment": "దయచేసి కాసేపు వేచి ఉండండి..."
  },
  "checkout_page": {
    "actions": {
      "back_to_plans": "ప్లాన్స్‌కి తిరిగి వెళ్ళండి",
      "pay_amount": "{{amount}} చెల్లించండి",
      "processing": "ప్రాసెస్ అవుతోంది..."
    },
    "error_state": {
      "title": "చెకౌట్ లోపం"
    },
    "errors": {
      "init_failed": "చెల్లింపును ప్రారంభించడంలో విఫలమైంది",
      "missing_plan": "ప్లాన్ సమాచారం లేదు",
      "payment_failed": "చెల్లింపు విఫలమైంది",
      "subscription_create_failed": "చెల్లింపు విజయవంతమైంది కానీ సబ్‌స్క్రిప్షన్ సృష్టి విఫలమైంది. దయచేసి సపోర్ట్‌ని సంప్రదించండి."
    },
    "loading": {
      "preparing": "చెకౌట్ సిద్ధం అవుతోంది..."
    },
    "order_summary": {
      "billing": "బిల్లింగ్:",
      "billing_fallback": "మాసిక",
      "plan": "ప్లాన్:",
      "plan_fallback": "ప్లాన్",
      "selected_plan": "ఎంచుకున్న ప్లాన్",
      "title": "ఆర్డర్ సారాంశం",
      "total": "మొత్తం:"
    },
    "subtitle": "మీ సబ్‌స్క్రిప్షన్‌ను పూర్తి చేయడానికి చెల్లింపు వివరాలు నమోదు చేయండి",
    "title": "మీ చెల్లింపును పూర్తి చేయండి"
  },
  "common": {
    "actions": "చర్యలు",
    "activate": "సక్రియం చేయండి",
    "active": "క్రియాశీల",
    "add": "జోడించు",
    "app_notifications": "యాప్‌లో హెచ్చరికలు",
    "back": "వెనక్కి",
    "cancel": "రద్దు చేయి",
    "checking": "తనిఖీ చేస్తోంది…",
    "close": "కార్యకలాపాల విండోను మూసివేయండి",
    "confirm": "నిర్ధారించండి",
    "continue": "కొనసాగించు",
    "date": "తేదీ",
    "days": "రోజులు",
    "deactivate": "నిష్క్రియం చేయండి",
    "delete": "తొలగించు",
    "done": "పూర్తి",
    "edit": "సవరించు",
    "email": "ఇమెయిల్ చిరునామా",
    "email_notifications": "ఇమెయిల్ హెచ్చరికలు",
    "error_fetch_data": "బ్రోకరేజ్ డేటాను లోడ్ చేయడంలో విఫలమైంది",
    "error_occurred": "లోపం జరిగింది",
    "filter": "ఫిల్టర్",
    "filter_all": "అన్నీ",
    "first_name": "మొదటి పేరు",
    "generating": "సృష్టిస్తోంది...",
    "go_back": "వెనక్కి వెళ్ళు",
    "id": "ఐడి",
    "inactive": "నిష్క్రియ",
    "is_required": "అవసరం",
    "language": "ఇష్టపడే భాష",
    "last_name": "చివరి పేరు",
    "live": "ప్రత్యక్షంగా",
    "load": "లోడ్ చేయండి",
    "loading": "లోడ్ అవుతోంది...",
    "loading_dashboard": "డాష్‌బోర్డ్ లోడ్ అవుతోంది...",
    "mark_unverified": "ధృవీకరణ తీసియడానికి క్లిక్ చేయండి",
    "mark_verified": "ధృవీకరించడానికి క్లిక్ చేయండి",
    "menu": "మెనూ",
    "next": "తదుపరి",
    "no": "కాదు",
    "no_results_desc": "ఆస్తులు కనుగొనబడలేదు. వేరే శోధనను ప్రయత్నించండి.",
    "no_results_found": "ఫలితాలు కనుగొనబడలేదు",
    "not_available": "—",
    "off": "ఆఫ్",
    "on": "ఆన్",
    "organization": "సంస్థ",
    "pending": "పెండింగ్",
    "phone": "ఫోన్ నంబర్",
    "previous": "మునుపటి",
    "properties_found": "ఆస్తులు కనుగొనబడ్డాయి",
    "refresh": "తాజా",
    "remove": "తొలగించు",
    "required_fields": "అవసర ఫీల్డ్లు",
    "results": "ఫలితాలను చూడండి",
    "retry": "మళ్లి ప్రయత్నించండి",
    "role": "ప్రాథమిక పాత్ర",
    "save": "సేవ్ చేయండి",
    "save_changes": "మార్పులను సేవ్ చేయండి",
    "saving": "సేవ్ అవుతోంది...",
    "search": "ఆస్తులను శోధించండి",
    "search_results": "శోధన ఫలితాలు",
    "searching_properties": "ప్రాపర్టీల కోసం వెతుకుతోంది...",
    "select": "",
    "select_all_that_apply": "",
    "send": "పంపండి",
    "share": "షేర్ చేయండి",
    "skip": "",
    "status": "స్థితి",
    "statuses": {
      "completed": "పూర్తయింది",
      "error": "లోపం",
      "failed": "విఫలమైంది",
      "healthy": "ఆరోగ్యమైనది",
      "not_checked": "తనిఖి లేదు",
      "pending": "పెండింగ్‌లో ఉంది",
      "unconfigured": "కాన్ఫిగర్ కాలేదు"
    },
    "submit": "",
    "system": "సిస్టమ్",
    "translating": "అనువదిస్తోంది...",
    "try_again": "మళ్లీ ప్రయత్నించండి",
    "type": "రకం",
    "update": "అప్‌డేట్",
    "username": "వినియోగదారు పేరు",
    "verified": "ఇమెయిల్ ధృవీకరణ",
    "view": "చూడండి",
    "yes": "అవును"
  },
  "compare_page": {
    "actions": {
      "browse_properties": "",
      "retry_search": ""
    },
    "empty": {
      "add_one_more": "",
      "no_base_hint": "",
      "no_base_selected": "",
      "no_recent_or_suggested": "",
      "no_search_results": "",
      "use_search_panels": ""
    },
    "errors": {
      "base_load_failed": "",
      "base_unavailable": "",
      "search_failed": "",
      "suggestions_load_failed": ""
    },
    "labels": {
      "base_property": "",
      "last_viewed": "",
      "property_n": "",
      "suggested_properties": ""
    },
    "loading": {
      "page": "",
      "suggestions": ""
    },
    "search": {
      "placeholder": ""
    },
    "side_by_side_title": "",
    "table": {
      "amenities": "",
      "bathrooms": "",
      "bedrooms": "",
      "built_up_area": "",
      "floor": "",
      "furnishing": "ఫర్నిషింగ్",
      "location": "",
      "price": "",
      "status": "",
      "type": ""
    },
    "title": ""
  },
  "contact_page": {
    "desc": "మా AI-ఆధారిత రియల్ ఎస్టేట్ ప్లాట్‌ఫారమ్ గురించి ప్రశ్నలు ఉన్నాయా? మేము సహాయం చేయడానికి సిద్ధంగా ఉన్నాము.",
    "form_card": {
      "email": "ఇమెయిల్",
      "error_failed": "సందేశం పంపడంలో విఫలమైంది. దయచేసి తర్వాత మళ్లీ ప్రయత్నించండి.",
      "error_fields": "దయచేసి అవసరమైన అన్ని ఖాళీలను పూరించండి",
      "first_name": "మొదటి పేరు",
      "last_name": "చివరి పేరు",
      "message": "సందేశం",
      "placeholder_email": "john@example.com",
      "placeholder_first_name": "జాన్",
      "placeholder_last_name": "డో",
      "placeholder_message": "మీ సందేశాన్ని ఇక్కడ టైప్ చేయండి...",
      "placeholder_subject": "మేము మీకు ఎలా సహాయపడగలము?",
      "subject": "విషయం",
      "submit_btn": "సందేశాన్ని పంపండి",
      "submitting_btn": "పంపిస్తోంది...",
      "success_msg": "మీ సందేశం విజయవంతంగా పంపబడింది!",
      "title": "మాకు సందేశం పంపండి"
    },
    "info_card": {
      "call_schedule": "సోమ-శుక్ర ఉదయం 9 నుండి సాయంత్రం 6 వరకు",
      "call_title": "మాకు కాల్ చేయండి",
      "email_title": "మాకు ఇమెయిల్ చేయండి",
      "title": "సంప్రదింపు సమాచారం",
      "visit_address": "టెక్ హబ్, హైటెక్ సిటీ<br />హైదరాబాద్, తెలంగాణ 500081<br />భారతదేశం",
      "visit_title": "మమ్మల్ని సందర్శించండి"
    },
    "title": "మమ్మల్ని సంప్రదించండి"
  },
  "currency": {
    "cr": "కోట్లు",
    "lakhs": "లక్షలు"
  },
  "dashboard": {
    "aadhaar_reminder": {
      "cta": "ఇప్పుడే ధృవీకరించండి",
      "description": "లిస్టింగ్‌లు మరియు అద్దెదారు పరస్పర చర్యలపై నమ్మకం పెంచడానికి ఆధార్ ధృవీకరణ పూర్తి చేయండి.",
      "dismiss": "రిమైండర్ తొలగించు",
      "title": "ఆధార్‌తో మీ గుర్తింపును ధృవీకరించండి"
    },
    "admin_desc": "సిస్టమ్ విశ్లేషణలు మరియు నిర్వహణ యొక్క అవలోకనం.",
    "admin_title": "అడ్మిన్ డాష్‌బోర్డ్",
    "find_home_desc": "మీ తదుపరి ఇంటిని కనుగొనడానికి సిద్ధంగా ఉన్నారా?",
    "find_home_title": "AI శోధన",
    "merged_desc": "ఇళ్లు వెతకండి, మీ లిస్టింగ్‌లను నిర్వహించండి మరియు అన్నీ ఒకే చోట ట్రాక్ చేయండి.",
    "org_desc": "మీ సంస్థ మరియు సభ్యుల కార్యకలాపాలను నిర్వహించండి.",
    "org_title": "సంస్థ డాష్‌బోర్డ్",
    "own_property_desc": "మీ ఆస్తి లిస్టింగ్ పోస్ట్ చేసి యజమాని ఖాతాకు మారండి — మా AI దీన్ని వేగంగా మరియు సులభంగా చేస్తుంది.",
    "own_property_title": "మీకు ఆస్తి ఉందా?",
    "owner_dashboard_title": "యజమాని డ్యాష్‌బోర్డ్",
    "pm_desc": "మీ ప్రాపర్టీలను మరియు అద్దెదారుల సంభాషణలను ట్రాక్ చేయండి.",
    "pm_title": "ఆస్తి నిర్వాహక డాష్‌బోర్డ్",
    "post_my_property": "నా ఆస్తిని పోస్ట్ చేయండి",
    "recent_searches_desc": "మీ చివరి AI శోధన నుండి ఆస్తులు",
    "recent_searches_title": "ఇటీవలి శోధనలు",
    "start_ai_search": "AI శోధనను ప్రారంభించండి",
    "tenant_dashboard_title": "అద్దెదారు డ్యాష్‌బోర్డ్",
    "tenant_desc": "ఈరోజు మీ ఖాతాలో ఏమి జరుగుతుందో ఇక్కడ ఉంది.",
    "welcome_back": "తిరిగి స్వాగతం, {{name}}"
  },
  "dashboard_page": {
    "title": "డాష్‌బోర్డ్",
    "welcome": "మీ డాష్‌బోర్డ్‌కు స్వాగతం."
  },
  "deleteUser": {
    "adminWarningDesc": "మీరు అడ్మినిస్ట్రేటివ్ ఖాతాను తొలగించబోతున్నారు. ఈ చర్యకు అదనపు నిర్ధారణ అవసరం మరియు సిస్టమ్‌పై గణనీయమైన ప్రభావం చూపుతుంది.",
    "adminWarningTitle": "అధిక-ప్రత్యేక హక్కుల ఖాతా",
    "cancel": "వినియోగదారు రద్దును తొలగించు",
    "confirmMessage": "వినియోగదారు నిర్ధారణ సందేశాన్ని తొలగించు",
    "deactivate": "యూజర్‌ను తొలగించు - నిష్క్రియం చేయండి",
    "deleteButton": "యూజర్ తొలగింపు బటన్",
    "deleting": "యూజర్‌ను తొలగిస్తున్నారు",
    "errorGeneric": "వినియోగదారుని తొలగించడంలో విఫలమైంది. దయచేసి మీ అనుమతులను తనిఖీ చేయండి.",
    "hardDelete": {
      "description": "యూజర్‌ను శాశ్వతంగా తొలగించు - వివరణ",
      "title": "యూజర్‌ను శాశ్వతంగా తొలగించు - శీర్షిక"
    },
    "permanent": "యూజర్‌ను శాశ్వతంగా తొలగించు",
    "softDelete": {
      "description": "యూజర్‌ను తాత్కాలికంగా తొలగించు - వివరణ",
      "title": "యూజర్‌ను తాత్కాలికంగా తొలగించు - శీర్షిక"
    },
    "title": "యూజర్‌ను తొలగించు - శీర్షిక"
  },
  "demo": {
    "auto_test_all": "ఈ కీ ఆటోమేటిక్‌గా ఇంగ్లీష్, హిందీ మరియు తెలుగులో కనిపించాలి!",
    "buttons": {
      "later": "తర్వాత ప్రయత్నించండి",
      "start": "ప్రారంభించండి"
    },
    "descriptions": {
      "main": "i18next-parser ఎలా పనిచేస్తుందో చూపించడానికి ఈ కాంపోనెంట్ ఉపయోగించబడుతుంది."
    },
    "footer": {
      "info": {
        "v1": "డెమో వెర్షన్ 1.0.0"
      }
    },
    "trans_demo": "మీరు అనువాదాలలో <1>HTML ట్యాగ్‌లను</1> కూడా ఉపయోగించవచ్చు!",
    "welcome_title": "డెమోకు స్వాగతం"
  },
  "example": {
    "description": "ఉదాహరణ వివరణ",
    "title": "ఉదాహరణ శీర్షిక",
    "trans_component": "ఉదాహరణ అనువాద భాగం"
  },
  "favourites_page": {
    "empty_desc": "ఆస్తులను అన్వేషించడం ప్రారంభించి ఇక్కడ మీ ఇష్టాలను సేవ్ చేయండి!",
    "empty_title": "ఇంకా ఇష్టాలు లేవు",
    "load_failed": "ఇష్టాలు లోడ్ చేయడం విఫలమైంది",
    "loading": "మీ ఇష్టాలు లోడ్ అవుతున్నాయి...",
    "showing_one_one": "",
    "showing_one_other": "",
    "showing_other_one": "",
    "showing_other_other": "",
    "subtitle": "మీరు ఇష్టపడి తర్వాత కోసం సేవ్ చేసిన ఆస్తులు",
    "title": "నా ఇష్టాలు"
  },
  "features_page": {
    "badge": "ప్లాట్‌ఫారమ్ ఫీచర్లు",
    "create_account_btn": "ఉచిత ఖాతాను సృష్టించండి",
    "cta_quote": "\"నేను ఉపయోగించిన అత్యంత అధునాతన ఆస్తి శోధన ప్లాట్‌ఫారమ్. ఇది నాకు ఏమి కావాలో నిజంగా అర్థం చేసుకుంటుంది.\"",
    "cta_title": "AIతో మీ తదుపరి <1/>ఇంటిని కనుగొనడానికి సిద్ధంగా ఉన్నారా?",
    "features": {
      "conversational_ui": "సంభాషణాత్మక UI",
      "conversational_ui_desc": "మా చాట్ ఇంటర్‌ఫేస్ ద్వారా మీరు ప్రొఫెషనల్ రియల్ ఎస్టేట్ ఏజెంట్‌తో మాట్లాడుతున్నట్లే ప్లాట్‌ఫారమ్‌తో సంభాషించండి.",
      "instant_translation": "తక్షణ అనువాదం",
      "instant_translation_desc": "ప్లాట్‌ఫారమ్ అంతటా ఇంగ్లీష్, హిందీ మరియు తెలుగులో నిజ-సమయ అనువాదంతో అనర్గళంగా సంభాషించండి.",
      "intelligent_matching": "ఇంటెలిజెంట్ మ్యాచింగ్",
      "intelligent_matching_desc": "మీ జీవనశైలికి సరిపోయే ఆస్తులను సూచించడానికి మా AI కాలక్రమేణా మీ ప్రాధాన్యతలను నేర్చుకుంటుంది.",
      "market_insights": "మార్కెట్ అంతర్దృష్టులు",
      "market_insights_desc": "AI విశ్లేషణతో స్థానిక మార్కెట్ పోకడలు, ధరల చరిత్ర మరియు పరిసర ప్రాంత అభివృద్ధిపై లోతైన డేటాను పొందండి.",
      "multilingual_support": "బహుభాషా మద్దతు",
      "multilingual_support_desc": "మీకు ఇష్టమైన భాషలో ప్లాట్‌ఫారమ్‌ను ఉపయోగించండి. ఇంగ్లీష్, హిందీ మరియు తెలుగుకు పూర్తి మద్దతు ఉంది.",
      "owner_dashboard": "యజమాని డాష్‌బోర్డ్",
      "owner_dashboard_desc": "జాబితాలను నిర్వహించడానికి, లీడ్స్‌ను ట్రాక్ చేయడానికి మరియు కమ్యూనికేషన్‌ను సులభంగా నిర్వహించడానికి ఆస్తి యజమానుల కోసం శక్తివంతమైన సాధనాలు.",
      "smart_ai_search": "స్మార్ట్ AI సెర్చ్",
      "smart_ai_search_desc": "సహజ భాషా ప్రశ్నలను ఉపయోగించి ఆస్తులను వెతకండి. ఇకపై సంక్లిష్టమైన ఫిల్టర్లు లేదా సాంకేతిక పదజాలం అవసరం లేదు.",
      "verified_listings": "ధృవీకరించబడిన జాబితాలు",
      "verified_listings_desc": "100% భద్రత మరియు విశ్వసనీయతను నిర్ధారించడానికి ప్రతి జాబితా మా AI మరియు కమ్యూనిటీ తనిఖీల ద్వారా కఠినంగా ధృవీకరించబడుతుంది.",
      "virtual_tours": "వర్చువల్ టూర్స్",
      "virtual_tours_desc": "AI-మెరుగైన ఫోటోగ్రఫీతో మీ ఇంటి నుండే ఆస్తులను అన్వేషించండి.",
      "voice_search": "వాయిస్ సెర్చ్",
      "voice_search_desc": "మీ వాయిస్‌తో ఆస్తుల కోసం వెతకండి. మా AI అనేక భాషలలో సహజమైన మాటలను అర్థం చేసుకుంటుంది."
    },
    "hero_desc": "మీ సెర్చ్ నుండి మూవింగ్ ఇన్ వరకు ప్రయాణాన్ని సులభతరం చేయడానికి రూపొందించబడిన మా సమగ్ర AI సాధనాలతో రియల్ ఎస్టేట్ భవిష్యత్తును అనుభవించండి.",
    "hero_title": "ప్రతి <1/>ప్రాపర్టీ సెర్చ్‌లోనూ ఇంటెలిజెన్స్",
    "try_ai_btn": "ఇప్పుడే AI సెర్చ్‌ని ప్రయత్నించండి",
    "view_pricing_btn": "ధరలను చూడండి"
  },
  "gemini_listing": {
    "badge_draft": "డ్రాఫ్ట్",
    "badge_live": "లైవ్",
    "collapse_sidebar": "సైడ్‌బార్ మూసివేయి",
    "hero": "ఈరోజు మీరు ఏ ఆస్తిని లిస్ట్ చేస్తున్నారు?",
    "hero_hint": "సాధ్యమైతే ముందుగా పిన్‌కోడ్ లేదా చిరునామా చెప్పండి; లేకపోతే రకం, ప్రాంతం, నగరం, ధర, ఫోటోలు లేదా PG/వాణిజ్య వివరాలు — మీరు చాట్ చేస్తున్నప్పుడు ప్రివ్యూ అప్‌డేట్ అవుతుంది.",
    "list_new_property": "కొత్త ప్రాపర్టీని జాబితా చేయండి",
    "location_pick_catalog_hint": "మీ ఎనేబుల్ చేసిన స్థానాల నుండి — ఒకదాన్ని ఎంచుకోండి, సంఖ్య టైప్ చేయండి, లేదా సరిపోలకపోతే మ్యాప్‌లో శోధించండి.",
    "location_pick_choose_city_hint": "పలు నగరాలు సరిపోతున్నాయి — ముందుగా మీ నగరాన్ని ఎంచుకోండి, తర్వాత మీరు మీ ప్రాంతాన్ని ఎంచుకుంటారు.",
    "location_pick_cities_heading": "మీ నగరాన్ని ఎంచుకోండి",
    "location_pick_decline": "ఇవి ఏవీ కావు — మ్యాప్‌లో శోధించండి",
    "location_pick_decline_user": "ఇవి ఏవీ కావు — మ్యాప్‌లో శోధించండి",
    "location_pick_kind_city": "నగరం",
    "location_pick_kind_locality": "ప్రాంతం",
    "location_pick_localities_heading": "లోక్యాలిటీలు / పొరుగుడులు",
    "location_pick_localities_in_metro": "{{metro}} లో ప్రాంతాలు",
    "location_pick_map_hint": "మ్యాప్ మ్యాచ్‌లు — ఒకదాన్ని ఎంచుకోండి లేదా సంఖ్య టైప్ చేయండి.",
    "location_pick_matching_cities": "సరిపోయిన నగరాలు: {{cities}}",
    "location_pick_next": "మరిన్ని లోడ్ చేయండి",
    "location_pick_next_user": "మరిన్ని లోక్యాలిటీలు లోడ్ చేయండి",
    "location_pick_page_num": "పేజీ {{page}} / {{pages}}",
    "location_pick_page_range": "{{total}}లో {{start}}–{{end}} లోక్యాలిటీలు",
    "location_pick_prev": "ముందటి",
    "location_pick_prev_user": "ముందటి లోక్యాలిటీలు",
    "nav_menu": "మెనూ",
    "no_listings_yet": "ఇంకా డ్రాఫ్ట్‌లు లేదా లిస్టింగ్‌లు లేవు. ఒకటి సృష్టించడానికి చాట్ ప్రారంభించండి.",
    "open_preview": "ప్రీవ్యూ",
    "placeholder": "మీ ఆస్తి వివరాలను తెలియజేయండి (రకం, ప్రాంతం, ధర, పరిమాణం) లేదా పిన్‌కోడ్/చిరునామా నమోదు చేయండి…",
    "publishing_splash_subtitle": "వివరాలను ఖరారు చేస్తూ మీ లైవ్ పేజీని సిద్ధం చేస్తున్నాము…",
    "publishing_splash_title": "మీ ప్రాపర్టీ లిస్టింగ్ సమర్పించబడుతోంది...",
    "recent_listings": "ఇటీవలి లిస్టింగ్‌లు",
    "sidebar_title": "నా లిస్టింగ్లు",
    "untitled_published": "లిస్ట్ చేసిన ప్రాపర్టీ"
  },
  "genui_playground": {
    "area_details_confirmed": "",
    "documents_uploaded_message": "నేను {{count}} డాక్యుమెంట్{{suffix}} అప్‌లోడ్ చేశాను",
    "error_connecting_backend": "❌ GenUI బ్యాకెండ్‌కు కనెక్ట్ అవ్వడంలో లోపం.",
    "images_uploaded_message": "నేను {{count}} చిత్రం{{suffix}} అప్‌లోడ్ చేశాను",
    "maintenance_confirmed": "నిర్వహణ: {{amount}} ({{frequency}})",
    "maintenance_included": "నిర్వహణ చేర్చబడింది",
    "pg_available_from": "",
    "pg_common_amenities_selected": "",
    "pg_common_amenities_skip": "",
    "pg_detail_beds_per_room_one": "",
    "pg_detail_beds_per_room_other": "",
    "pg_detail_deposit": "",
    "pg_detail_rent": "",
    "pg_detail_rooms_one": "",
    "pg_detail_rooms_other": "",
    "pg_food_no": "",
    "pg_food_yes": "",
    "pg_food_yes_meals": "",
    "pg_gate_closing_none": "",
    "pg_gate_closing_set": "",
    "pg_present_in_selected": "",
    "pg_room_facilities_selected": "",
    "pg_room_facilities_skip": "",
    "pg_rules_selected": "",
    "pg_rules_skip": "",
    "pg_services_confirmed": "",
    "pg_sharing_types_selected": "",
    "pg_tenant_preference": "",
    "pg_usp_added": "",
    "pg_usp_skip": "",
    "preferred_tenants_selected": "ప్రాధాన్య అద్దెదారులు: {{list}}",
    "preferred_tenants_skip": "ప్రాధాన్య అద్దెదారులు: ఏవీ లేవు",
    "title": "GenUI ప్లేగ్రౌండ్"
  },
  "genui_widgets": {
    "age_of_construction": {
      "options": {
        "10_to_15_years": "10 నుండి 15 సంవత్సరాలు",
        "15_to_20_years": "15 నుండి 20 సంవత్సరాలు",
        "5_to_10_years": "5 నుండి 10 సంవత్సరాలు",
        "above_20_years": "20 సంవత్సరాలకు పైగా",
        "less_than_5_years": "5 సంవత్సరాల కంటే తక్కువ",
        "new_construction": "కొత్త నిర్మాణం",
        "not_available": "",
        "single_phase": "",
        "three_phase": ""
      },
      "placeholder": "ఎంచుకోండి",
      "title": "నిర్మాణ వయస్సు"
    },
    "amenities": {
      "add_your_own": "మీది జోడించండి",
      "confirm": "ఎంపికను నిర్ధారించండి",
      "custom_placeholder": "ఉదా. రూఫ్ టెర్రస్...",
      "items": {
        "balcony": "బాల్కనీ",
        "children_play_area": "పిల్లల ఆట ప్రాంగణం",
        "clubhouse": "క్లబ్‌హౌస్",
        "garden": "తోట",
        "gas_pipeline": "గ్యాస్ పైప్‌లైన్",
        "gymnasium": "జిమ్",
        "internet_wifi": "ఇంటర్నెట్/Wi-Fi",
        "lift": "లిఫ్ట్",
        "maintenance_staff": "నిర్వహణ సిబ్బంది",
        "park": "పార్క్",
        "parking": "పార్కింగ్",
        "power_backup": "విద్యుత్ బ్యాకప్",
        "rain_water_harvesting": "వర్షపు నీటి సంరక్షణ",
        "reserved_parking": "రిజర్వ్ పార్కింగ్",
        "security_24x7": "24x7 భద్రత",
        "swimming_pool": "ఈత కొలను",
        "visitor_parking": "సందర్శకుల పార్కింగ్",
        "water_storage": "నీటి నిల్వ"
      },
      "selected_count_one": "{{count}} ఎంచుకున్నారు",
      "selected_count_other": "{{count}} ఎంచుకున్నారు",
      "title": "సౌకర్యాలను ఎంచుకోండి"
    },
    "area_details": {
      "confirm": "విస్తీర్ణాన్ని నిర్ధారించండి",
      "error_ordering": "దయచేసి కార్పెట్ వైశాల్యం ≤ బిల్ట్-అప్ వైశాల్యం ≤ సూపర్ బిల్ట్-అప్ వైశాల్యం ఉండేలా చూసుకోండి, మరియు సూపర్ బిల్ట్-అప్ వైశాల్యం బిల్ట్-అప్ వైశాల్యం కంటే ఎక్కువగా ఉండాలి.",
      "error_positive": "వైశాల్యం విలువలు 0 కంటే ఎక్కువగా ఉండాలి.",
      "error_units": "దయచేసి అన్ని వైశాల్య ఫీల్డ్‌లు ఒకే కొలత యూనిట్‌ను ఉపయోగిస్తున్నాయని నిర్ధారించుకోండి.",
      "help": "విస్తీర్ణ సహాయం",
      "help_text": "కనీసం ఒక విస్తీర్ణం నమోదు చేయండి. కార్పెట్, బిల్ట్-అప్, సూపర్ బిల్ట్-అప్ జోడించవచ్చు.",
      "mandatory": "కనీసం ఒక విస్తీర్ణ రకం తప్పనిసరి",
      "plot": "ప్లాట్ వైశాల్యం",
      "title": "విస్తీర్ణ వివరాలు జోడించండి",
      "total": "మొత్తం వైశాల్యం"
    },
    "area_input": {
      "confirm": "విస్తీర్ణాన్ని నిర్ధారించండి",
      "placeholder": "ఉదా. 1500",
      "title": "ఆస్తి పరిమాణం",
      "units": {
        "acres": "ఎకరాలు",
        "bigha": "బీఘా",
        "cents": "సెంట్లు",
        "guntas": "గుంటలు",
        "marla": "మర్లా",
        "sqft": "చ. అ.",
        "sqyd": "చ. గజ."
      }
    },
    "area_type": {
      "built_up": "బిల్ట్-అప్ వైశాల్యం",
      "carpet": "కార్పెట్ వైశాల్యం",
      "plot": "ప్లాట్ వైశాల్యం",
      "super_built_up": "సూపర్ బిల్ట్-అప్ వైశాల్యం",
      "title": "వైశాల్యం రకం"
    },
    "available_from": {
      "immediately": "వెంటనే",
      "month_year": "లేదా నెల / సంవత్సరం నమోదు చేయండి",
      "placeholder": "ఉదా. జూన్ 2026",
      "title": "ఎప్పటి నుండి అందుబాటులో"
    },
    "booking_token_amount": {
      "confirm": "నిర్ధారించండి",
      "placeholder": "ఉదా. 100000",
      "title": "బుకింగ్ / టోకెన్ మొత్తం"
    },
    "commercial_furnishing": {
      "title": "ఫర్నిషింగ్ స్థితి"
    },
    "commercial_subtype": {
      "commercial_land": "వాణిజ్య భూమి",
      "commercial_office_space": "వాణిజ్య కార్యాలయ స్థలం",
      "commercial_shop": "వాణిజ్య షాప్",
      "commercial_showroom": "వాణిజ్య షోరూమ్",
      "industrial_building": "పారిశ్రామిక భవనం",
      "industrial_land": "పారిశ్రామిక భూమి",
      "industrial_shed": "పారిశ్రామిక షెడ్",
      "office_it_park_sez": "ఐటి పార్క్ / SEZ లో కార్యాలయం",
      "title": "వాణిజ్య ఆస్తి రకం",
      "warehouse_godown": "గోదాము / గోడౌన్"
    },
    "commercial_zone": {
      "agricultural_zone": "వ్యవసాయ జోన్",
      "commercial": "వాణిజ్య",
      "government_use": "ప్రభుత్వ ఉపయోగం",
      "industrial": "పారిశ్రామిక",
      "natural_conservation_zone": "ప్రకృతి సంరక్షణ జోన్",
      "open_spaces": "బహిరంగ ప్రదేశాలు",
      "public_semi_public": "పబ్లిక్ మరియు సెమీ పబ్లిక్ ఉపయోగం",
      "public_utilities": "పబ్లిక్ యుటిలిటీలు",
      "residential": "నివాస",
      "special_economic_zone": "ప్రత్యేక ఆర్థిక జోన్",
      "title": "భూమి జోనింగ్",
      "transport_communication": "రవాణా మరియు కమ్యూనికేషన్"
    },
    "connectivity": {
      "add_your_own": "మీది జోడించండి",
      "continue_one": "కొనసాగించండి ({{count}} ఎంచుకున్నారు)",
      "continue_other": "కొనసాగించండి ({{count}} ఎంచుకున్నారు)",
      "items": {
        "airport": "విమానాశ్రయం",
        "bus_stop": "బస్ స్టాప్",
        "highway_orr": "హైవే/ORR",
        "main_road": "ప్రధాన రహదారి",
        "metro_station": "మెట్రో స్టేషన్",
        "nearby_landmark": "సమీప ల్యాండ్‌మార్క్"
      },
      "placeholder": "ఉదా. హైటెక్ సిటీ మెట్రో - 5 నిమి",
      "selected_count_one": "{{count}} ఎంచుకున్నారు",
      "selected_count_other": "{{count}} ఎంచుకున్నారు",
      "skip": "దాటవేయి",
      "title": "కనెక్టివిటీ"
    },
    "counter": {
      "confirm_one": "{{count}} {{label}} నిర్ధారించండి",
      "confirm_other": "{{count}} {{label}} నిర్ధారించండి",
      "labels": {
        "balconies_one": "బాల్కనీ",
        "balconies_other": "బాల్కనీలు",
        "bathrooms_one": "బాత్‌రూమ్",
        "bathrooms_other": "బాత్‌రూమ్‌లు",
        "bedrooms_one": "బెడ్‌రూమ్",
        "bedrooms_other": "బెడ్‌రూమ్‌లు",
        "lifts_one": "లిఫ్ట్/ఎలివేటర్",
        "lifts_other": "లిఫ్ట్‌లు/ఎలివేటర్లు",
        "open_sides_one": "ఓపెన్ సైడ్",
        "open_sides_other": "ఓపెన్ సైడ్స్",
        "total_floors_one": "మొత్తం అంతస్తు",
        "total_floors_other": "మొత్తం అంతస్తులు"
      },
      "skip": "Skip"
    },
    "extra_pantry": {
      "dry_pantry": "ఎండి పాంట్రీ",
      "not_available": "అందుబాటులో లేదు",
      "wet_pantry": "తెమడి పాంట్రీ"
    },
    "facing": {
      "east": "East",
      "north": "North",
      "north_east": "North-East",
      "north_west": "North-West",
      "south": "South",
      "south_east": "South-East",
      "south_west": "South-West",
      "title": "Property Facing",
      "west": "West"
    },
    "floor_details": {
      "ground_floor": "గ్రౌండ్ ఫ్లోర్",
      "title": "అంతస్తు & భవన వివరాలు"
    },
    "furnishing": {
      "fully_furnished": "Fully Furnished",
      "fully_sub": "Move-in ready with furniture and appliances",
      "semi_furnished": "Semi Furnished",
      "semi_sub": "Basic fittings; bring your own furniture",
      "title": "Furnishing Status",
      "unfurnished": "Unfurnished",
      "unfurnished_sub": "Empty unit; no furniture included"
    },
    "ideal_for_businesses": {
      "title": "వ్యాపారాలకు అనువైనది"
    },
    "locality_tier": {
      "developed": "అభివృద్ధి చెందిన ప్రాంతాలు",
      "developed_sub": "Established residential & commercial hubs with mature amenities",
      "label": "లోకాలిటీ టైర్",
      "premium": "ప్రీమియం ప్రాంతాలు",
      "premium_sub": "High-end, prime luxury neighborhoods with top-tier lifestyle",
      "subtitle": "ఈ ప్రాంతాన్ని ఉత్తమంగా వివరించే టైర్‌ను ఎంచుకోండి",
      "tier_1": "టైర్ 1 ప్రైమ్ / లగ్జరీ",
      "tier_2": "టైర్ 2 అభివృద్ధి / పరిపక్వ",
      "tier_3": "టైర్ 3 ఉద్భవిస్తున్న / వృద్ధి",
      "title": "లోకాలిటీ వర్గీకరణ",
      "upcoming": "రాబోయే ప్రాంతాలు",
      "upcoming_sub": "High-growth potential, developing infrastructure & future appreciation"
    },
    "location": {
      "allow_or_pick": "లొకేషన్ అనుమతి ఇవ్వండి లేదా మీ దేశాన్ని ఎంచుకోండి. లోకాలిటీ మరియు పిన్‌కోడ్ ఆ దేశంలోనే ఉంటాయి.",
      "area_label": "ప్రాంతం / పరిసర ప్రాంతం",
      "label": "లొకేషన్ / పరిసర ప్రాంతం",
      "placeholder": "ఉదా. గాచిబౌలి",
      "press_enter": "లొకేషన్ నిర్ధారించడానికి Enter నొక్కండి",
      "press_enter_locality": "లోకాలిటీ నిర్ధారించడానికి Enter నొక్కండి లేదా శోధన్ క్లిక్ చేయండి",
      "searching_in": "ఇక్కడ శోధిస్తోంది",
      "set_country_first": "ముందు మీ దేశాన్ని సెట్ చేయండి",
      "use_current": "నా ప్రస్తుత లొకేషన్ ఉపయోగించండి"
    },
    "maintenance_charges": {
      "amount_label": "నిర్వహణ ఛార్జీలు",
      "amount_placeholder": "నిర్వహణ ఛార్జీలు",
      "confirm": "నిర్ధారించండి",
      "frequency": {
        "monthly": "నెలవారీ",
        "one_time": "ఒకసారి",
        "per_sq_unit_monthly": "ప్రతి చ.అ. యూనిట్ నెలవారీ",
        "quarterly": "త్రైమాసిక",
        "yearly": "వార్షిక"
      },
      "included_hint": "అద్దెలో నిర్వహణ ఉంది — వేరు ఛార్జీ లేదు.",
      "included_hint_sale": "వేరు నిర్వహణ ఛార్జీ లేదు — చేర్చబడింది లేదా వర్తించదు.",
      "included_label": "నిర్వహణ చేర్చబడింది",
      "per_label": "ప్రతి",
      "skip": "దాటవేయి",
      "title": "నిర్వహణ ఛార్జీలు"
    },
    "maintenance_frequency": {
      "title": "నిర్వహణ ఫ్రీక్వెన్సీ"
    },
    "media": {
      "add": "జోడించండి",
      "add_anyway": "నిజం, ఫోటోలు లేదా వీడియో జోడించండి",
      "add_photos": "ఫోటోలు లేదా వీడియో టూర్ జోడించండి",
      "click_or_drag": "ఇక్కడ క్లిక్ చేయండి లేదా ఫైల్‌లు లాగండి",
      "documents_hint": "(బ్రోషర్, ఫ్లోర్ ప్లాన్, చట్టపర డాక్యుమెంట్లు)",
      "documents_title": "ఆస్తి డాక్యుమెంట్లు",
      "documents_types": "PDF, DOC, DOCX, XLS, XLSX, JPG, PNG · ప్రతి {{mb}} MB",
      "done": "పూర్తి",
      "file_too_large": "ఫైల్ చాలా పెద్దిది (గరిష్ట {{mb}} MB)",
      "limit_partial": "{{max}} పరిమితులో ఉండటానికి ఇంకా {{remaining}} అిటమ్ల(ల)ను జోడగలిగించాము.",
      "limit_reached": "గరిష్ట {{max}} మీడియా అిటమ్ల చేరుకున్నాయి (ఫోటోలు + వీడియో టూర్).",
      "no_media": "మీడియా లేదు",
      "no_media_ok": "మీడియా లేదు — పరవాలేదు!",
      "photos_formats": "ఫోటోలు (JPEG, PNG) · వీడియో (గరిష్ట {{mb}}MB)",
      "preview_alt": "ప్రీవ్యూ",
      "remove": "తొలగిండి",
      "skip": "దాటు",
      "skip_media": "మీడియాను దాటు",
      "summary_none": "ఇంకా మీడియా లేదు (గరిష్ట {{max}})",
      "summary_photos_one": "{{photos}} ఫోటో ({{count}}/{{max}})",
      "summary_photos_other": "",
      "summary_photos_one_one": "",
      "summary_photos_one_other": "",
      "summary_photos_video_one": "{{photos}} ఫోటో, 1 వీడియో ({{count}}/{{max}})",
      "summary_photos_video_other": "",
      "summary_photos_video_one_one": "",
      "summary_photos_video_one_other": "",
      "summary_video_one": "",
      "summary_video_other": "",
      "unsupported_type": "మద్దతు కాని ఫైల్ రకం",
      "upload": "అప్లోడ్ చేయండి",
      "upload_one": "{{count}} డాక్యుమెంట్ అప్లోడ్ చేయండి",
      "upload_n_one": "",
      "upload_n_other": "",
      "upload_one_one": "",
      "upload_one_other": "",
      "video": "వీడియో",
      "video_too_large": "వీడియో \"{{name}}\" {{mb}} MB పరిమితిని దాటినది."
    },
    "mode_selector": {
      "rent": "అద్దె / లీజ్",
      "rent_hint": "నేను అద్దెకు ఇవ్వాలనుకుంటున్నాను",
      "sell": "అమ్మకం",
      "sell_hint": "నేను ఆస్తిని అమ్మాలనుకుంటున్నాను"
    },
    "nearby_businesses": {
      "items": {
        "bank": "బ్యాంక్",
        "cafe": "కేఫ్",
        "clinic": "క్లినిక్",
        "hospital": "ఆసుపత్రి",
        "mall": "మాల్",
        "pharmacy": "ఫార్మసీ",
        "restaurant": "రెస్టారెంట్",
        "retail_shops": "రిటైల్ షాప్‌లు",
        "school": "పాఠశాల"
      },
      "title": "సమీప వ్యాపారాలు"
    },
    "nearby_places": {
      "add_your_own": "మీది జోడించండి",
      "continue_one": "కొనసాగించండి ({{count}} ఎంచుకున్నారు)",
      "continue_other": "కొనసాగించండి ({{count}} ఎంచుకున్నారు)",
      "items": {
        "gym": "జిమ్",
        "hospital": "ఆసుపత్రి",
        "park": "పార్క్",
        "restaurant": "రెస్టారెంట్",
        "school": "పాఠశాల",
        "shopping_mall": "షాపింగ్ మాల్"
      },
      "placeholder": "ఉదా. అపోలో ఆసుపత్రి - 2 కి.మీ",
      "selected_count_one": "{{count}} ఎంచుకున్నారు",
      "selected_count_other": "{{count}} ఎంచుకున్నారు",
      "skip": "దాటవేయి",
      "title": "సమీప ప్రదేశాలు"
    },
    "number_input": {
      "booking_token_amount": "Booking / Token Amount",
      "ceiling_height": "Ceiling height (ft)",
      "confirm": "Confirm",
      "entrance_width": "ప్రవేశం వెడల్పు (అడుగులు)",
      "example_prefix": "e.g.",
      "floor_number": "Floor number",
      "floors_allowed_for_construction": "అనుమతించిన అంతస్తులు",
      "open_sides": "ఓపెన్ సైడ్స్",
      "parking_spots": "Parking spots",
      "plot_breadth": "ప్లాట్ వెడల్పు (అడుగులు)",
      "plot_length": "ప్లాట్ పొడవు (అడుగులు)",
      "road_width": "రోడ్ వెడల్పు",
      "road_width_facing_plot": "ప్లాట్ ముందు రోడ్",
      "total_floors": "Total floors in building",
      "washroom_count": "వాష్‌రూమ్ సంఖ్య"
    },
    "ownership": {
      "freehold": "ఫ్రీహోల్డ్",
      "freehold_sub": "భూమి మరియు నిర్మాణం రెండు పూర్తి యజమాన్యం, కాలవధి లేదు",
      "label": "యాజమాన్యం",
      "leasehold": "లీజ్‌హోల్డ్",
      "leasehold_sub": "ప్రభుత్వం లేదా యజమాని ఇచ్చిన నిర్ధిష్ట కాలానికి యజమాన్యం",
      "poa": "పవర్ ఆఫ్ అటార్నీ",
      "poa_sub": "చాటుప్ర పావర్ ఆఫ్ అటార్నీ ద్వారా అమ్మకం హక్కు",
      "society": "సహకార సొసైటీ",
      "society_sub": "నమోదు హౌసింగ్ కో-ఆపరేటివ్ ద్వారా షేర్లు మరియు బాడాబడి హక్కులు",
      "subtitle": "ఆస్తి చట్టపరమైన టైటిల్ / యాజమాన్య స్థితిని ఎంచుకోండి",
      "title": "యాజమాన్య రకం"
    },
    "parking": {
      "confirm": "నిర్ధారించండి",
      "options": {
        "bike": "సిర్ఫ్ బైక్",
        "bike_sub": "టూ వీలర్ పార్కింగ్ మాత్రమే",
        "both": "రెండూ (కార్ & బైక్)",
        "both_sub": "కార్ మరియు ద్విచక్ర వాహనాల స్థలాలు",
        "car": "కార్ మాత్రమే",
        "car_sub": "నాలుగు చక్రాల వాహన స్థలాలు",
        "none": "పార్కింగ్ లేదు",
        "none_sub": "ప్రత్యేక వాహన పార్కింగ్ లేదు"
      },
      "skip": "దాటవేయి",
      "slots_label": "కార్ పార్కింగ్ స్థలాలు",
      "subtitle": "అందుబాటులో ఉన్న వాహన పార్కింగ్ ఎంచుకోండి",
      "title": "పార్కింగ్ సౌకర్యం"
    },
    "pg_available_from": {
      "confirm": "నిర్ధారించు",
      "immediately": "వెంటనే",
      "or_custom": "లేదా నెల / సంవత్సరం నమోదు చేయండి",
      "placeholder": "ఉదా. జూన్ 2026",
      "section_label": "అందుబాటు నుండి"
    },
    "pg_available_services": {
      "confirm": "నిర్ధారించండి",
      "laundry": "లాండ్రీ",
      "room_cleaning": "రూమ్ క్లీనింగ్",
      "subtitle": "మీ PGలో టెనెంట్లకు ఏ సేవలు అందుబాటులో ఉన్నాయి?",
      "title": "అందుబాటులో ఉన్న సేవలు",
      "warden": "వార్డెన్ సౌకర్యం"
    },
    "pg_common_amenities": {
      "confirm": "నిర్ధారించు",
      "fridge": "Fridge",
      "gym": "Gym",
      "kitchen": "Kitchen",
      "lift": "Lift",
      "microwave": "Microwave",
      "power_backup": "Power Backup",
      "ro_water": "RO Water",
      "skip": "దాటవేయి",
      "subtitle": "మీ PG సాధారణ ప్రాంతాల్లో అందుబాటులో ఉన్న అన్ని సౌకర్యాలను ఎంచుకోండి",
      "title": "సాధారణ ప్రాంత సౌకర్యాలు",
      "tv": "TV",
      "wifi": "WiFi"
    },
    "pg_food": {
      "confirm": "నిర్ధారించు",
      "meals": {
        "breakfast": "అల్పాహారం",
        "dinner": "రాత్రి భోజనం",
        "lunch": "మధ్యాహ్న భోజనం"
      },
      "meals_label": "ఏ భోజనాలు? (ఐచ్ఛికం)",
      "subtitle": "మీ PG అద్దెదారులకు ఆహారం / భోజనాలు అందిస్తుందా?",
      "title": "ఆహారం అందుబాటులో"
    },
    "pg_gate_closing": {
      "confirm": "నిర్ధారించు",
      "field_label": "గేట్ మూసివేత సమయం",
      "none": "గేట్ మూసివ లేదు",
      "placeholder": "సమయం ఎంచుకోండి",
      "title": "అద్దెదారులు ఈ సమయానికి ముందు PGకి తిరిగి రావాలి"
    },
    "pg_occupancy": {
      "available_floors": "అందుబాటులో ఉన్న అంతస్తులు (ఐచ్ఛికం)",
      "beds_per_room": "గదికి మంచాల సంఖ్య",
      "confirm_details": "నిర్ధారించు",
      "continue": "కొనసాగించు",
      "deposit_per_bed": "బెడ్‌కు సెక్యూరిటీ డిపాజిట్ (₹)",
      "double": "Double",
      "double_title": "Double Sharing (2 Beds)",
      "four": "Four",
      "four_title": "Four Sharing (4 Beds)",
      "other": "Other",
      "other_title": "Custom / Dormitory Layout",
      "rent_details_for": "{{type}} రూమ్ అద్దె వివరాలు",
      "rent_per_bed": "బెడ్‌కు నెలవారీ అద్దె (₹)",
      "rooms_count": "PG లో {{type}} గదుల సంఖ్య",
      "selected_count": "{{count}} selected",
      "selected_count_one": "{{count}} selected",
      "selected_count_other": "{{count}} selected",
      "sell_details_for": "{{type}} షేరింగ్ గదులు",
      "single": "Single",
      "single_title": "Single Occupancy (1 Bed)",
      "step_hint": "{{remaining}} ఎంపిక(లు) మిగిలి ఉన్నాయి",
      "subtitle": "మీరు అందించే షేరింగ్ ఎంపికలన్నీ ఎంచుకోండి",
      "title": "ఆక్యుపెన్సీ వివరాలు",
      "triple": "Triple",
      "triple_title": "Triple Sharing (3 Beds)"
    },
    "pg_present_in": {
      "independent_building": "స్వతంత్ర భవనం",
      "independent_flats": "స్వతంత్ర ఫ్లాట్(లు)",
      "society": "సొసైటీలో ఉంది",
      "title": "PG ఎక్కడ ఉంది"
    },
    "pg_room_facilities": {
      "ac": "AC",
      "air_cooler": "Air cooler",
      "balcony": "అటాచ్డ్ బాల్కనీ",
      "confirm": "నిర్ధారించు",
      "copy_notice": "{{type}} లాంటి సౌకర్యాలనే వర్తింపజేయండి",
      "cot": "Cot",
      "cupboard": "Cupboard",
      "geyser": "Geyser",
      "locked_notice": "మునుపటి గది నుండి సౌకర్యాలు ఎంచుకోబడి లాక్ చేయబడ్డాయి",
      "mattress": "Mattress",
      "same_as_previous": "మునుపటి గది లాగే",
      "side_table": "Side table",
      "skip": "దాటవేయి",
      "subtitle": "ప్రతి గదిలో అందుబాటులో ఉన్న అన్ని సౌకర్యాలను ఎంచుకోండి",
      "subtitle_for_type": "{{type}} షేరింగ్ గదుల్లో అందుబాటులో ఉన్న సౌకర్యాలను ఎంచుకోండి",
      "title": "గది సౌకర్యాలు",
      "title_for_type": "గది సౌకర్యాలు — {{type}}",
      "tv": "TV",
      "washrooms": "Washrooms"
    },
    "pg_rules": {
      "confirm": "నిర్ధారించు",
      "no_drinking": "మద్యం నిషేధం",
      "no_guardian": "గార్డియన్ అనుమతి లేదు",
      "no_opposite_gender": "వ్యతిరేక లింగం నిషేధం",
      "no_smoking": "స్మోకింగ్ నిషేధం",
      "skip": "దాటవేయి",
      "subtitle": "మీ PGకి వర్తించే అన్ని నియమాలను ఎంచుకోండి",
      "title": "PG నియమాలు",
      "veg_only": "కేవలం శాకాహారం"
    },
    "pg_tenant_preference": {
      "both": "Both",
      "professionals": "Professionals",
      "student": "Student",
      "subtitle": "మీరు అద్దెదారులుగా ఎవరిని ఇష్టపడతారు?",
      "title": "అద్దెదారు ప్రాధాన్యతలు"
    },
    "pg_usp": {
      "added": "జోడించిన USPలు",
      "confirm": "నిర్ధారించు",
      "examples_title": "ఉదాహరణ USPలు",
      "heading": "మీ PG గురించి మరింత చెప్పండి",
      "placeholder": "ఉదా. మెట్రో స్టేషన్ దగ్గర",
      "select_category": "వర్గం ఎంచుకోండి",
      "skip": "దాటవేయి",
      "subtitle": "మీ PG USP రాయండి",
      "write_usp": "PG USP రాయండి"
    },
    "possession_status": {
      "ready_to_move": "వెంటనే నివసించడానికి సిద్ధం",
      "title": "హస్తగతం స్థితి",
      "under_construction": "నిర్మాణంలో ఉంది"
    },
    "power_supply": {
      "options": {
        "not_available": "అందుబాటులో లేదు",
        "single_phase": "సింగిల్ ఫేజ్",
        "three_phase": "త్రీ ఫేజ్"
      },
      "title": "విద్యుత్ సరఫరా"
    },
    "preferred_tenants": {
      "anyone": "ఎవరైనా",
      "bachelor_female": "బ్యాచిలర్ మహిళ",
      "bachelor_male": "బ్యాచిలర్ పురుషుడు",
      "company": "కంపెనీ",
      "confirm": "నిర్ధారించు",
      "family": "కుటుంబం",
      "subtitle": "మీరు ఎవరికి అద్దెకు ఇవ్వాలనుకుంటున్నారు? వర్తించేవన్నీ ఎంచుకోండి.",
      "title": "ప్రాధాన్య అద్దెదారులు"
    },
    "price_input": {
      "confirm": "ధరను నిర్ధారించండి",
      "placeholder": "మొత్తం నమోదు చేయండి",
      "price_negotiable": "ధర చర్చించదగినది",
      "quick_picks": "త్వరిత ఎంపికలు",
      "rent_suffix": "/ నెల",
      "title": "మీ ధరను నమోదు చేయండి"
    },
    "property_address": {
      "confirm": "చిరునామాను నిర్ధారించండి",
      "confirmed_message": "ఆస్తి చిరునామా నిర్ధారించబడింది",
      "pinned_verified": "పిన్ ధృవీకరించబడింది",
      "preview": "చిరునామా ప్రివ్యూ",
      "show_map_pin_desc_off": "ఆస్తి శోధన ఫలితాల్లో కనిపిస్తూనే ఉంటుంది, కానీ మ్యాప్ పిన్ దాచబడుతుంది.",
      "show_map_pin_desc_on": "కొనుగోలుదారులు/అద్దెదారుల కోసం శోధన మ్యాప్‌లో మీ ఖచ్చితమైన ఎరుపు పిన్ కనిపిస్తుంది.",
      "show_map_pin_label": "శోధన మ్యాప్‌లో చిరునామా చూపించు",
      "subtitle": "దిగువ మీ పూర్తి పోస్టల్ చిరునామాను నిర్ధారించండి లేదా సవరించండి.",
      "title": "ఆస్తి చిరునామా వివరాలు"
    },
    "property_map_pin": {
      "address_unavailable": "ఈ పిన్‌కు వీధి చిరునామా కనుగొనలేకపోయాం. మీ Google Maps కీలో Places API మరియు Geocoding APIని ప్రారంభించి మళ్లీ ప్రయత్నించండి.",
      "approx_location": "అంచనా నెట్‌వర్క్ స్థానం చూపబడుతోంది. ఖచ్చితమైన పిన్ కోసం బ్రౌజర్ GPSని ప్రారంభించండి.",
      "area_not_found": "ఆ ప్రాంతం కనుగొనబడలేదు. పరిసర పేరు, ల్యాండ్‌మార్క్ లేదా పూర్తి చిరునామా ప్రయత్నించండి.",
      "area_search_failed": "ప్రాంత శోధన విఫలమైంది. కనెక్షన్ తనిఖీ చేసి మళ్లీ ప్రయత్నించండి.",
      "area_search_label": "మ్యాప్‌లో ప్రాంతం శోధించండి",
      "area_search_placeholder": "లోకాలిటీ, ల్యాండ్‌మార్క్ లేదా చిరునామా శోధించండి",
      "confirm": "స్థానాన్ని నిర్ధారించండి",
      "confirmed_message": "ఆస్తి స్థానం నిర్ధారించబడింది",
      "confirming": "సేవ్ చేస్తోంది…",
      "edit_subtitle": "ఒక ప్రదేశం శోధించండి, మ్యాప్ పాన్ చేయండి లేదా పిన్ లాగండి. పిన్ మ్యాప్ సెంటర్‌తో సింక్‌లో ఉంటుంది.",
      "edit_title": "ఆస్తి స్థానాన్ని సవరించండి",
      "exit_fullscreen": "ఫుల్‌స్క్రీన్ నుండి నిష్క్రమించు (Esc)",
      "fullscreen": "ఫుల్‌స్క్రీన్",
      "latitude": "అక్షాంశం",
      "live_location_found": "మీ లైవ్ స్థానం చూపబడుతోంది",
      "locate_me": "నా లైవ్ స్థానం",
      "longitude": "రేఖాంశం",
      "osm_address_unavailable": "ఈ పిన్‌కు వీధి చిరునామా కనుగొనలేకపోయాం. పిన్‌ను కొద్దిగా కదిలించండి లేదా నెట్‌వర్క్ తనిఖీ చేయండి.",
      "recenter_pin": "ఆస్తి పిన్‌పై కేంద్రీకరించండి",
      "save_location": "స్థానం సేవ్ చేయండి",
      "select_location": "మీ ఆస్తి పిన్ ఉంచడానికి మ్యాప్‌పై లాగండి లేదా ట్యాప్ చేయండి",
      "subtitle": "ఒక ప్రదేశం శోధించండి, ఆపై మ్యాప్ పాన్ చేయండి లేదా పిన్ లాగి ఖచ్చితమైన స్థలాన్ని గుర్తించండి.",
      "title": "మీ ఆస్తి స్థానాన్ని పిన్ చేయండి"
    },
    "rera": {
      "approved": "RERA ఆమోదించబడింది",
      "chat_confirmed_no": "RERA నమోదు కాలేదు",
      "chat_confirmed_with_id": "RERA రిజిస్టర్ చేయబడింది: అవును (ID: {{id}})",
      "chat_confirmed_yes": "RERA రిజిస్టర్ చేయబడింది: అవును",
      "chat_skipped": "RERA దాటవేయి",
      "confirm_button": "ధృవీకరించండి మరియు కొనసాగించండి",
      "id_label": "RERA రిజిస్ట్రేషన్ ID / సంఖ్య",
      "id_placeholder": "ఉదా. P02400001234",
      "label": "RERA స్థితి",
      "not_registered": "RERA నమోదు కాలేదు",
      "registered": "RERA నమోదు చేయబడింది",
      "skip": "దాటవేయి",
      "subtitle": "ఈ ఆస్తి RERA ఆమోదించబడిందా / నమోదు చేయబడిందా?",
      "title": "RERA నమోదు",
      "unregistered_sub": "మినహాయింపు లేదా నమోదు పెండింగ్‌లో ఉంది",
      "verified_sub": "కొనుగోలుదారు నమ్మకాన్ని పెంచుతుంది"
    },
    "sale_type": {
      "label": "అమ్మకం రకం",
      "new": "కొత్త",
      "new_sub": "బిల్డర్/డెవలపర్ నుండి నేరుగా కొత్త ప్రాపర్టీ",
      "resale": "రీసేల్",
      "resale_sub": "ప్రస్తుత యజమాని మళ్లీ అమ్ముతున్న ఉపయోగించిన ప్రాపర్టీ",
      "subtitle": "ఇది కొత్త బుకింగ్‌నా లేక రీసేల్‌నా అని పేర్కొనండి",
      "title": "అమ్మకం రకం"
    },
    "security_deposit": {
      "confirm": "నిర్ధారించండి",
      "placeholder": "ఉదా. 10000 లేదా 0",
      "title": "సెక్యూరిటీ డిపాజిట్"
    },
    "submit_success": {
      "list_another": "మరొక ఆస్తిని జాబు చేయండి",
      "subtitle": "మీ ఆస్తి LetMeIn మార్కెట్ప్లేస్లో పోస్ట్ చేయబడింది",
      "title": "ఆస్తి విజయవంతంగా జాబితాయి!",
      "view_properties": "నా ఆస్తులను చూడండి"
    },
    "tag_multi_select": {
      "add_custom": "మీది జోడించండి…",
      "continue": "కొనసాగించండి"
    },
    "type_selector": {
      "title": "ప్రాపర్టీ రకం"
    },
    "washroom_count": {
      "title": "వాష్‌రూమ్ సంఖ్య"
    },
    "yes_no": {
      "questions": {
        "does_it_have_a_personal_washroom": "Does it have a personal washroom?",
        "is_it_a_corner_plot": "Is it a corner plot?",
        "is_it_a_corner_shop": "Is it a corner shop?",
        "is_it_on_the_main_road": "Is it on the main road?",
        "is_there_a_boundary_wall": "Is there a boundary wall?",
        "is_washroom_available": "Is washroom available?",
        "loading_unloading_access": "Is loading/unloading access available?",
        "truck_accessibility": "Is truck access available?"
      }
    }
  },
  "help": {
    "community": {
      "description": "ఫీచర్లు చర్చించడానికి మరియు ఇతర వినియోగదారుల నుండి సహాయం పొందడానికి మా కమ్యూనిటీ ఫోరమ్లో చేరండి.",
      "title": "కమ్యూనిటీ",
      "visit": "కమ్యూనిటీని సందర్శించండి →"
    },
    "contact": {
      "direct_support": "నేరుటి మద్దతు",
      "email_support": "ఇమెయిల్ మద్దతు",
      "respond_time": "సాధారణంగా 24 గంటలలో ప్రతిస్పందాము.",
      "tech_issues": "సాంకేతిక సమస్యలు"
    },
    "faq": {
      "q1": {
        "a": "సైడ్‌బార్లో 'ఆస్తిని జాబు చేయండి' విభాగానికి వెళ్లండి. AI లిస్టింగ్ అసిస్టెంట్తో వ్రత్తిపూర్వ వివరణ మరియు వివరాలు సెట్ చేయవచ్చు.",
        "q": "నేను నా ఆస్తిని ఎలా జాబు చేయాలి?"
      },
      "q2": {
        "a": "బ్రోకరేజ్ హబ్ యజమానులు ప్రాపర్టీ మేనేజర్‌లను ఆహ్వానించి నిర్వహించడానికి అనుమతిస్తుంది. మీ డాష్‌బోర్డ్ నుండి ప్రదర్శనను ట్రాక్ చేయవచ్చు.",
        "q": "బ్రోకరేజ్ హబ్ అన్తేది?"
      },
      "q3": {
        "a": "సైడ్‌బార్ నుండి 'సబ్స్క్రిప్షన్' పేజికి వెళ్లండి. అక్కడ మీ ప్రస్తుత ప్లాన్‌ని చూడవచ్చు, అప్‌గ్రేడ్ చేయవచ్చు లేదా బిల్లింగ్ వివరాలను నిర్వహించవచ్చు.",
        "q": "నేను నా సబ్స్క్రిప్షన్ ప్లాన్‌ని ఎలా మార్చాలి?"
      },
      "q4": {
        "a": "అవును, మేము భద్రతను గంభీరంగా తీసుకుంతాము. మీ డేటా ఎన్క్రిప్ట్ చేయబడుతుంది, Firebase మరియు Stripe/Razorpay వంటి ప్రమాణీకరణ/చెల్లింపులు ఉపయోగిస్తాము.",
        "q": "నా డేటా సురక్షితమైనదా?"
      },
      "q5": {
        "a": "అద్దెదారు మీ ఆస్తి గురించి అడిగినప్పుడుతే మీకు నోటిఫికేషన్ వస్తుంది. తర్వాత 'సందేశాలు' విభాగానికి వెళ్లి నేరుగా చాట్ చేయవచ్చు.",
        "q": "నేను అద్దెదారుని ఎలా సంప్రదించగలను?"
      }
    },
    "form": {
      "description": "క్రింది ఫార్మ్ నింపి, మా జోలు మీకు సంప్రదిస్తుంది.",
      "email": "ఇమెయిల్",
      "error": "సందేశం పంపడంలో విఫలమైంది. దయచేసి మళ్లీ ప్రయత్నించండి.",
      "error_long": "సహాయ అభ్యర్థన పంపడటంలో విఫలమైంది. దయచేసి మళ్లి ప్రయత్నించండి.",
      "message": "సందేశం",
      "name": "పేరు",
      "placeholder_email": "john@example.com",
      "placeholder_message": "మీ మనసులో ఉన్నదాని మాకు చెప్పండి...",
      "placeholder_name": "John Doe",
      "placeholder_subject": "నా సబ్స్క్రిప్షన్ గురించి ప్రశ్న",
      "sending": "పంపుతోంది...",
      "subject": "విషయం",
      "submit": "సందేశం పంపండి",
      "success": "సందేశం విజయవంతంగా పంపబడింది!",
      "success_long": "సహాయ అభ్యర్థన విజయవంతంగా పంపబడింది! మేము తవ్వరత మీతో సంప్రదిస్తాము.",
      "title": "మాకు సందేశం పంపండి"
    },
    "requests": {
      "loading": "సందేశాలు లోడ్ అవుతున్నాయి...",
      "need_respond": "ప్రతిస్పందాలి",
      "none_desc_admin": "ఇంకా వరకు మద్దతు అభ్యర్థనలు రాలేదు.",
      "none_desc_user": "మీరు ఇంకా మద్దతు అభ్యర్థనలు పంపలేదు.",
      "none_found": "సందేశాలు కనుగొనబడలేదు",
      "refresh": "రిఫ్రెష్",
      "reply": {
        "cancel": "రద్దు",
        "error": "ప్రత్యుత్తరం పంపడంలో విఫలమైంది. SMTP సెట్ అయిందో లేదో తనిఖీ చేయండి.",
        "label": "ప్రత్యుత్తరం",
        "placeholder": "మీ ప్రత్యుత్తరం టైప్ చేయండి...",
        "placeholder_long": "మీ జవాబును ఇక్కడ టైప్ చేయండి...",
        "send": "ప్రత్యుత్తరం పంపండి",
        "success": "ప్రత్యుత్తరం విజయవంతంగా పంపబడింది! అభ్యర్థన స్థితి పరిష్కరించబడింది."
      },
      "reply_btn": "ప్రత్యుత్తరం",
      "request_resolved": "పరిష్కరించబడింది",
      "send_msg": "సందేశం పంపండి",
      "status": {
        "pending": "పెండింగ్",
        "resolved": "పరిష్కరించబడింది"
      },
      "title_admin": "అన్ని మద్దతు అభ్యర్థనలు",
      "title_user": "మీ మద్దతు అభ్యర్థనలు"
    },
    "subtitle": "జవాబులు కనుగొనండి లేదా మా జోలుతో సంప్రదించండి.",
    "tabs": {
      "contact": "సంప్రదించండి",
      "faq": "FAQ",
      "inbox": "ఇన్‌బాక్స్",
      "requests": "నా అభ్యర్థనలు"
    }
  },
  "image_search_page": {
    "actions": {
      "find_similar": "సమానమైన ప్రాపర్టీలు కనుగొనండి",
      "searching": "సమానమైన ప్రాపర్టీలు వెతుకుతోంది…"
    },
    "dropzone": {
      "click_browse": "బ్రౌజ్ చేయడానికి క్లిక్ చేయండి",
      "drag_drop": "డ్రాగ్ & డ్రాప్ చేయండి లేదా",
      "drop_here": "చిత్రాన్ని ఇక్కడ వదలండి",
      "formats": "JPEG, PNG, WebP · గరిష్ఠం 10 MB",
      "upload_photo": "ప్రాపర్టీ ఫోటో అప్లోడ్ చేయండి"
    },
    "errors": {
      "generic": "ఏదో తప్పు జరిగింది. మళ్లీ ప్రయత్నించండి.",
      "invalid_type": "దయచేసి JPEG, PNG లేదా WebP చిత్రాన్ని ఉపయోగించండి.",
      "max_size": "చిత్రం 10 MB లోపు ఉండాలి.",
      "no_matches": "సరిపోలే ప్రాపర్టీలు కనిపించలేదు. మరో చిత్రం ప్రయత్నించండి.",
      "paid_only": "🔒 ఇమేజ్ సెర్చ్ పేడ్ యూజర్లకు మాత్రమే అందుబాటులో ఉంది."
    },
    "footer_note": "ఫలితాలు ముందుగా దృశ్య సమానత్వం, తరువాత లొకేషన్ ఆధారంగా ర్యాంక్ చేయబడతాయి.",
    "how_it_works": {
      "example": "\"గచ్చిబౌలి, హైదరాబాద్ సమీపంలో\"",
      "prefix": "మీకు నచ్చిన ప్రాపర్టీ ఫోటోను అప్లోడ్ చేయండి. మా AI దానికి దగ్గరైన లిస్టింగ్స్‌ను కనుగొంటుంది. అవసరమైతే ఈ విధంగా లొకేషన్ హింట్ జోడించండి",
      "suffix": "అంటే ప్రాంతానికి సరిపోయే ఫలితాలు వస్తాయి."
    },
    "location_context": {
      "hint": "లొకేషన్ జోడిస్తే మరింత సరైన ఫలితాలు వస్తాయి.",
      "label": "లొకేషన్ సందర్భం",
      "optional": "ఐచ్ఛికం",
      "placeholder": "ఉదా. \"గచ్చిబౌలి, హైదరాబాద్ సమీపంలో\" లేదా \"3 BHK అపార్ట్‌మెంట్\""
    },
    "preview": {
      "change": "మార్చు",
      "selected_alt": "ఎంచుకున్న ప్రాపర్టీ"
    }
  },
  "impersonation": {
    "action": "వినియోగదారుని ఇమ్పర్సనేట్ చేయండి",
    "banner_actor": "సూపర్ అడ్మిన్ {{email}} గా సైన్ ఇన్ అయ్యారు.",
    "banner_body": "మీరు యాప్ని {{name}} ({{email}}) గా చూస్తున్నారు.",
    "banner_title": "ఇమ్పర్సనేషన్ చెలుతుంది",
    "exit": "ఇమ్పర్సనేషన్ నుండి నిల్వదించండి",
    "failed": "ఇమ్పర్సనేషన్ ప్రారంభించలేకపోయింది.",
    "started": "ఇప్పుడు ఈ వినియోగదారు గా చూస్తున్నారు.",
    "stop_failed": "ఇమ్పర్సనేషన్ నుండి నిల్వదించలేకపోయింది."
  },
  "landing": {
    "chat_placeholder": "మా AI అసిస్టెంట్‌తో చాట్ చేయడం ప్రారంభించండి...",
    "guide_desc": "వ్యక్తిగతీకరించిన AI సిఫార్సులతో మీ సరైన సరిపోలికను కనుగొనడం మేము సులభతరం చేస్తాము",
    "guide_title": "AI మిమ్మల్ని ఇంటికి మార్గనిర్దేశం చేయనివ్వండి",
    "hero_desc": "మీరు విల్లా, భూములు, అపార్ట్‌మెంట్లు, హాస్టళ్లు లేదా మరేదైనా ప్రాపర్టీ కోసం వెతుకుతున్నా, మా AI అసిస్టెంట్ ప్రతి దశలోనూ మీకు సహాయం చేయడానికి ఇక్కడ ఉంది. తక్షణమే వ్యక్తిగతీకరించిన సిఫార్సులను పొందండి.",
    "hero_title_1": "మీ ప్రాపర్టీని కనుగొనండి.",
    "hero_title_2": "మీ కలను జీవించండి.",
    "showcase_desc": "ఆధునిక జీవనశైలి యొక్క పరాకాష్టను అనుభవించండి",
    "showcase_title": "లగ్జరీ అపార్ట్‌మెంట్ షోకేస్"
  },
  "landing_page": {
    "ai_search_btn": "AI సెర్చ్",
    "analyzing": "విశ్లేషిస్తోంది...",
    "feature_ai": "AI-ఆధారితం",
    "feature_instant": "తక్షణ ఫలితాలు",
    "feature_setup": "తక్షణ సెటప్",
    "feature_verified": "ధృవీకరించబడిన జాబితాలు",
    "footer": {
      "about_p1": "ప్రాపర్టీ కొనుగోలుదారులు మరియు విక్రేతలను అనుసంధానించే ప్రముఖ AI-ఆధారిత రియల్ ఎస్టేట్ ప్లాట్‌ఫారమ్‌గా, LetMeIn AI <0>50,000 కంటే ఎక్కువ నెలవారీ క్రియాశీల వినియోగదారులను</0> మరియు వేలాది ధృవీకరించబడిన ఆస్తి జాబితాలను కలిగి ఉంది. మా అత్యాధునిక సాంకేతికతతో, మేము స్మార్ట్ సెర్చ్, తక్షణ మూల్యాంకనాలు మరియు నిపుణుల పెట్టుబడి సలహాలను అందించే సమగ్ర ఆస్తి పర్యావరణ వ్యవస్థగా అభివృద్ధి చెందాము.",
      "about_p2": "LetMeIn AI మా యాజమాన్య విశ్లేషణల డ్యాష్‌బోర్డ్ ద్వారా విస్తృతమైన డేటా-ఆధారిత అంతర్దృష్టులను మరియు మార్కెట్ పోకడలను కూడా అందిస్తుంది, గృహ కొనుగోలుదారులకు వారి ప్రాధాన్యతలకు అనుగుణంగా ఖచ్చితమైన ధర అంచనాలు, ప్రాంతాల సమీక్షలు మరియు పెట్టుబడి అవకాశాలను అందిస్తుంది.",
      "about_title": "LetMeIn AI గురించి",
      "app_coming_soon_app_store": "LetMeIn AI iOS యాప్ ఇంకా అందుబాటులో లేదు. App Storeలో లైవ్ అయినప్పుడు మేము మీకు తెలియజేస్తాము.",
      "app_coming_soon_google_play": "LetMeIn AI Android యాప్ ఇంకా అందుబాటులో లేదు. Google Playలో లైవ్ అయినప్పుడు మేము మీకు తెలియజేస్తాము.",
      "app_coming_soon_title": "మొబైల్ యాప్ త్వరలో వస్తుంది",
      "app_store_aria": "App Storeలో డౌన్‌లోడ్ చేసుకోండి",
      "browse_properties": "ఆస్తులను చూడండి",
      "google_play_aria": "Google Playలో పొందండి",
      "privacy": "గోప్యత",
      "rights_reserved": "© 2026 LetMeIn AI. సర్వ హక్కులు ప్రత్యేకించబడినవి.",
      "terms": "నిబంధనలు"
    },
    "get_details": "వివరాలు చూడండి",
    "header": {
      "listing_intent_nav_aria": "కొనడం, అద్దె లేదా అమ్మకం",
      "nav_buy": "కొనండి",
      "nav_rent": "అద్దె",
      "nav_sell": "అమ్మండి"
    },
    "header_profile_aria": "ఖాతా మెనూ",
    "hero_subtitle": "మీరు దేని కోసం వెతుకుతున్నారో ఖచ్చితంగా అర్థం చేసుకునే AI-ఆధారిత ప్రాపర్టీ సెర్చ్.",
    "hero_title_1": "మీకు సరిపోయే",
    "hero_title_2": "స్థలాన్ని కనుగొనండి",
    "hero_title_accent": "అద్భుతమైన",
    "intent_nav": {
      "buy_commercial": "అమ్మకానికి కమర్షియల్",
      "buy_flats": "ఫ్లాట్లు & అపార్ట్‌మెంట్లు",
      "buy_plots": "ప్లాట్లు & భూమి",
      "query_buy_commercial": "అమ్మకానికి కమర్షియల్ ప్రాపర్టీలు",
      "query_buy_flats": "అమ్మకానికి ఫ్లాట్లు మరియు అపార్ట్‌మెంట్లు",
      "query_buy_plots": "అమ్మకానికి నివాస ప్లాట్లు మరియు భూమి",
      "query_rent_flats": "అద్దెకు ఫ్లాట్లు మరియు అపార్ట్‌మెంట్లు",
      "query_rent_houses": "అద్దెకు స్వతంత్ర ఇళ్లు మరియు విల్లాలు",
      "query_rent_pg": "PG మరియు షేర్డ్ స్టే",
      "query_sell_ai": "నా ప్రాపర్టిని అమ్మాలనుకుంటున్నాను, మొదలుపెట్టడంలో సహాయం కావాలి",
      "rent_flats": "అద్దెకు ఫ్లాట్లు",
      "rent_houses": "అద్దెకు ఇళ్లు & విల్లాలు",
      "rent_pg": "PG & కో-లివింగ్",
      "sell_ai": "అమ్మకం గురించి AIని అడగండి",
      "sell_list": "ప్రాపర్టిని జాబితా చేయండి"
    },
    "listings": "జాబితాలు",
    "listings_count_suffix": "జాబితాలు",
    "location_permission_dialog": {
      "browser_popup_tip": "బ్రౌజర్ లొకేషన్ అడిగే పాపప్ చూపిస్తే, ముందుగా Allow లేదా Just this time నొక్కండి.",
      "browser_popup_waiting": "బ్రౌజర్ పైన లొకేషన్ పాపప్ కోసం చూసి, Allow లేదా Just this time నొక్కండి.",
      "desc_denied": "మీరు అనుమతించే వరకు ఈ సైట్ మీ లైవ్ లొకేషన్‌ను ఉపయోగించలేదు.",
      "desc_timeout": "మీ లొకేషన్ పొందడానికి ఎక్కువ సమయం పట్టింది.",
      "desc_unavailable": "మీ పరికరం ప్రస్తుతం GPS కోఆర్డినేట్‌లను కనుగొనలేకపోయింది.",
      "how_to_unblock_android": "ఈ సైట్ కోసం లొకేషన్ ఆన్ చేయండి (Android)",
      "how_to_unblock_desktop": "ఈ సైట్ కోసం లొకేషన్ ఆన్ చేయండి",
      "how_to_unblock_ios": "ఈ సైట్ కోసం లొకేషన్ ఆన్ చేయండి (iPhone / iPad)",
      "how_to_unblock_mac": "ఈ సైట్ కోసం లొకేషన్ ఆన్ చేయండి (Mac)",
      "how_to_unblock_windows": "ఈ సైట్ కోసం లొకేషన్ ఆన్ చేయండి (Windows)",
      "locating": "లొకేషన్ తనిఖీ చేస్తోంది…",
      "no_gps_note": "లొకేషన్ కనుగొనలేకపోయాము",
      "place_pin_instead": "నేను మ్యాప్‌పై పిన్‌ను డ్రాగ్ చేస్తాను",
      "search_manually": "ప్రాంతాన్ని మాన్యువల్‌గా శోధించండి",
      "step_android_1": "Chromeలో, వెబ్‌సైట్ చిరునామా పక్కన ఉన్న లాక్ చిహ్నాన్ని నొక్కండి.",
      "step_android_2": "Permissions (లేదా Site settings) పై నొక్కండి.",
      "step_android_3": "Locationని Allowకి సెట్ చేయండి.",
      "step_android_4": "ఇక్కడకు తిరిగి వచ్చి Try Again నొక్కండి.",
      "step_desktop_1": "బ్రౌజర్‌లో వెబ్‌సైట్ చిరునామాకి ఎడమవైపు లాక్ చిహ్నాన్ని క్లిక్ చేయండి.",
      "step_desktop_2": "Locationని కనుగొని Allowకి సెట్ చేయండి.",
      "step_desktop_3": "అవసరమైతే, సిస్టమ్ ప్రైవసీ సెట్టింగ్‌లలో ఈ బ్రౌజర్ కోసం Location ఆన్ చేయండి.",
      "step_desktop_4": "ఇక్కడకు తిరిగి వచ్చి Try Again క్లిక్ చేయండి.",
      "step_ios_1": "Safariలో, అడ్రస్ బార్ ఎడమవైపు aA (లేదా పేజీ సెట్టింగ్‌ల చిహ్నం) నొక్కండి.",
      "step_ios_2": "Website Settings నొక్కి, తర్వాత Location ఎంచుకోండి.",
      "step_ios_3": "Allow ఎంచుకోండి.",
      "step_ios_4": "ఇంకా పని చేయకపోతే: iPhone Settings → Privacy & Security → Location Services → Safari Websites → Allow.",
      "step_ios_5": "ఇక్కడకు తిరిగి వచ్చి Try Again నొక్కండి.",
      "step_mac_1": "బ్రౌజర్‌లో వెబ్‌సైట్ చిరునామాకి ఎడమవైపు లాక్ చిహ్నాన్ని క్లిక్ చేయండి.",
      "step_mac_2": "Locationని కనుగొని Allowకి సెట్ చేయండి.",
      "step_mac_3": "Mac System Settings → Privacy & Security → Location Services ఆన్ చేసి, మీ బ్రౌజర్‌ను చెక్ చేయండి.",
      "step_mac_4": "ఇక్కడకు తిరిగి వచ్చి Try Again క్లిక్ చేయండి.",
      "step_windows_1": "బ్రౌజర్‌లో వెబ్‌సైట్ చిరునామాకి ఎడమవైపు లాక్ చిహ్నాన్ని క్లిక్ చేయండి.",
      "step_windows_2": "Locationని కనుగొని Allowకి సెట్ చేయండి.",
      "step_windows_3": "Windows Settings → Privacy & security → Location ఆన్ చేసి, మీ బ్రౌజర్‌కు అనుమతి ఇవ్వండి.",
      "step_windows_4": "ఇక్కడకు తిరిగి వచ్చి Try Again క్లిక్ చేయండి.",
      "timeout_hint": "బ్రౌజర్ లొకేషన్ పాపప్ వచ్చుంటే Allow నొక్కండి. లేకపోతే మళ్లీ ప్రయత్నించండి, లేదా ప్రాంతం పేరు శోధించండి.",
      "timeout_note": "లొకేషన్ కనుగొనడానికి ఎక్కువ సమయం పడుతోంది",
      "title_denied": "లొకేషన్ యాక్సెస్ నిరోధించబడింది",
      "title_generic": "లైవ్ లొకేషన్ అందుబాటులో లేదు",
      "title_timeout": "లొకేషన్ రిక్వెస్ట్ సమయం ముగిసింది",
      "title_unavailable": "పరికరం లొకేషన్‌ను గుర్తించలేకపోయాము",
      "try_again": "మళ్లీ ప్రయత్నించండి",
      "unavailable_hint": "చాలా ల్యాప్‌టాప్‌లు ఖచ్చితమైన GPS ఇవ్వలేవు. ప్రాంతం పేరు శోధించండి, లేదా మ్యాప్‌పై పిన్ లాగండి."
    },
    "location_picker": {
      "desc": "అత్యుత్తమ ఫలితాలను అందించడానికి, మేము మీ నగరాన్ని తెలుసుకోవాలి. దయచేసి స్థాన ప్రాప్యతను అనుమతించండి లేదా మీ నగరాన్ని మాన్యువల్‌గా ఎంచుకోండి.",
      "footer": "మీ దేశం మరియు నగరం మా AI కి మీ ప్రాంతంలో ఖచ్చిన మ్యాచ్చెలు కనుగొనటానికి సహాయపడతాయి.",
      "title": "స్థానం అవసరం"
    },
    "manager": {
      "badge": "ఆస్తి నిర్వాహకులు",
      "desc": "అనేక ఆస్తులను నిర్వహించే నిపుణుల కోసం రూపొందించబడింది - అద్దెదారులను ట్రాక్ చేయండి, వసూళ్లను ఆటోమేట్ చేయండి మరియు ఒక శక్తివంతమైన డ్యాష్‌బోర్డ్ నుండి మీ అద్దె వ్యాపారాన్ని పెంచుకోండి.",
      "features": {
        "analytics_desc": "మీ మొత్తం పోర్ట్‌ఫోలియోలో ఆక్యుపెన్సీ రేట్లు, అద్దె ఆదాయ పోకడలు మరియు ఆస్తి పనితీరుపై నిజ-సమయ అంతర్దృష్టులను పొందండి.",
        "analytics_title": "పోర్ట్‌ఫోలియో అనలిటిక్స్",
        "collections_desc": "సమయానికి చెల్లింపులను పెంచడానికి ఆటోమేటెడ్ రిమైండర్‌లు మరియు పేమెంట్ ట్రాకింగ్‌తో అద్దె వసూళ్లను క్రమబద్ధీకరించండి.",
        "collections_title": "ఆటోమేటెడ్ వసూళ్లు",
        "tenant_desc": "అద్దెదారు కమ్యూనికేషన్లు, లీజు పునరుద్ధరణలు మరియు నిర్వహణ అభ్యర్థనలను ఒకే చోట నిర్వహించండి.",
        "tenant_title": "అద్దెదారు సంబంధాల కేంద్రం"
      },
      "join_btn": "ఆస్తి నిర్వాహకుడిగా చేరండి",
      "no_commitment": "ఎటువంటి నిబద్ధత అవసరం లేదు • నిమిషాల్లో సెటప్ చేయండి",
      "title_1": "మీ పోర్ట్‌ఫోలియోను విస్తరించండి,",
      "title_accent": "సులభంగా."
    },
    "nav_contact": "మమ్మల్ని సంప్రదించండి",
    "nav_features": "ఫీచర్లు",
    "nav_feedback": "ఫీడ్బ్యాక్",
    "nav_get_started": "ప్రారంభించండి",
    "nav_pricing": "ధరలు",
    "nav_signin": "సైన్ ఇన్",
    "no_properties_found": "ఆస్తులేవీ కనుగొనబడలేదు",
    "owner": {
      "badge": "ఆస్తి యజమానులు",
      "desc": "మా AI-ఆధారిత ప్లాట్‌ఫారమ్‌లో తమ ఆస్తులను జాబితా చేసే వేలాది మంది యజమానులతో చేరండి.",
      "post_btn": "ఇప్పుడే మీ ఆస్తిని పోస్ట్ చేయండి",
      "subtitle": "మా ఫ్లెక్సిబుల్ క్రెడిట్ సిస్టమ్‌తో మీరు ఉపయోగించిన దానికి మాత్రమే చెల్లించండి",
      "title_1": "మీ ఆస్తిని జాబితా చేయండి మరియు",
      "title_accent": "ధృవీకరించబడిన అద్దెదారులను తక్షణమే కనుగొనండి"
    },
    "popular": "ప్రసిద్ధమైనవి:",
    "popular_properties": "పాపులర్ ఆస్తులు",
    "popular_properties_desc": "మీ ప్రాంతంలో అత్యుత్తమ డీల్స్ కనుగొనండి",
    "popular_properties_prefix": "ప్రసిద్ధ ఆస్తులు",
    "popular_tags": {
      "bhk_apartments": "3BHK అపార్ట్‌మెంట్లు",
      "bhk_in_city": "{{city}} లో 3BHK",
      "independent_house": "స్వతంత్ర ఇల్లు",
      "pet_friendly": "పెంపుడు జంతు స్నేహపూర్వక",
      "villas_with_pool": "పూల్ ఉన్న విల్లాలు"
    },
    "preferred_agent": "ప్రిఫర్డ్ ఏజెంట్",
    "preferred_agents_desc": "కొనుగోలుదారులు మరియు అద్దెదారులు విశ్వసించే ధృవీకరించబడిన ఆస్తి నిర్వాహకులు",
    "preferred_agents_prefix": "అత్యుత్తమ ఏజెంట్లు",
    "projects": {
      "badge": "కొత్తగా ప్రారంభించబడినవి",
      "card1_desc": "మీ నగరంలో కొత్తగా ప్రారంభించబడిన అన్ని నివాస మరియు వాణిజ్య ప్రాజెక్టుల పూర్తి వివరాలను బ్రౌజ్ చేయండి.",
      "card1_title": "అన్ని కొత్త ప్రాజెక్టుల కోసం డైరెక్టరీ",
      "card2_desc": "భద్రత కోసం అధికారిక నివేదికలు, చట్టపరమైన ఆమోదాలు మరియు RERA రిజిస్ట్రేషన్ వివరాలను యాక్సెస్ చేయండి.",
      "card2_title": "RERA నుండి అన్ని నివేదికలు",
      "card3_desc": "నిపుణుల నుండి నిష్పాక్షిక విశ్లేషణ, పెట్టుబడి సామర్థ్య రేటింగ్స్ మరియు నిర్మాణ నాణ్యత సమీక్షలను పొందండి.",
      "card3_title": "నిపుణుల సమీక్షలు & సలహాలు",
      "desc": "రాబోయే డెవలప్‌మెంట్‌లు, నిబంధనల పాటించటం మరియు నిపుణుల అభిప్రాయాల గురించి మీరు తెలుసుకోవలసిన ప్రతిదీ ఇక్కడ ఉంది.",
      "title": "రాబోయే ప్రాజెక్టులు"
    },
    "search_placeholder": "ప్రయత్నించండి 'హైదరాబాద్‌లో 3 BHK విల్లా' లేదా '15k లోపు అద్దెకు స్టూడియో'...",
    "see_all": "అన్నీ చూడండి",
    "since": "నుండి",
    "theme": "థీమ్"
  },
  "leases_page": {
    "actions": {
      "convert": "మార్చు",
      "reupload_signed": "సంతకం చేసిన లీజును మళ్లీ అప్‌లోడ్ చేయండి",
      "sign_upload": "సైన్ & అప్‌లోడ్",
      "signed_lease": "సంతకం చేసిన లీజు",
      "unsigned_lease": "సంతకం చేయని లీజు",
      "update_lease": "లీజును నవీకరించండి",
      "upload_lease": "లీజును అప్‌లోడ్ చేయండి"
    },
    "add_tenant_btn": "అద్దెదారుని మాన్యువల్‌గా జోడించండి",
    "desc_owner": "మీ యాక్టివ్ లీజులు మరియు వచ్చే లీడ్‌లను నిర్వహించండి.",
    "desc_tenant": "మీ యాక్టివ్ లీజులు, కాంట్రాక్ట్ వివరాలను చూడండి మరియు డాక్యుమెంట్లను సైన్ చేయండి.",
    "errors": {
      "add_failed": "అద్దెదారుని జోడించడంలో విఫలమైంది. దయచేసి వినియోగదారు ఉన్నారని నిర్ధారించుకోండి.",
      "convert_failed": "అద్దెదారుగా మార్చడంలో విఫలమైంది",
      "delete_failed": "రికార్డును తొలగించడంలో విఫలమైంది. దయచేసి మళ్లీ ప్రయత్నించండి.",
      "update_failed": "అద్దెదారు వివరాలను నవీకరించడంలో విఫలమైంది",
      "upload_failed": "ఫైల్ అప్‌లోడ్ చేయడం విఫలమైంది"
    },
    "filters": {
      "reset": "రీసెట్",
      "search_placeholder": "పేరు, ఇమెయిల్, ఆస్తి ద్వారా వెతకండి..."
    },
    "interest_types": {
      "lease": "📝 లీజు",
      "rent": "🏠 అద్దె",
      "sale": "💰 అమ్మకం"
    },
    "modals": {
      "add_manual": {
        "adding": "జోడిస్తోంది...",
        "cancel": "రద్దు చేయి",
        "email_hint": "వినియోగదారు ఈ ఇమెయిల్‌తో నమోదు అయి ఉండాలి.",
        "email_label": "అద్దెదారు ఇమెయిల్ *",
        "email_placeholder": "tenant@example.com",
        "end_label": "లీజు ముగింపు *",
        "no_properties": "మీ నియంత్రణలో ఆస్తులేవీ లేవు.",
        "property_hint": "మీరు నిర్వహించే లేదా యాజమాన్యం గల ఆస్తులు మాత్రమే చూపబడతాయి.",
        "property_label": "ఆస్తిని ఎంచుకోండి *",
        "property_placeholder": "ఒక ఆస్తిని ఎంచుకోండి",
        "rent_label": "నెలవారీ అద్దె (₹) *",
        "start_label": "లీజు ప్రారంభం *",
        "submit": "అద్దెదారుని జోడించండి",
        "subtitle": "ఉన్న వినియోగదారుని యాక్టివ్ అద్దెదారుగా జోడించండి.",
        "title": "అద్దెదారుని మాన్యువల్‌గా జోడించండి"
      },
      "convert": {
        "cancel": "రద్దు చేయి",
        "desc": "ఆస్తి <3>{{property}}</3> వద్ద <1>{{name}}</1> కోసం లీజు వివరాలను సెట్ చేయండి",
        "end_label": "లీజు ముగింపు తేదీ *",
        "rent_label": "నెలవారీ అద్దె (₹) *",
        "start_label": "లీజు ప్రారంభ తేదీ *",
        "submit": "అద్దెదారుగా మార్చండి",
        "title": "యాక్టివ్ అద్దెదారుగా మార్చండి"
      },
      "delete": {
        "cancel": "రద్దు చేయి",
        "desc": "మీరు ఖచ్చితంగా <1>{{name}}</1> రికార్డును తొలగించాలనుకుంటున్నారా?",
        "submit": "రికార్డును తొలగించు",
        "title": "తొలగింపును ధృవీకరించండి",
        "warning": "ఈ చర్యను వెనక్కి తీసుకోలేము."
      },
      "edit": {
        "cancel": "రద్దు చేయి",
        "desc": "<1>{{name}}</1> కోసం లీజు నిబంధనలను నవీకరించండి",
        "end_label": "లీజు ముగింపు తేదీ",
        "rent_label": "నెలవారీ అద్దె (₹)",
        "start_label": "లీజు ప్రారంభ తేదీ",
        "submit": "మార్పులను సేవ్ చేయండి",
        "title": "లీజు వివరాలను సవరించండి",
        "updating": "నవీకరించబడుతోంది..."
      },
      "lease_doc": {
        "cancel": "రద్దు చేయి",
        "desc_sign": "మీ లీజు ఒప్పందం యొక్క సంతకం చేసిన కాపీని అప్‌లోడ్ చేయండి.",
        "desc_upload": "మీ అద్దెదారు సమీక్షించడానికి మరియు సంతకం చేయడానికి లీజు ఒప్పందాన్ని అప్‌లోడ్ చేయండి.",
        "download": "డౌన్‌లోడ్",
        "file_hint": "PDF ఫైళ్లు మాత్రమే, గరిష్టంగా 5MB",
        "select_pdf": "PDF పత్రాన్ని ఎంచుకోండి",
        "submit_replace": "పత్రాన్ని మార్చండి",
        "submit_upload": "పత్రాన్ని అప్‌లోడ్ చేయండి",
        "template": "లీజు ఒప్పంద టెంప్లేట్",
        "title_sign": "సైన్ చేయండి & లీజును అప్‌లోడ్ చేయండి",
        "title_upload": "లీజు పత్రాన్ని అప్‌లోడ్ చేయండి",
        "upload_hint": "ఎంచుకోవడానికి క్లిక్ చేయండి లేదా ఇక్కడకు లాగండి (డ్రాగ్ చేయండి)"
      },
      "view": {
        "close": "మూసివేయి",
        "labels": {
          "email": "ఇమెయిల్ చిరునామా",
          "end": "లీజు ముగింపు",
          "inquiry": "ప్రారంభ విచారణ",
          "property": "ఆస్తి",
          "rent": "నెలవారీ అద్దె",
          "start": "లీజు ప్రారంభం"
        },
        "subtitle": "{{name}} వివరాలను చూస్తున్నారు",
        "title": "అద్దెదారు వివరాలు"
      }
    },
    "status": {
      "active": "యాక్టివ్",
      "application": "దరఖాస్తు",
      "inquiry": "విచారణ"
    },
    "table": {
      "actions": "చర్యలు",
      "anonymous_user": "అజ్ఞాత వినియోగదారు",
      "date": "తేదీ",
      "default_inquiry_message": "నాకు ఈ ఆస్తిపై ఆసక్తి ఉంది.",
      "interest_type": "ఆసక్తి రకం",
      "lead_name": "లీడ్ పేరు",
      "lease_period": "లీజు కాలం",
      "message": "సందేశం",
      "no_active_tenants": "యాక్టివ్ అద్దెదారులు ఎవరూ కనిపించలేదు. విచారణల ట్యాబ్‌ని తనిఖీ చేయాలా?",
      "no_inquiries": "కొత్త విచారణలేవీ లేవు.",
      "property": "ఆస్తి",
      "rent": "అద్దె",
      "status": "స్థితి",
      "tenant": "అద్దెదారు",
      "to": "వరకు"
    },
    "tabs": {
      "active": "యాక్టివ్ అద్దెదారులు",
      "inquiries": "లీడ్‌లు & విచారణలు"
    },
    "title_owner": "అద్దెదారులు & విచారణలు",
    "title_tenant": "నా లీజులు & రికార్డులు",
    "toasts": {
      "fill_required": "దయచేసి అవసరమైన అన్ని ఫీల్డ్‌లను పూరించండి.",
      "lease_doc_uploaded": "లీజు పత్రం విజయవంతంగా అప్‌లోడ్ చేయబడింది!",
      "signed_lease_uploaded": "సంతకం చేసిన లీజు విజయవంతంగా అప్‌లోడ్ చేయబడింది!",
      "tenant_added": "అద్దెదారు విజయవంతంగా జోడించబడ్డారు!"
    }
  },
  "listing_questions": {
    "location_set_success": ""
  },
  "location": {
    "choose_city": "మీ నగరాన్ని ఎంచుకోండి",
    "choose_country": "దేశాన్ని ఎంచుకోండి",
    "city_label": "నగరం",
    "city_loading": "నగరాలు లోడ్ అవుతున్నాయి…",
    "country_label": "దేశం",
    "country_loading": "దేశాలు లోడ్ అవుతున్నాయి…",
    "just_open_map": "{{zoneName}} కోసం మ్యాప్‌ను తెరవండి",
    "no_cities": "ఈ దేశానికి ఎనేబల్ చేసిన నగరాలు లేవు.",
    "no_countries": "మద్దతు కాని దేశాలు కాన్ఫిగర్ కాలేదు.",
    "search_city": "నగరాలను వెతుకోండి…",
    "select_area_in": "{{zoneName}} లో ప్రాంతాన్ని ఎంచుకోండి",
    "tap_area_hint": "ఒక ప్రాంతాన్ని నొక్కండి లేదా క్రింద మీ పరిసర ప్రాంతాన్ని మాట్లాడండి/టైప్ చేయండి"
  },
  "maintenance": {
    "admin_notice": "నిర్వహణ అడ్మిన్ నోటీసు",
    "check_back": "తరువాత మళ్లీ తనిఖీ చేయండి",
    "description": "నిర్వహణ వివరణ",
    "title": "నిర్వహణ శీర్షిక"
  },
  "maintenance_dashboard": {
    "card": {
      "reported": "నివేదించబడింది:",
      "status": "స్థితి:"
    },
    "empty": {
      "subtitle": "మీ పోర్ట్‌ఫోలియోలో అంతా బాగానే ఉంది!",
      "title": "నిర్వహణ అభ్యర్థనలు కనుగొనబడలేదు"
    },
    "filter_status": "స్థితి ఫిల్టర్",
    "filters": {
      "all": "అన్ని అభ్యర్థనలు"
    },
    "modal": {
      "category": "వర్గం",
      "category_placeholder": "ఏమి సమస్య?",
      "choose_property": "ఒక ఆస్తిని ఎంచుకోండి",
      "description": "మీ నిర్వహిత ఆస్తులలో ఒకదానికి కొత్త మరమ్మతు లేదా నిర్వహణ అభ్యర్థనను సమర్పించండి.",
      "description_for_property": "{{propertyName}} వద్ద ఏదైనా సరిచేయాలా? మాకు తెలియజేయండి.",
      "description_placeholder": "సమస్య, యూనిట్‌లో స్థానం మరియు అత్యవసర వివరాలను వివరించండి...",
      "issue_description": "సమస్య వివరణ",
      "issue_details": "సమస్య వివరాలు",
      "issue_details_placeholder": "ఏమి జరుగుతోందో వివరించండి...",
      "no_properties": "ఆస్తులు అందుబాటులో లేవు",
      "priority": "ప్రాధాన్యత",
      "select_property": "ఆస్తిని ఎంచుకోండి",
      "submit": "అభ్యర్థనను సమర్పించండి",
      "title": "నిర్వహణ సమస్యను నివేదించండి"
    },
    "priority_detail": {
      "high": "ఎక్కువ - అత్యవసరం",
      "low": "తక్కువ - రొటీన్",
      "medium": "మధ్యస్థ - త్వరలో",
      "urgent": "అత్యవసరం - ఎమర్జెన్సీ"
    },
    "property_fallback": "ఆస్తి ({{id}}...)",
    "report_issue": "సమస్యను నివేదించండి",
    "status": {
      "assigned": "కేటాయించబడింది",
      "cancelled": "రద్దు",
      "completed": "పూర్తయింది",
      "in_progress": "ప్రగతిలో",
      "pending": "పెండింగ్"
    },
    "subtitle": "మీ నిర్వహిత ఆస్తులలో మరమ్మతు అభ్యర్థనలను ట్రాక్ చేసి నిర్వహించండి.",
    "title": "నిర్వహణ డాష్‌బోర్డ్",
    "toasts": {
      "description_required": "దయచేసి సమస్య వివరణను ఇవ్వండి",
      "fields_required": "దయచేసి అన్ని అవసరమైన ఫీల్డ్‌లను పూరించండి",
      "select_property": "దయచేసి ఒక ఆస్తిని ఎంచుకోండి",
      "status_update_failed": "స్థితిని నవీకరించడంలో విఫలమైంది",
      "status_updated": "స్థితి {{status}}కి నవీకరించబడింది",
      "submit_failed": "నిర్వహణ అభ్యర్థన సృష్టించడంలో విఫలమైంది",
      "submit_success": "నిర్వహణ అభ్యర్థన విజయవంతంగా సమర్పించబడింది!"
    }
  },
  "messages_page": {
    "compose_placeholder": "మీ సందేశాన్ని వ్రాయండి...",
    "default_agent_message": "హాయ్! మీ జాబితా చేసిన ఆస్తులపై నాకు ఆసక్తి ఉంది.",
    "empty_inbox_description": "ఆస్తుల గురించి సందేశాలను చూడటానికి సైడ్‌బార్ నుండి ఒక సంభాషణను ఎంచుకోండి.",
    "empty_inbox_title": "మీ ఇన్‌బాక్స్",
    "errors": {
      "auth_timeout": "మెసేజింగ్ సైన్-ఇన్ సమయం ముగిసింది. దయచేసి పేజీని రిఫ్రెష్ చేసి మళ్లి ప్రయత్నించండి.",
      "load_failed": "సంభాషణలు లోడ్ చేయడంలో విఫలమైంది. దయచేసి రిఫ్రెష్ చేసి మళ్లి ప్రయత్నించండి.",
      "load_title": "సందేశాలు లోడ్ కాలేదు",
      "send_failed": "సందేశం పంపడంలో విఫలమైంది. దయచేసి మళ్ళీ ప్రయత్నించండి.",
      "start_conversation_failed": "సంభాషణ ప్రారంభించడంలో విఫలమైంది. దయచేసి మళ్లి ప్రయత్నించండి.",
      "voice_send_failed": "వాయిస్ సందేశం పంపడంలో విఫలమైంది. దయచేసి మళ్లి ప్రయత్నించండి."
    },
    "fallback_initials": "U",
    "fallback_user": "వినియోగదారు",
    "inbox": "ఇన్‌బాక్స్",
    "loading_conversations": "సంభాషణలు లోడ్ అవుతున్నాయి...",
    "login_required": "సందేశాలను చూడటానికి దయచేసి లాగిన్ అవండి",
    "no_history_hint": "మొదటి సందేశం పంపి చర్చను ప్రారంభించండి.",
    "no_history_title": "సంభాషణ చరిత్ర లేదు",
    "no_results_hint": "పేరు లేదా ఆస్తి పేరుతో శోధించడానికి ప్రయత్నించండి",
    "no_results_title": "ఫలితాలు కనుగొనబడలేదు",
    "privacy_alert": {
      "cancel_edit": "రద్దు చేసి సవరించండి",
      "description": "మీ సందేశంలో సంప్రదింపు సమాచారాన్ని గుర్తించాము. మీ భద్రత కోసం, అన్ని సంభాషణలను ప్లాట్‌ఫారమ్ లోపలే ఉంచమని మేము సిఫారసు చేస్తాము.",
      "preview_label": "సందేశ ప్రివ్యూ",
      "send_masked": "మాస్క్ చేసిన సందేశం పంపండి",
      "title": "గోప్యత హెచ్చరిక"
    },
    "property_card": {
      "badge": "",
      "untitled": ""
    },
    "property_info": {
      "load_failed": "",
      "loading": "",
      "missing_id": "",
      "open": ""
    },
    "ready_to_chat": "చాట్ చేయడానికి సిద్ధం",
    "search_placeholder": "సంభాషణలను శోధించండి...",
    "title": "సందేశాలు",
    "voice": {
      "duration": "{{seconds}}సె",
      "start": "వాయిస్ సందేశం రికార్డ్ చేయండి",
      "stop": "రికార్డింగ్ ఆపండి"
    }
  },
  "not_available": "",
  "notifications": {
    "delete": "తొలగించు",
    "failed_to_delete": "నోటిఫికేషన్‌ను తొలగించడంలో విఫలమైంది",
    "failed_to_load": "నోటిఫికేషన్‌లను లోడ్ చేయడంలో విఫలమైంది",
    "failed_to_mark_read": "నోటిఫికేషన్‌ను చదివినట్లు గుర్తించడంలో విఫలమైంది",
    "mark_as_read": "చదివినట్లు గుర్తించు",
    "new_count_one": "{{count}} కొత్తవి",
    "new_count_other": "{{count}} కొత్తవి",
    "no_notifications": "నోటిఫికేషన్‌లు లేవు",
    "templates": {
      "new_subscription": "కొత్త సబ్‌స్క్రిప్షన్ కొనుగోలు చేయబడింది!",
      "new_subscription_title": "💰 కొత్త సబ్‌స్క్రిప్షన్",
      "new_user_registration": "కొత్త వినియోగదారు నమోదు చేసుకున్నారు:\n\n👤 పేరు: {{userName}}\n📧 ఇమెయిల్: {{userEmail}}\n🏷️ పాత్ర: {{userRole}}\n📝 రకం: {{registrationType}}",
      "new_user_registration_title": "🎉 కొత్త వినియోగదారు నమోదు"
    },
    "time": {
      "days_ago_one": "{{count}} రోజు క్రితం",
      "days_ago_other": "{{count}} రోజుల క్రితం",
      "hours_ago_one": "{{count}} గంట క్రితం",
      "hours_ago_other": "{{count}} గంటల క్రితం",
      "just_now": "ఇప్పుడే",
      "minutes_ago_one": "{{count}} నిమిషం క్రితం",
      "minutes_ago_other": "{{count}} నిమిషాల క్రితం"
    },
    "title": "నోటిఫికేషన్‌లు"
  },
  "org_billing": {
    "add_credits": "సంస్థకి క్రెడిట్లు జోడండి",
    "admin_description": "మీ సంస్థ భాగస్వామ్య వాలెట్ను నిర్వహించి సభ్యుల వినియోగాన్ని సమీక్షించండి.",
    "contact_admin": "క్రెడిట్లు జోడడానికి మీ సంస్థ నిర్వాహకుడను సంప్రదించండి.",
    "last_n_days": "గత గత {{days}} రోజులు",
    "ledger_desc": "సంస్థ కోసం ಇమిడిపి క్రెడిట్ కదలికలు.",
    "member": "సభ్యుడు",
    "member_description": "మీ సంస్థ బ్యాలన్స్ మరియు మీ వినియోగ వాటాను చూడండి.",
    "shared_balance": "భాగస్వామ్య వాలెట్ బ్యాలన్స్",
    "shared_balance_desc": "అన్ని సంస్థ సభ్యులకి అందుబాటులో ఉన్న క్రెడిట్లు.",
    "shared_balance_note": "అన్ని జట్టు సభ్యులకి సాధారణ. వినియోగ ఈ బ్యాలన్స్ నుండి తీసుకుంది.",
    "title": "వినియోగ & బిల్లింగ్",
    "topup_success": "సంస్థ వాలెట్కి క్రెడిట్లు విజయవంతంగా జోడబడ్డాయి.",
    "usage_summary": "వినియోగ సారాంశం"
  },
  "organizations": {
    "add_user_modal": {
      "add_user": "వినియోగదారుని జోడించండి",
      "cancel": "రద్దు చేయి",
      "city": "నగరం",
      "creating": "సృష్టిస్తోంది...",
      "description": "కొత్త వినియోగదారుని సృష్టించండి. వినియోగదారుడు తమ ఖాతాను సక్రియం చేయడానికి ఒక ఇమెయిల్ అందుకుంటారు.",
      "email": "ఇమెయిల్",
      "error_fields": "దయచేసి అవసరమైన అన్ని ఖాళీలను పూరించండి.",
      "error_org_required": "ఎంచుకున్న పాత్రకు సంస్థ అవసరం.",
      "error_pm_details": "ప్రాపర్టీ మేనేజర్లకు ఫోన్ మరియు నగరం అవసరం.",
      "first_name": "మొదటి పేరు",
      "last_name": "చివరి పేరు",
      "organization": "సంస్థ",
      "password": "పాస్‌వర్డ్",
      "phone": "ఫోన్ నంబర్",
      "role": "పాత్ర",
      "select_organization": "సంస్థను ఎంచుకోండి",
      "select_role": "పాత్రను ఎంచుకోండి",
      "success": "వినియోగదారుడు విజయవంతంగా సృష్టించబడ్డాడు మరియు ఇప్పుడు క్రియాశీలంగా ఉన్నాడు!",
      "title": "వినియోగదారుని జోడించండి",
      "username": "వినియోగదారు పేరు"
    },
    "add_user_to_org": "బిల్డర్‌కు వినియోగదారుని జోడించండి",
    "add_user_to_org_modal": {
      "add_user": "వినియోగదారుని జోడించు",
      "adding": "చేరుస్తోంది...",
      "cancel": "రద్దు చేయి",
      "description": "ఒక నిర్దిష్ట పాత్రతో ఒక వినియోగదారుని బిల్డర్‌కు చేర్చండి. సూపర్ అడ్మిన్‌లు మాత్రమే ఏ బిల్డర్‌కైనా వినియోగదారులను చేర్చగలరు.",
      "error_failed": "బిల్డర్‌కు వినియోగదారుని జోడించడం విఫలమైంది",
      "org_admin": "బిల్డర్ అడ్మిన్",
      "org_member": "బిల్డర్ సభ్యుడు",
      "organization": "బిల్డర్",
      "role": "పాత్ర",
      "select_organization": "బిల్డర్‌ను ఎంచుకోండి",
      "select_role": "పాత్రను ఎంచుకోండి",
      "title": "బిల్డర్‌కు వినియోగదారుని జోడించండి",
      "user": "వినియోగదారు"
    },
    "card": {
      "description": "మీ సిస్టమ్‌లోని అన్ని బిల్డర్‌ల జాబితా.",
      "title": "అన్ని బిల్డర్‌లు"
    },
    "create_org": "బిల్డర్‌ను సృష్టించండి",
    "create_org_modal": {
      "cancel": "రద్దు చేయి",
      "create": "బిల్డర్‌ను సృష్టించండి",
      "creating": "సృష్టిస్తోంది...",
      "description": "ఒక కొత్త బిల్డర్‌ను సృష్టించండి. సూపర్ అడ్మిన్‌లు మాత్రమే బిల్డర్‌లను సృష్టించగలరు.",
      "error_failed": "బిల్డర్‌ను సృష్టించడంలో విఫలమైంది",
      "org_desc": "వివరణ",
      "org_desc_placeholder": "బిల్డర్ వివరణను నమోదు చేయండి",
      "org_name": "బిల్డర్ పేరు",
      "org_name_placeholder": "బిల్డర్ పేరును నమోదు చేయండి",
      "org_slug": "బిల్డర్ స్లగ్",
      "org_slug_placeholder": "బిల్డర్-స్లగ్",
      "slug_hint": "బిల్డర్‌కు URL-స్నేహపూర్వక ఐడెంటిఫైయర్",
      "title": "బిల్డర్‌ను సృష్టించండి"
    },
    "delete_org_modal": {
      "confirm": "\"{{name}}\" తొలగించాలా?",
      "delete_btn": "బిల్డర్‌ను తొలగించండి",
      "deleting": "తొలగిస్తోంది...",
      "details_title": "బిల్డర్ వివరాలు",
      "error_failed": "బిల్డర్‌ను తొలగించడం విఫలమైంది. దయచేసి మళ్ళీ ప్రయత్నించండి.",
      "impact_members": "అన్ని బిల్డర్ సభ్యులు (అనాథులు)",
      "impact_properties": "అన్ని బిల్డర్ ఆస్తులు మరియు డేటా",
      "title": "బిల్డర్‌ను తొలగించండి",
      "warning": "ఈ చర్యను రద్దు చేయలేము. ఈ బిల్డర్‌కు సంబంధించిన అన్ని డేటా శాశ్వతంగా తొలగించబడుతుంది."
    },
    "edit_org_modal": {
      "desc_placeholder": "బిల్డర్ వివరణను నమోదు చేయండి",
      "description": "బిల్డర్ వివరాలను నవీకరించండి.",
      "error_failed": "బిల్డర్‌ను నవీకరించడం విఫలమైంది",
      "name_label": "బిల్డర్ పేరు",
      "name_placeholder": "బిల్డర్ పేరును నమోదు చేయండి",
      "slug_label": "బిల్డర్ స్లగ్",
      "slug_placeholder": "బిల్డర్-స్లగ్",
      "title": "బిల్డర్‌ను సవరించండి"
    },
    "errors": {
      "fetch_failed": "బిల్డర్‌లను పొందడంలో విఫలమైంది."
    },
    "invite_org_modal": {
      "cancel": "రద్దు చేయండి",
      "description": "కొత్త బిల్డర్‌ను సెటప్ చేయడానికి ఆహ్వాన ఇమెయిల్‌ను పంపండి",
      "email_label": "ఇమెయిల్ చిరునామా",
      "email_placeholder": "ఇమెయిల్ చిరునామాను నమోదు చేయండి",
      "error_generic": "ఆహ్వానాన్ని పంపేటప్పుడు లోపం సంభవించింది.",
      "error_invalid_email": "దయచేసి చెల్లుబాటు అయ్యే ఇమెయిల్ చిరునామాను నమోదు చేయండి.",
      "message_label": "సందేశం (ఐచ్ఛికం)",
      "message_placeholder": "ఆహ్వానానికి వ్యక్తిగత సందేశాన్ని జోడించండి...",
      "send": "ఆహ్వానం పంపండి",
      "sending": "పంపుతోంది...",
      "success_message": "{{email}}కి ఆహ్వానం విజయవంతంగా పంపబడింది",
      "title": "బిల్డర్‌ను సెటప్ చేయడానికి ఆహ్వానించండి"
    },
    "invite_to_setup": "బిల్డర్‌ను సెటప్ చేయడానికి ఆహ్వానించండి",
    "loading": "బిల్డర్‌లను లోడ్ చేస్తోంది...",
    "search_placeholder": "బిల్డర్‌లను శోధించండి...",
    "subtitle": "బిల్డర్‌లను మరియు వాటి సెట్టింగ్‌లను నిర్వహించండి.",
    "table": {
      "actions": "చర్యలు",
      "created": "సృష్టించబడింది",
      "id": "ఐడి",
      "name": "పేరు",
      "verified": "ధృవీకరించబడింది"
    },
    "title": "బిల్డర్‌లు",
    "total": "మొత్తం",
    "users": {
      "card": {
        "description": "మీ సంస్థలోని అన్ని వినియోగదారుల జాబితా.",
        "title": "సంస్థ సభ్యులు"
      },
      "fetch_failed": "సంస్థ వినియోగదారులను పొందడంలో విఫలమైంది.",
      "filters": {
        "all_status": "అన్ని స్థితి",
        "invited": ""
      },
      "invite": "వినియోగదారుని ఆహ్వానించండి",
      "remove": "వినియోగదారుని తొలగించండి",
      "search_placeholder": "వినియోగదారులను శోధించండి...",
      "status": {
        "invited": ""
      },
      "subtitle": "మీ సంస్థలోని వినియోగదారులను నిర్వహించండి.",
      "table": {
        "actions": "చర్యలు",
        "created": "సృష్టించబడింది",
        "name": "పేరు",
        "role": "పాత్ర",
        "status": "స్థితి",
        "username": "వినియోగదారు పేరు",
        "verified": "ధృవీకరించబడింది"
      },
      "title": "సంస్థ వినియోగదారులు",
      "total": "మొత్తం వినియోగదారులు"
    }
  },
  "owner_stats": {
    "active_now": "ఇప్పుడు క్రియాశీలం",
    "manage_all": "అన్ని లిస్టింగ్‌లను నిర్వహించండి",
    "post_new": "కొత్త లిస్టింగ్ పోస్ట్ చేయండి",
    "total_listings": "మొత్తం లిస్టింగ్‌లు",
    "total_views": "మొత్తం వ్యూలు"
  },
  "payment_success": {
    "actions": {
      "go_to_dashboard": "డ్యాష్‌బోర్డ్‌కి వెళ్ళండి",
      "go_to_plans": "ప్లాన్స్‌కి వెళ్ళండి",
      "manage_subscription": "సబ్‌స్క్రిప్షన్ నిర్వహించండి"
    },
    "error_state": {
      "title": "చెల్లింపు ధృవీకరణ విఫలమైంది"
    },
    "errors": {
      "no_payment_info": "చెల్లింపు సమాచారం లేదు",
      "unknown": "తెలియని లోపం ఏర్పడింది.",
      "verification_failed": "చెల్లింపు ధృవీకరణ విఫలమైంది"
    },
    "loading": {
      "description": "దయచేసి వేచి ఉండండి, మీ సబ్‌స్క్రిప్షన్‌ను నిర్ధారిస్తున్నాం.",
      "title": "మీ చెల్లింపు ధృవీకరించబడుతోంది..."
    },
    "subscription_details": {
      "billing_cycle": "బిల్లింగ్ సైకిల్",
      "next_billing_date": "తదుపరి బిల్లింగ్ తేదీ",
      "plan": "ప్లాన్",
      "status": "స్థితి",
      "title": "సబ్‌స్క్రిప్షన్ వివరాలు"
    },
    "success_state": {
      "description": "మీ చెల్లింపు విజయవంతంగా ప్రాసెస్ అయింది మరియు మీ సబ్‌స్క్రిప్షన్ ఇప్పుడు యాక్టివ్‌లో ఉంది.",
      "subtitle": "మీ సబ్‌స్క్రిప్షన్‌కు ధన్యవాదాలు",
      "title": "చెల్లింపు విజయవంతమైంది!"
    }
  },
  "plans": {
    "add_plan_btn": "ప్లాన్‌ను జోడించండి",
    "autogenerate_btn": "ప్లాన్‌లను స్వయంచాలకంగా సృష్టించండి",
    "description": "మీ సబ్‌స్క్రిప్షన్ ప్లాన్‌లు మరియు ధరలను నిర్వహించండి.",
    "no_plans": {
      "description": "మీ మొదటి ప్లాన్‌ను సృష్టించడం ద్వారా లేదా కొన్ని డిఫాల్ట్ ప్లాన్‌లను స్వయంచాలకంగా రూపొందించడం ద్వారా ప్రారంభించండి.",
      "title": "ప్లాన్‌లు లేవు"
    },
    "search_placeholder": "ప్లాన్‌లను వెతకండి...",
    "table": {
      "description": "మీ సిస్టమ్‌లోని అన్ని సబ్‌స్క్రిప్షన్ ప్లాన్‌ల జాబితా.",
      "title": "అన్ని ప్లాన్‌లు"
    },
    "title": "ప్లాన్‌లు",
    "types": {
      "business": "వ్యాపారం",
      "single": "సింగిల్"
    }
  },
  "pricing_page": {
    "ai_smart_search_card": {
      "ai_powered": "AI పవర్డ్",
      "cta": "సెర్చ్ ప్రారంభించండి",
      "deep_insights": "లోతైన అంతర్దృష్టులు",
      "desc": "సెకన్లలో మీకు కావాల్సిన వాటిని కనుగొనడానికి AI శక్తిని ఉపయోగించండి.",
      "feature1": "సహజ భాషా ప్రశ్నలు",
      "feature2": "పరిసర ప్రాంత విశ్లేషణ",
      "feature3": "మార్కెట్ ట్రెండ్ డేటా",
      "feature4": "స్థానిక అంతర్దృష్టులు & స్కోర్లు",
      "feature5": "సెర్చ్ ప్రాధాన్యతలను సేవ్ చేయండి",
      "intelligence": "ఇంటెలిజెన్స్",
      "title": "AI స్మార్ట్ సెర్చ్"
    },
    "badge": "ఫ్లెక్సిబుల్ ధరలు",
    "buy_credits_card": {
      "any_amount": "ఎంత మొత్తమైనా",
      "badge": "ఫ్లెక్సిబుల్",
      "cta": "ఇప్పుడే టాప్ అప్ చేయండి",
      "feature1": "సురక్షితమైన స్ట్రైప్ చెల్లింపులు",
      "feature2": "తక్షణ బ్యాలెన్స్ అప్‌డేట్",
      "feature3": "అన్ని AI ఫీచర్ల కోసం ఉపయోగించండి",
      "feature4": "నెలవారీ నిబద్ధతలు లేవు",
      "feature5": "పూర్తి లావాదేవీ చరిత్ర",
      "never_expires": "ఎప్పటికీ గడువు ముగియదు",
      "subtext": "మీ వాలెట్‌కు $0.50 USD నుండి ప్రారంభించి ఎంతైనా జోడించవచ్చు.",
      "title": "క్రెడిట్‌లను కొనుగోలు చేయండి",
      "validity": "చెల్లుబాటు"
    },
    "desc": "మీరు ఉపయోగించే కొద్దీ క్రెడిట్‌లను కొనుగోలు చేయండి. నెలవారీ నిబద్ధతలు లేవు, దాచిన రుసుములు లేవు. ప్రతి టాప్-అప్‌తో అన్ని ప్రీమియం AI ఫీచర్లు చేర్చబడతాయి.",
    "property_listings_card": {
      "cta": "ఆస్తిని జాబితా చేయండి",
      "desc": "మీ ఆస్తులను జాబితా చేయడానికి మరియు వేలాది మంది ధృవీకరించబడిన కొనుగోలుదారులను చేరుకోవడానికి క్రెడిట్‌లను ఉపయోగించండి.",
      "exposure": "ఎక్స్‌పోజర్",
      "feature1": "వెరిఫైడ్ ఓనర్ బ్యాడ్జ్",
      "feature2": "అపరిమిత విచారణలు",
      "feature3": "లీడ్ మేనేజ్‌మెంట్ సాధనాలు",
      "feature4": "స్మార్ట్ లీడ్ ఫిల్టరింగ్",
      "feature5": "నేరుగా సందేశం పంపడం",
      "high_visibility": "అధిక దృశ్యమానత",
      "list_reach": "జాబితా చేయండి & చేరుకోండి",
      "title": "ప్రాపర్టీ జాబితాలు"
    },
    "title": "సాధారణ, క్రెడిట్ ఆధారిత ధరలు"
  },
  "privacy_policy": {
    "last_updated": "చివరిగా నవీకరించబడింది: అక్టోబర్ 29, 2026",
    "sections": {
      "ai": {
        "body_1": "",
        "body_2_prefix": "",
        "body_2_suffix": "",
        "items": {
          "image_search": {
            "label": "",
            "value": "If you use image-based property search, uploaded images are analyzed by AI/embedding models to identify property characteristics. Images used only for a one-off search request are not kept as permanent listing media unless you separately upload them to a listing."
          },
          "listing_assistant": {
            "label": "Listing Assistant (GenUI):",
            "value": "When you use conversational listing tools, messages and extracted listing fields are processed to build and update your draft or published listing."
          },
          "natural_language": {
            "label": "",
            "value": "Your search and listing prompts may be processed by large language models (including Google Gemini and related AI services) to interpret intent and generate responses. Prompt text may be sent to those providers under their data processing terms."
          },
          "recommendations": {
            "label": "",
            "value": ""
          },
          "voice_input": {
            "label": "",
            "value": "If you use voice search or voice listing input, audio is converted to text via speech services such as Sarvam AI and/or the browser Web Speech API. We do not permanently retain raw audio recordings. Transcripts may be cached briefly; duration and provider usage may be logged for billing and reliability."
          }
        },
        "title": "5. AI & ఆటోమేటెడ్ ప్రాసెసింగ్"
      },
      "changes": {
        "body_1": "",
        "body_2": "",
        "items": {
          "email_notice": "",
          "last_updated": "",
          "platform_notice": ""
        },
        "title": "13. ఈ గోప్యతా విధానంలో మార్పులు"
      },
      "children": {
        "body_prefix": "",
        "body_suffix": "",
        "title": "11. పిల్లల గోప్యత"
      },
      "collect": {
        "payment": {
          "body": "We use Stripe as our payment processor for subscriptions, plan changes, and credit/wallet top-ups where enabled. We do not store your full credit or debit card details on our servers. Stripe collects and processes payment data in accordance with PCI-DSS standards. We retain transaction IDs, plan or credit purchase details, wallet balance metadata, and billing history needed for accounting and support.",
          "title": "2.4 చెల్లింపు సమాచారం"
        },
        "personal": {
          "body": "నమోదు సమయంలో మీరు స్వచ్ఛందంగా అందించే సమాచారాన్ని మేము సేకరిస్తాం:",
          "items": {
            "credentials": "",
            "location": "",
            "name_contact": "",
            "organization": "Organization or builder name and related business account details (for org / business accounts)",
            "photo": "",
            "verification": "Identity verification details when enabled for your account (for example, Aadhaar verification via DigiLocker through our verification partner). We store limited verification status and, where provided, masked identifiers such as the last four digits—not your full Aadhaar number on our servers."
          },
          "title": "2.1 వ్యక్తిగత సమాచారం"
        },
        "property": {
          "body": "మీరు యజమాని/మేనేజర్ అయితే, మీరు జాబితా చేసే ఆస్తుల వివరాలను సేకరిస్తాం:",
          "items": {
            "address": "",
            "details": "",
            "history": "",
            "import_sources": "Listing content you import (for example spreadsheet rows, free-text paragraphs, or property portal URLs you submit for scraping/enrichment)",
            "media": "Photographs, videos, documents, and virtual tour content uploaded for listings",
            "pricing": ""
          },
          "title": "2.2 ఆస్తి సమాచారం"
        },
        "title": "2. మేము సేకరించే సమాచారం",
        "usage": {
          "body": "వేదికను ఉపయోగించినప్పుడు కొన్ని సాంకేతిక వివరాలు స్వయంచాలకంగా సేకరించబడతాయి:",
          "items": {
            "behavior": "",
            "device": "",
            "diagnostics": "Application error and performance diagnostics (for example via Sentry), which may include technical context needed to fix issues",
            "location_data": "",
            "maps": "Map interactions and geocoding requests (for example Google Maps / Places) when you set or search locations, including approximate coordinates you confirm on a map pin",
            "messages": "In-app notifications and message delivery metadata when realtime messaging features are enabled",
            "referral": "",
            "search_queries": "",
            "voice": "Voice input used for search or listing: audio is streamed or uploaded for speech-to-text (for example Sarvam AI or on-device Web Speech). We do not permanently store raw audio files. Transcript text may be cached briefly (typically up to about 30 minutes) to improve reliability, and usage metrics (such as duration) may be logged for billing and quality."
          },
          "title": "2.3 వినియోగ & సాంకేతిక డేటా"
        }
      },
      "contact": {
        "body": "",
        "email": "ఇమెయిల్:",
        "security": "భద్రతా సమస్యలు:",
        "sla": "గోప్యతా సంబంధిత అభ్యర్థనలకు 30 క్యాలెండర్ రోజుల్లో స్పందించడానికి మేము ప్రయత్నిస్తాము.",
        "support": "సాధారణ సహాయం:",
        "team": "LetMeIn AI — గోప్యతా బృందం",
        "title": "14. మమ్మల్ని సంప్రదించండి"
      },
      "cookies": {
        "body_1": "మీ అనుభవాన్ని మెరుగుపరచడానికి మేము కుకీలు మరియు సమాన ట్రాకింగ్ సాంకేతికతలను ఉపయోగిస్తాము.",
        "body_2": "మీ బ్రౌజర్ సెట్టింగ్స్ ద్వారా కుకీలను నియంత్రించవచ్చు; కొన్ని కుకీలు ఆపితే ఫీచర్లు ప్రభావితం కావచ్చు.",
        "items": {
          "analytics": {
            "label": "",
            "value": ""
          },
          "essential": {
            "label": "",
            "value": ""
          },
          "preference": {
            "label": "",
            "value": ""
          },
          "third_party": {
            "label": "",
            "value": ""
          }
        },
        "title": "4. కుకీలు & ట్రాకింగ్ సాంకేతికతలు",
        "types_title": "మేము ఉపయోగించే కుకీల రకాలు"
      },
      "introduction": {
        "body_1": "Welcome to LetMeIn AI. We are an AI-powered real estate platform connecting property seekers, owners, organizations, and property managers. We primarily operate in India and may support additional markets when enabled for your account. We are committed to protecting your personal information and your right to privacy.",
        "body_2": "ఈ విధానం మీ సమాచారాన్ని మేము ఎలా సేకరిస్తాం, ఉపయోగిస్తాం, పంచుకుంటాం, రక్షిస్తామో వివరిస్తుంది.",
        "title": "1. పరిచయం"
      },
      "retention": {
        "body_1": "",
        "body_2": "",
        "items": {
          "account": {
            "label": "",
            "value": ""
          },
          "listings": {
            "label": "",
            "value": ""
          },
          "logs": {
            "label": "",
            "value": ""
          },
          "marketing": {
            "label": "",
            "value": ""
          },
          "transactions": {
            "label": "",
            "value": "Retained for 7 years (or as required by applicable financial and tax rules), including credit/wallet purchase records."
          },
          "voice": {
            "label": "Voice Transcripts:",
            "value": "Raw audio is not permanently stored by us. Short-lived transcript cache entries (when enabled) typically expire within about 30 minutes."
          }
        },
        "title": "7. డేటా నిల్వ"
      },
      "rights": {
        "body_1": "Depending on your location and applicable law—including India’s Digital Personal Data Protection Act, 2023 (DPDP) where it applies—you may have the following rights with respect to your personal data:",
        "body_2_prefix": "",
        "body_2_suffix": "",
        "items": {
          "access": {
            "label": "",
            "value": ""
          },
          "erasure": {
            "label": "",
            "value": ""
          },
          "object": {
            "label": "",
            "value": ""
          },
          "portability": {
            "label": "",
            "value": ""
          },
          "rectification": {
            "label": "",
            "value": ""
          },
          "restriction": {
            "label": "",
            "value": ""
          },
          "withdraw": {
            "label": "",
            "value": ""
          }
        },
        "title": "9. మీ గోప్యతా హక్కులు"
      },
      "security": {
        "body_1": "",
        "body_2_prefix": "",
        "items": {
          "access": "",
          "audits": "",
          "https": "",
          "infrastructure": "",
          "passwords": "",
          "tokens": ""
        },
        "title": "8. డేటా భద్రత"
      },
      "sharing": {
        "body": "",
        "items": {
          "business": {
            "label": "",
            "value": ""
          },
          "consent": {
            "label": "",
            "value": ""
          },
          "legal": {
            "label": "",
            "value": ""
          },
          "listings": {
            "label": "",
            "value": ""
          },
          "providers": {
            "label": "",
            "value": "With trusted vendors who assist in operating our platform (for example Stripe for payments, Firebase/Google for authentication and AI, AWS for hosting and media storage, Sarvam AI for speech-to-text, Google Maps for location services, Pusher for realtime notifications, and error-monitoring providers such as Sentry), under appropriate contractual safeguards."
          }
        },
        "title": "6. మీ సమాచారాన్ని పంచుకోవడం"
      },
      "third_party": {
        "body_1": "",
        "body_2": "",
        "items": {
          "aws": {
            "label": "Amazon Web Services (AWS):",
            "link_text": "AWS Privacy",
            "value": "Application hosting and object storage / CDN for property media (for example via S3 and CloudFront on media.letmein.ai)."
          },
          "facebook": {
            "label": "Facebook (Meta):",
            "link_text": "Meta Privacy Policy",
            "value": "Optional social login via Facebook OAuth when enabled."
          },
          "google": {
            "label": "Google (Firebase, Gemini AI & Maps):",
            "link_text": "Google Privacy Policy",
            "value": "Authentication, App Check / reCAPTCHA, AI-powered search and listing assistance, and Maps / Places / geocoding features."
          },
          "pusher": {
            "label": "Pusher:",
            "link_text": "Pusher Privacy Policy",
            "value": "Realtime in-app notifications and presence when messaging features are enabled."
          },
          "sarvam": {
            "label": "Sarvam AI:",
            "link_text": "Sarvam",
            "value": "Speech-to-text for voice search and voice listing input when Sarvam is enabled for your deployment."
          },
          "sentry": {
            "label": "Sentry:",
            "link_text": "Sentry Privacy Policy",
            "value": "Application error and performance monitoring to keep the service reliable."
          },
          "stripe": {
            "label": "Stripe:",
            "link_text": "Stripe Privacy Policy",
            "value": "Payment processing for subscriptions and credit/wallet top-ups."
          },
          "surepass": {
            "label": "Surepass / DigiLocker (when enabled):",
            "link_text": "Partner terms",
            "value": "Optional Aadhaar / DigiLocker identity verification for eligible accounts."
          }
        },
        "title": "10. మూడవ పక్ష సేవలు"
      },
      "transfers": {
        "body_1": "LetMeIn AI is primarily operated from India. Some third-party providers (such as Google, Stripe, AWS, Sarvam, Sentry, or Pusher) may process data in other countries, including the United States and the European Union. When we transfer personal data internationally, we take steps to ensure adequate protections are in place, including:",
        "items": {
          "compliance": "",
          "dpas": "",
          "frameworks": ""
        },
        "title": "12. అంతర్జాతీయ డేటా బదిలీలు"
      },
      "use": {
        "body": "మేము సేకరించిన సమాచారాన్ని కింది ప్రయోజనాల కోసం ఉపయోగిస్తాము:",
        "items": {
          "account_management": {
            "label": "",
            "value": ""
          },
          "ai_matching": {
            "label": "",
            "value": "To power personalized property recommendations, AI search, conversational listing assistants (GenUI), embeddings-based matching, and related natural language features."
          },
          "analytics": {
            "label": "",
            "value": ""
          },
          "communications": {
            "label": "",
            "value": ""
          },
          "fraud_prevention": {
            "label": "",
            "value": ""
          },
          "legal_compliance": {
            "label": "",
            "value": ""
          },
          "listing_tools": {
            "label": "Listing & Import Tools:",
            "value": "To help you create and manage listings, including AI-assisted listing chat and optional import from files or property URLs you provide."
          },
          "marketing": {
            "label": "",
            "value": ""
          },
          "payment_processing": {
            "label": "",
            "value": "To manage subscriptions and credit/wallet purchases, process upgrades or top-ups, and track usage-based billing (including AI, voice, and maps usage where metered)."
          },
          "service_delivery": {
            "label": "",
            "value": ""
          }
        },
        "title": "3. మీ సమాచారాన్ని మేమెలా ఉపయోగిస్తాము"
      }
    },
    "summary": "This Privacy Policy describes how LetMeIn AI (\"we\", \"us\", or \"our\") collects, uses, stores, and protects your personal information when you use our website, apps, and services. By using LetMeIn AI, you agree to the practices described in this policy.",
    "title": "గోప్యతా విధానం"
  },
  "profile": {
    "account_settings": "ఖాతా సెట్టింగ్‌లు",
    "add_area_placeholder": "ఒక ప్రాంతాన్ని జోడించండి (ఉదా. హైటెక్ సిటీ)",
    "add_manually": "ఏమైనప్పటికీ అనుకూల ప్రాంతంగా జోడించండి",
    "appearance": "రూప లావణ్యం",
    "appearance_settings": "స్వరూపం సెట్టింగ్‌లు",
    "appearance_tab": {
      "auto_save": "ఆటో-సేవ్ ప్రారంభించబడింది",
      "auto_save_desc": "మీ థీమ్ ప్రాధాన్యత స్వయంచాలకంగా సేవ్ చేయబడుతుంది మరియు మీ అన్ని సెషన్‌లలో వర్తించబడుతుంది.",
      "theme_mode": "థీమ్ మోడ్",
      "theme_mode_desc": "లైట్ మరియు డార్క్ థీమ్ మధ్య టోగుల్ చేయండి",
      "theme_pref": "థీమ్ ప్రాధాన్యతలు",
      "theme_pref_desc": "లైట్ మరియు డార్క్ మోడ్ మధ్య మారండి"
    },
    "basic_profile_info": "మీ ప్రాథమిక ప్రొఫైల్ సమాచారం",
    "billing_locale": "బిల్లింగ్ & వాలెట్",
    "billing_locale_desc": "నమోదా సమయం సెట్ చేయబడింది. వాలెట్ ఉపయోగంలో ఉన్న తర్వాత మార్చులో మార్పిడకి సంప్రదించండి.",
    "confirm_new_password": "కొత్త పాస్‌వర్డ్‌ను నిర్ధారించండి",
    "connected_accounts": "కనెక్ట్ చేయబడిన ఖాతాలు",
    "control_notifications": "మీరు నోటిఫికేషన్‌లను ఎలా స్వీకరిస్తారో నియంత్రించండి",
    "customize_look_feel": "మీ అప్లికేషన్ యొక్క రూపాన్ని మరియు అనుభూతిని అనుకూలీకరించండి",
    "default_location": "డిఫాల్ట్ స్థానం",
    "edit_profile": "ప్రొఫైల్‌ను సవరించు",
    "email_address": "ఇమెయిల్ చిరునామా",
    "enter_new_password_placeholder": "కొత్త పాస్‌వర్డ్‌ను నమోదు చేయండి",
    "enter_old_password_placeholder": "మీ పాత పాస్‌వర్డ్‌ను నమోదు చేయండి",
    "first_name": "మొదటి పేరు",
    "identity": {
      "card_desc": "మీ ఆధార్ వివరాలు గుర్తింపు ధృవీకరణకు మాత్రమే ఉపయోగించబడతాయి, బహిరంగంగా పంచుకోబడవు.",
      "card_title": "ఆధార్ ధృవీకరణ",
      "consent": "LetMeIn AIలో గుర్తింపు కోసం ఆధార్ ధృవీకరణకు నేను సమ్మతిస్తున్నాను.",
      "consent_required": "కొనసాగించడానికి దయచేసి సమ్మతిని అంగీకరించండి.",
      "description": "ప్లాట్‌ఫారమ్‌పై విశ్వాసం పెంచడానికి ఆధార్తో మీ గుర్తింపును ధృవీకరించండి.",
      "digilocker_hint": "ఆధార్ OTP ధృవీకరణను సురక్షితంగా పూర్తి చేయడానికి మిమ్మల్ని డిజీలాకర్‌కు మళ్లిస్తాము.",
      "info": "ధృవీకరణ యజమానులు, అద్దెదారులు మరియు ప్రాపర్టీ మేనేజర్‌లకు లిస్టింగ్‌లు/పరస్పర చర్యలలో విశ్వాసం ఏర్పరచడానికి సహాయపడుతుంది.",
      "masked_aadhaar": "{{lastFour}}తో ముగిసే ఆధార్",
      "pending": "ధృవీకరణ జరుగుతోంది. స్థితిని తనిఖీ చేస్తున్నాము...",
      "status_failed": "ధృవీకరణ స్థితిని పొందలేకపోయాము.",
      "status_unverified": "ధృవీకరించబడలేదు",
      "status_verified": "ధృవీకరించబడింది",
      "tab_label": "గుర్తింపు",
      "title": "గుర్తింపు ధృవీకరణ",
      "verified_message": "మీ ఆధార్ గుర్తింపు ధృవీకరించబడింది.",
      "verify_failed": "ఆధార్ ధృవీకరణ విఫలమైంది. దయచేసి మళ్లీ ప్రయత్నించండి.",
      "verify_success": "ఆధార్ విజయవంతంగా ధృవీకరించబడింది.",
      "verify_with_digilocker": "డిజీలాకర్‌తో ధృవీకరించండి",
      "verifying": "ధృవీకరిస్తోంది..."
    },
    "last_name": "చివరి పేరు",
    "location_tab": {
      "loc_pref": "స్థాన ప్రాధాన్యతలు",
      "loc_pref_desc": "మీకు నచ్చిన దేశం మరియు నగరాన్ని సెట్ చేయండి",
      "privacy": "గోప్యతా సమాచారం",
      "privacy_desc": "మీ స్థాన ప్రాధాన్యత మీ బ్రౌజర్‌లో స్థానికంగా నిల్వ చేయబడుతుంది. ఈ సెట్టింగ్ మా సర్వర్‌లలో ఖచ్చితమైన GPS డేటాను నిల్వ చేయకుండా మీ అనుభవాన్ని మెరుగుపరచడంలో మాకు సహాయపడుతుంది.",
      "save_prefs": "ప్రాధాన్యతలను సేవ్ చేయండి"
    },
    "manage_auth_methods": "మీ లాగిన్ పద్ధతులు మరియు సోషల్ ఖాతాలను జోడించండి లేదా తొలగించండి",
    "manage_location_prefs": "మీ డిఫాల్ట్ దేశం మరియు నగర ప్రాధాన్యతలను నిర్వహించండి",
    "manage_org_public_info": "మీ సంస్థ యొక్క పబ్లిక్ సమాచారాన్ని నిర్వహించండి",
    "manage_profile_preferences": "మీ ప్రొఫైల్ మరియు ప్రాధాన్యతలను నిర్వహించండి",
    "messages": {
      "account_link_failed": "{{provider}} ఖాతాను జోడించడంలో విఫలమైంది",
      "account_linked": "{{provider}} ఖాతా విజయవంతంగా జోడించబడింది!",
      "account_unlink_failed": "{{provider}} ఖాతాను తొలగించడంలో విఫలమైంది",
      "account_unlinked": "{{provider}} ఖాతా విజయవంతంగా తొలగించబడింది!",
      "enter_old_password": "దయచేసి మీ పాత పాస్‌వర్డ్‌ను నమోదు చేయండి.",
      "location_invalid": "దయచేసి మీ దేశంలో మద్దతు ఉన్న నగరాన్ని ఎంచుకోండి.",
      "location_update_failed": "స్థాన ప్రాధాన్యతలను నవీకరించడంలో విఫలమైంది",
      "location_updated": "స్థాన ప్రాధాన్యతలు విజయవంతంగా నవీకరించబడ్డాయి",
      "notification_permission_blocked": "నోటిఫికేషన్‌లు నిరోధించబడ్డాయి. దయచేసి మీ బ్రౌజర్ సెట్టింగ్‌లలో వాటిని ప్రారంభించండి.",
      "notification_permission_denied": "నోటిఫికేషన్ అనుమతి నిరాకరించబడింది",
      "notification_update_failed": "నోటిఫికేషన్ ప్రాధాన్యతలను నవీకరించడంలో విఫలమైంది",
      "notification_update_success": "నోటిఫికేషన్ ప్రాధాన్యతలు విజయవంతంగా నవీకరించబడ్డాయి!",
      "notifications_not_supported": "ఈ బ్రౌజర్‌లో బ్రౌజర్ నోటిఫికేషన్‌లు మద్దతు ఇవ్వబడవు",
      "old_password_incorrect": "పాత పాస్‌వర్డ్ తప్పు.",
      "passwords_do_not_match": "పాస్‌వర్డ్‌లు సరిపోలడం లేదు.",
      "profile_update_failed": "ప్రొఫైల్‌ను నవీకరించడంలో విఫలమైంది. దయచేసి మళ్ళీ ప్రయత్నించండి.",
      "profile_updated": "ప్రొఫైల్ విజయవంతంగా నవీకరించబడింది!",
      "sw_not_supported": "ఈ బ్రౌజర్‌లో సర్వీస్ వర్కర్‌లు మద్దతు ఇవ్వబడరు",
      "unlink_confirm": "మీరు ఖచ్చితంగా మీ {{provider}} ఖాతాను తొలగించాలనుకుంటున్నారా?",
      "web_push_disabled": "బ్రౌజర్ నోటిఫికేషన్‌లు నిలిపివేయబడ్డాయి",
      "web_push_enabled": "బ్రౌజర్ నోటిఫికేషన్‌లు విజయవంతంగా ప్రారంభించబడ్డాయి",
      "web_push_failed": "బ్రౌజర్ నోటిఫికేషన్‌లను ప్రారంభించడంలో విఫలమైంది"
    },
    "new_password": "కొత్త పాస్‌వర్డ్",
    "no_areas_added": "ఇంకా ప్రాంతాలు జోడించబడలేదు. మీరు పనిచేసే ప్రాంతాలను జోడించండి.",
    "no_matching_areas": "సరిపోలే ప్రాంతాలు కనుగొనబడలేదు",
    "notification_preferences": "నోటిఫికేషన్ ప్రాధాన్యతలు",
    "notifications": "నోటిఫికేషన్లు",
    "notifications_tab": {
      "email": "ఇమెయిల్ నోటిఫికేషన్‌లు",
      "email_desc": "ఇమెయిల్ ద్వారా నోటిఫికేషన్‌లను స్వీకరించండి",
      "in_app": "యాప్‌లో నోటిఫికేషన్‌లు",
      "in_app_desc": "అప్లికేషన్ లోపల నోటిఫికేషన్‌లను స్వీకరించండి",
      "settings_desc": "మీ నోటిఫికేషన్ ప్రాధాన్యతలను నిర్వహించండి",
      "settings_title": "నోటిఫికేషన్ సెట్టింగ్‌లు",
      "storage_desc": "మీ నోటిఫికేషన్ ప్రాధాన్యతలు మీ ఖాతాలో సురక్షితంగా నిల్వ చేయబడతాయి మరియు మీ అన్ని పరికరాలలో వర్తింపజేయబడతాయి.",
      "storage_title": "ప్రాధాన్యత నిల్వ",
      "web_push": "బ్రౌజర్ నోటిఫికేషన్‌లు",
      "web_push_desc": "యాప్ మూసివేయబడినప్పుడు కూడా నోటిఫికేషన్‌లను స్వీకరించండి"
    },
    "old_password": "పాత పాస్‌వర్డ్",
    "operating_areas": "నిర్వహణ ప్రాంతాలు",
    "operating_areas_desc": "మీరు ఆస్తి నిర్వహణ సేవలను అందించే నిర్దిష్ట ప్రాంతాలను జాబితా చేయండి",
    "org_tab": {
      "address": "చిరునామా",
      "description": "వివరణ",
      "name": "సంస్థ పేరు",
      "phone": "ఫోన్",
      "save_details": "వివరాలను సేవ్ చేయండి",
      "slug": "స్లగ్",
      "website": "వెబ్‌సైట్"
    },
    "organization": "సంస్థ",
    "organization_profile": "సంస్థ ప్రొఫైల్",
    "password_settings": "పాస్‌వర్డ్ సెట్టింగ్‌లు",
    "personal_details": "వ్యక్తిగత వివరాలు",
    "profile": "ప్రొఫైల్",
    "profile_information": "ప్రొఫైల్ సమాచారం",
    "reenter_new_password_placeholder": "కొత్త పాస్‌వర్డ్‌ను మళ్ళీ నమోదు చేయండి",
    "regional_settings": "ప్రాంతీయ సెట్టింగ్‌లు",
    "set_password_placeholder": "మీ పాస్‌వర్డ్‌ను సెట్ చేయండి",
    "social_account": "లాగిన్ పద్ధతులు",
    "social_tab": {
      "auth_methods": "ప్రామాణీకరణ పద్ధతులు",
      "auth_methods_desc": "లాగిన్ ప్రదాతలను జోడించండి లేదా తొలగించండి",
      "connected": "కనెక్ట్ అయింది",
      "link": "జోడించు",
      "linking": "జోడిస్తోంది...",
      "no_providers": "ఎటువంటి ప్రొవైడర్‌లు కనుగొనబడలేదు",
      "not_connected": "కనెక్ట్ కాలేదు",
      "providers": {
        "email": "ఇమెయిల్/పాస్‌వర్డ్",
        "facebook": "ఫేస్‌బుక్",
        "google": "గూగుల్",
        "phone": "ఫోన్"
      },
      "set_password": "ఖాతా పాస్‌వర్డ్‌ను సెట్ చేయండి",
      "set_password_btn": "పాస్‌వర్డ్ సెట్ చేయండి",
      "set_password_desc": "సోషల్ లాగిన్‌తో పాటు ఇమెయిల్/పాస్‌వర్డ్‌తో కూడా లాగిన్ చేయడానికి పాస్‌వర్డ్ జోడించండి.",
      "unlink": "తొలగించు"
    },
    "update_profile_info": "మీ వ్యక్తిగత సమాచారం మరియు ఖాతా సెట్టింగ్‌లను నవీకరించండి"
  },
  "property": {
    "add_to_favourites": "ఇష్టాలకు జోడించండి",
    "address": "చిరునామా",
    "age_const": "నిర్మాణ కాల పరిమితి",
    "amenities_count_one": "{{count}} సౌకర్యాలు & లక్షణాలు — వివరాలకు చూడండి",
    "amenities_count_other": "{{count}} సౌకర్యాలు & లక్షణాలు — వివరాలకు చూడండి",
    "amenities_title": "ముఖ్యమైన సౌకర్యాలు",
    "apartment_name": "",
    "area_type": "వైశాల్యం రకం",
    "available_floors": "అందుబాటులో ఉన్న అంతస్తులు",
    "available_from": "అందుబాటు / మూవ్-ఇన్",
    "available_services": "అందుబాటులో ఉన్న సేవలు",
    "back_to_my_properties": "నా ప్రాపర్టీలకు తిరిగి వెళ్ళు",
    "back_to_properties": "లిస్టింగ్ పేజీకి తిరిగి",
    "balconies": "బాల్కనీలు",
    "bathrooms": "బాత్రూమ్‌లు",
    "baths_one": "{{count}} బాత్",
    "baths_other": "{{count}} బాత్‌లు",
    "bedrooms": "పడకగదులు",
    "brochure": "బ్రోచర్ డౌన్‌లోడ్ చేయండి",
    "built_up_area": "బిల్ట్-అప్ ఏరియా",
    "by_owner": "{{name}} ద్వారా",
    "collapse_room_details": "గది వివరాలను మూసివేయి",
    "commercial_subtype": "వాణిజ్య ఉప-రకం",
    "common_area_amenities_title": "కామన్ ఏరియా సౌకర్యాలు",
    "compare": "ప్రాజెక్ట్‌లను పోల్చండి",
    "connectivity_title": "రవాణా మరియు కనెక్టివిటీ",
    "contact_failed": "సంభాషణ ప్రారంభించడం విఫలమైంది. మళ్లీ ప్రయత్నించండి.",
    "contact_loc": "ఖచ్చితమైన స్థానం కోసం సంప్రదించండి",
    "contact_owner": "యజమానిని సంప్రదించండి",
    "contact_unavailable": "ఈ ఆస్తికి సంప్రదింపు సమాచారం అందుబాటులో లేదు.",
    "corner_shop": "మూల దుకాణం",
    "curfew": "కర్ఫ్యూ: {{time}}",
    "default_description": "ఈ అందమైన ప్రాపర్టీకి స్వాగతం. బాగా నిర్వహించబడి, ప్రధాన ప్రాంతంలో ఉంది. మరిన్ని వివరాలు మరియు సందర్శన కోసం మమ్మల్ని సంప్రదించండి.",
    "delete": "తొలగించు",
    "deposit": "డిపాజిట్",
    "desc_title": "ఆస్తి వివరణ",
    "dev_owner": "డెవలపర్ / యజమాని",
    "developer": "డెవలపర్",
    "dimensions": "కొలతలు",
    "directions": "",
    "edit": "సవరించు",
    "expand_room_details": "గది వివరాలను విస్తరించు",
    "external_source": "అసలు వెబ్‌సైట్",
    "extra_parameters_title": "",
    "facing": "ముఖ దిశ",
    "favourite": "ఇష్టం",
    "fit_out": "ఫిట్-అవుట్ స్థితి",
    "floor": "అంతస్తు",
    "floor_details": "అంతస్తు వివరాలు",
    "floor_level": "అంతస్తు స్థాయి",
    "floor_n": "అంతస్తు {{n}}",
    "floor_out_of": "అంతస్తు {{n}} ({{total}} లో)",
    "food_available": "భోజనం అందుబాటులో ఉంది",
    "food_meals": "భోజనం & ఆహారం",
    "for": "కొరకు",
    "for_rent": "అద్దెకు",
    "for_sale": "అమ్మకానికి",
    "furnishing": "ఫర్నిషింగ్",
    "furnishing_status": "ఫర్నిషింగ్ స్థితి",
    "gate_curfew": "గేట్ మూసివేత సమయం",
    "get_contact": "ఫోన్ & చిరునామా పొందండి",
    "go_back": "వెనక్కి వెళ్ళండి",
    "ground": "గ్రౌండ్",
    "highlights_title": "ప్రాపర్టీ ముఖ్యాంశాలు",
    "house_rules": "ఇంటి నియమాలు",
    "immediate": "వెంటనే",
    "in": "లో",
    "individual": "వ్యక్తిగత",
    "lifts": "లిఫ్ట్ / ఎలివేటర్లు",
    "listing_date": "జాబితా తేదీ",
    "loc_not_spec": "స్థలం పేర్కొనబడలేదు",
    "login_contact": "యజమానిని సంప్రదించడానికి దయచేసి లాగిన్ అవ్వండి",
    "login_favourites": "ఇష్టాలకు జోడించడానికి దయచేసి లాగిన్ అవ్వండి",
    "main_road_facing": "ప్రధాన రహదారి వైపు",
    "maintenance_charges": "నిర్వహణ ఛార్జీలు",
    "maintenance_included": "నిర్వహణ చేర్చబడింది",
    "map_pin_hidden": "సెర్చ్ మ్యాప్ నుండి దాచబడింది",
    "map_pin_visible": "సెర్చ్ మ్యాప్‌లో కనిపిస్తుంది",
    "media_next": "తరువాతి మీడియా",
    "media_play": "వీడియో ప్లే చేయండి",
    "media_previous": "ముందటి మీడియా",
    "monthly": "నెలవారీ",
    "more_details_title": "మరిన్ని వివరాలు",
    "move_in": "మూవ్-ఇన్",
    "na": "N/A",
    "nearby_places_title": "సమీప ప్రదేశాలు",
    "negotiable": "చర్చించదగినది",
    "no_curfew": "కర్ఫ్యూ లేదు",
    "no_food": "భోజనం లేదు",
    "no_image": "చిత్రం లేదు",
    "no_photos": "ఫోటోలు అందుబాటులో లేవు",
    "not_found": "ఆస్తి కనుగొనబడలేదు",
    "not_specified": "పేర్కొనబడలేదు",
    "open_full_page": "",
    "out_of": "లో",
    "out_of_total": "({{total}} లో)",
    "parking": "పార్కింగ్",
    "parking_spaces_one": "{{count}} స్థలం",
    "parking_spaces_other": "{{count}} స్థలం",
    "parking_spaces_plural_one": "{{count}} స్థలాలు",
    "parking_spaces_plural_other": "{{count}} స్థలాలు",
    "per_bed_mo": "/మంచం/నె",
    "pg_avail_from": "అందుబాటు: {{date}}",
    "pg_available_for_all": "అందరి అద్దెదారులు",
    "pg_available_for_anyone": "కో-ఎడ్ / ఎవరైనా",
    "pg_available_for_boys": "అబ్బాయిలకు మాత్రమే",
    "pg_available_for_girls": "అమ్మాయిలకు మాత్రమే",
    "pg_bed_sharing": "{{count}} బెడ్ షేరింగ్",
    "pg_food_3_meals": "3 భోజనాలు ఉన్నాయి ({{meals}})",
    "pg_food_included": "భోజనం ఉంది",
    "pg_food_meals_included": "{{meals}} ఉన్నాయి",
    "pg_food_self_cooking": "స్వయం వంట / భోజనం లేదు",
    "pg_name": "PG పేరు",
    "pg_present_in": "PG ఎక్కడ ఉంది",
    "pg_rooms_one_one": "{{count}} గది",
    "pg_rooms_one_other": "{{count}} గది",
    "pg_rooms_other_one": "{{count}} గదులు",
    "pg_rooms_other_other": "{{count}} గదులు",
    "pg_service_laundry": "లాండ్రీ",
    "pg_service_room_cleaning": "రూమ్ క్లీనింగ్",
    "pg_service_warden": "వార్డెన్ సౌకర్యం",
    "pg_sharing_named": "{{name}} షేరింగ్",
    "pg_usps": "ప్రత్యేక ఆకర్షణలు",
    "pg_usps_sub": "ఈ PG యొక్క ముఖ్య హైలైట్‌లు మరియు ప్రయోజనాలు",
    "photo_one_one": "{{count}} ఫోటో",
    "photo_one_other": "{{count}} ఫోటో",
    "photo_other_one": "{{count}} ఫోటోలు",
    "photo_other_other": "{{count}} ఫోటోలు",
    "plot_area": "ప్లాట్ విస్తీర్ణం",
    "poc": "సంప్రదింపు వ్యక్తి",
    "preferred_tenants": "",
    "price_breakup": "ధర విభజన",
    "price_rent": "అద్దెకు",
    "price_sale": "అమ్మకానికి",
    "property_name": "",
    "property_sub_type": "ప్రాపర్టీ ఉప-రకం",
    "property_type": "ప్రాపర్టీ రకం",
    "ready_to_move": "నివసించడానికి సిద్ధంగా ఉంది",
    "remove_from_favourites": "ఇష్టాల నుండి తొలగించండి",
    "rent": "అద్దె",
    "rera_approved": "RERA ఆమోదించబడింది",
    "room_facilities_title": "గది సౌకర్యాలు",
    "room_photos": "గది ఫోటోలు",
    "room_photos_empty": "ఈ షేరింగ్ ఎంపికకు ఇంకా గది ఫోటోలు అప్‌లోడ్ చేయలేదు",
    "room_type": "గది రకం",
    "sale": "అమ్మకం",
    "search_map_pin": "సెర్చ్ మ్యాప్ పిన్",
    "security_deposit": "సెక్యూరిటీ డిపాజిట్",
    "share": "",
    "share_copied": "",
    "share_copy_failed": "",
    "share_copy_link": "",
    "share_default_title": "",
    "share_device": "",
    "share_facebook": "",
    "share_instagram": "",
    "share_instagram_copied": "",
    "share_link_copied": "",
    "share_whatsapp": "",
    "shared_room": "షేర్డ్ రూమ్",
    "sharing": "రూమ్ షేరింగ్",
    "source": "మూలం",
    "status": "హోదా",
    "suitable_for": "అనుకూలం",
    "super_area": "బిల్ట్-అప్ విస్తీర్ణం",
    "total_floors": "మొత్తం అంతస్తులు",
    "total_views": "మొత్తం వీక్షణలు",
    "truck_access": "ట్రక్ యాక్సెస్",
    "types": {
      "agricultural_land": "Agricultural Land",
      "apartment": "Apartment",
      "builder_floor_apartment": "Builder Floor Apartment",
      "bungalow": "Bungalow",
      "co_living_space": "Co-living Space",
      "commercial": "Commercial",
      "commercial_plot": "Commercial Plot",
      "development_land": "Development Land",
      "duplex_house": "Duplex House",
      "farm_house": "Farm House",
      "farm_land": "Farm Land",
      "gated_community_house": "Gated Community House",
      "gated_community_villa": "Gated Community Villa",
      "hostel": "Hostel",
      "house": "House",
      "independent_house": "Independent House",
      "independent_villa": "Independent Villa",
      "industrial_land": "Industrial Land",
      "industrial_plot": "Industrial Plot",
      "land": "Plot",
      "na_plot": "Non-Agricultural Plot",
      "paying_guest": "Paying Guest",
      "penthouse": "Penthouse",
      "pg": "PG",
      "pg_accommodation": "PG Accommodation",
      "plot": "Plot",
      "residential_plot": "Residential Plot",
      "row_house": "Row House",
      "service_apartment": "Service Apartment",
      "studio_apartment": "Studio Apartment",
      "triplex_house": "Triplex House",
      "villa": "Villa"
    },
    "under_const": "నిర్మాణంలో ఉంది",
    "unfurnished": "అమర్చబడలేదు",
    "video_tour": "ఆస్తి వీడియో టూర్",
    "view": "చూడండి",
    "view_details": "వివరాలను వీక్షించండి",
    "visit_site": "సైట్‌ను సందర్శించండి",
    "washrooms": "వాష్‌రూమ్‌లు",
    "yes": "అవును"
  },
  "property_draft": {
    "confirm_delete_desc": "మీరు నిజంగా ఈ డ్రాఫ్ట్ను తొలగాలనా? ఈ ఆస్తి మరియు దాని చాట్ ప్రగతి తొలగబడతాయి.",
    "confirm_delete_title": "డ్రాఫ్ట్ తొలగాలా?",
    "delete_draft": "డ్రాఫ్ట్ తొలగిండి",
    "delete_failed": "డ్రాఫ్ట్ తొలగడంలో విఫలమైంది",
    "deleted_success": "డ్రాఫ్ట్ విజయవంతంగా తొలగబడింది",
    "resume": {
      "continue": "చివరి లిస్టింగ్‌ను పూర్తి చేయండి",
      "description": "మీకు పూర్తి కాని ప్రాపర్టీ లిస్టింగ్ ఉంది. మీరు ఎక్కడ ఆపిలేనో అక్కడి నుండి కొనసాగాలా, లేదా కొత్తది ప్రారంభించాలా?",
      "failed": "మీ లిస్టింగ్‌ను కొనసాగించలేకపోయాం. మీరు కుడి వైపు ప్రివ్యూను ఇప్పటికీ సవరించవచ్చు.",
      "start_new": "కొత్త లిస్టింగ్‌ను ప్రారంభించండి",
      "title": "మీ చివరి లిస్టింగ్‌ను పూర్తి చేయాలా?",
      "untitled": "శీర్షిక లేని డ్రాఫ్ట్"
    },
    "status": {
      "error": "సేవ్ విఫలమైంది",
      "saved": "సేవ్ అయింది",
      "saving": "సేవ్ అవుతోంది..."
    }
  },
  "property_edit_modal": {
    "close_aria": "ప్రాపర్టీ ఎడిట్ డైలాగ్‌ను మూసివేయండి",
    "errors": {
      "invalid_price_type": "చెల్లని లిస్టింగ్ ఉద్దేశ్యం.",
      "invalid_property_type": "చెల్లని ఆస్తి రకం. అపార్ట్మెంట్, హౌస్, విల్లా, కామర్షియల్, ప్లాట్/భూమి లేదా PG ఎంచుకోండి.",
      "invalid_status": "చెల్లని లిస్టింగ్ స్థితి.",
      "pin_update_required": "చిరునామా మార్చింది. మ్యాప్ పిన్ను నవీకరించి, ఆపై సేవ్ చేయండి.",
      "reserved_attribute_key": "ఆ కీ సిస్టమ్ ఫీల్డ్ల కోసం రిజర్వ్ చేయబడింది. దయచేసి కస్టమ్ పేరును ఉపయోగించండి.",
      "title_required": "శీర్షిక అవసరం",
      "update_failed": "ప్రాపర్టీ అప్‌డేట్ చేయలేకపోయాం. దయచేసి మళ్లీ ప్రయత్నించండి.",
      "valid_price_required": "చెల్లుబాటు అయ్యే ధర అవసరం"
    },
    "subtitle": "అన్ని వివరాలు, మీడియా మరియు లక్షణాలను ఒక చోటులో నవీకరించండి",
    "title": "ప్రాపర్టీని సవరించండి"
  },
  "property_listing": {
    "actions": {
      "post_property": "ఆస్తిని పోస్ట్ చేయండి"
    },
    "alerts": {
      "choose_excel_file": "దయచేసి Excel ఫైల్ (.xlsx) ఎంచుకోండి.",
      "confirm_delete_property": "ఈ ప్రాపర్టీని తొలగించాలని మీరు ఖచ్చితంగా అనుకుంటున్నారా?",
      "delete_failed": "ప్రాపర్టీని తొలగించడంలో విఫలమైంది.",
      "property_updated": "ఆస్తి విజయవంతంగా అప్‌డేట్ అయింది!",
      "update_failed": "ప్రాపర్టీని అప్‌డేట్ చేయడంలో విఫలం: {{error}}",
      "upgrade_failed_after_post": "మీ ప్రాపర్టీ పోస్ట్ అయింది! అయితే, మీ పాత్రను ఆటోమేటిక్‌గా అప్‌గ్రేడ్ చేయలేకపోయాం. దయచేసి సపోర్ట్‌ను సంప్రదించండి."
    },
    "bulk_import": {
      "ai_chat": "AI చాట్",
      "btn_web_import": "మ్యాప్‌లో లిస్టింగ్‌లను దిగుమతి చేసి సమీక్షించండి",
      "card_web_import": "ఇతర వెబ్‌సైట్ నుండి దిగుమతి",
      "excel_file": "ఎక్సెల్ ఫైల్",
      "import_failed": "",
      "import_for_user": "వినియోగదారుని కోసం ఇంపోర్ట్ చేయండి",
      "invalid_file_type": "దయచేసి చెల్లుబాటు అయ్యే Excel (.xlsx) లేదా CSV (.csv) ఫైల్‌ను వదలండి.",
      "my_account": "నా ఖాతా",
      "page": {
        "attr_core": "Core Specifications",
        "attr_location": "Location & Map Pin",
        "attr_media": "Media & Features",
        "browse_computer": "Browse Computer",
        "change_file": "మార్చు",
        "clear": "క్లియర్",
        "coming_soon": "త్వరలో",
        "compatible_portals": "Compatible Real Estate Portals",
        "confirm_delete_all": "Are you sure you want to permanently delete ALL {{count}} draft listings? This action cannot be undone.",
        "confirm_delete_one": "Are you sure you want to delete this draft listing?",
        "confirm_delete_selected": "Are you sure you want to delete {{count}} selected draft listing(s)?",
        "crawl_ready": "Multi-threaded AI crawl ready",
        "crawl_review": "క్రాల్ చేసి మ్యాప్‌లో రివ్యూ చేయండి",
        "crawling": "Crawling property specs & photos with AI...",
        "delete_all": "Delete All",
        "delete_all_failed": "Failed to delete all drafts.",
        "delete_draft_tooltip": "Delete draft",
        "delete_one_failed": "Failed to delete draft.",
        "delete_selected": "Delete ({{count}})",
        "delete_selected_failed": "Failed to delete some drafts.",
        "deleted_all": "Deleted all {{count}} draft(s).",
        "deleted_drafts": "Deleted {{count}} draft(s).",
        "direct_import": "నేరుగా దిగుమతి (డ్రాఫ్ట్‌లుగా సేవ్)",
        "download_paragraph_failed": "Failed to download paragraph template.",
        "download_standard_failed": "Failed to download standard template.",
        "draft_deleted": "Draft deleted.",
        "draft_missing_coords": "This draft is missing price or location coordinates. Please click \"Edit\" or \"Review on Map\" first.",
        "drafts_desc": "Review, edit on the interactive map, or batch publish pending drafts to live search.",
        "drafts_title": "సేవ్ చేసిన డ్రాఫ్ట్ లిస్టింగ్‌లు",
        "drafts_total": "{{count}} total",
        "drop_active": "Drop spreadsheet here to upload",
        "drop_here": "Drag & drop your property sheet here",
        "enter_url": "Please enter at least one valid property URL.",
        "facebook": "ఫేస్‌బుక్",
        "facebook_desc": "Import directly from Facebook Marketplace listings and real estate group posts in one click.",
        "filter_all": "All ({{count}})",
        "filter_needs_pin": "Needs Pin ({{count}})",
        "filter_pinned": "Pinned ({{count}})",
        "format_columns": "Standard Columns",
        "format_columns_desc": "Structured headers for BHK, Price, Locality",
        "format_paragraph": "AI Smart Paragraph",
        "format_paragraph_desc": "Freeform text notes parsed by AI",
        "import_finished": "Import finished: {{success}} imported, {{failed}} failed.",
        "import_first": "Import Your First Properties",
        "import_queued": "Import queued in background worker!",
        "import_success": "Successfully imported {{count}} properties!",
        "importing_urls": "Importing & parsing {{count}} listing URL(s)...",
        "insert_sample_urls": "నమూనా URLలు చేర్చు",
        "instagram": "ఇన్‌స్టాగ్రామ్",
        "instagram_desc": "Paste post or reel links. AI extracts property photos, price, BHK, and captions automatically.",
        "loading_drafts": "Loading saved drafts...",
        "location_pinned": "Location Pinned",
        "multi_portal_badge": "Multi-Portal AI Crawler",
        "need_import_now": "ఇప్పుడే లిస్టింగ్‌లు దిగుమతి చేయాలా?",
        "need_import_now_desc": "ఈరోజు మీరు బల్క్ స్ప్రెడ్‌షీట్‌లు అప్‌లోడ్ చేయవచ్చు లేదా వెబ్ లిస్టింగ్ URLల నుండి నేరుగా దిగుమతి చేయవచ్చు.",
        "needs_location_pin": "Needs Location Pin",
        "no_drafts": "సేవ్ చేసిన డ్రాఫ్ట్‌లు లేవు",
        "no_drafts_desc": "You have no pending drafts. Incomplete properties, bulk uploads, or web imports saved as drafts will appear here.",
        "no_drafts_match": "No drafts match your current search or filter.",
        "no_valid_rows": "No valid property rows found in the sheet. Please verify your template and try again.",
        "none_ready_publish": "None of the selected drafts have a valid title/price and map pin. Please click \"Review on Map\" to place pins first.",
        "page_subtitle": "స్ప్రెడ్‌షీట్‌లు, వెబ్ URLలు లేదా సోషల్ చానెల్స్ నుండి బల్క్‌గా లిస్టింగ్‌లను దిగుమతి చేయండి.",
        "parse_failed": "Failed to parse sheet with AI.",
        "parsing_desc": "Extracting BHK, pricing, amenities, room specifications, and placing initial map pins before opening the interactive review screen.",
        "parsing_title": "AI is parsing and geolocating your property listings...",
        "portal_custom": "Custom Listing Links",
        "portal_independent": "Independent Builder Sites",
        "preview_on_map": "మ్యాప్‌లో ప్రివ్యూ & రివ్యూ",
        "processing_ai": "AIతో ప్రాసెస్ అవుతోంది...",
        "publish": "Publish",
        "publish_failed": "Failed to publish draft.",
        "publish_ready": "Publish Ready ({{count}})",
        "publish_ready_failed": "Failed to publish ready drafts. Please try again.",
        "publish_selected": "Publish Selected ({{count}})",
        "publish_tooltip": "Publish directly to live listings",
        "ready_for_parsing": "పార్సింగ్‌కు సిద్ధం",
        "recommended_hint": "Recommended: Review on Map lets you inspect addresses, adjust coordinates, and preview specifications before publishing to live listings.",
        "refresh_drafts": "Refresh Drafts",
        "remove_file": "ఫైల్ తొలగించు",
        "review_all_on_map": "Review All on Map",
        "review_on_map_n": "Review on Map ({{count}})",
        "review_pin": "Review Pin",
        "review_pin_tooltip": "Edit listing and review pin on interactive map",
        "row_error": "Row {{row}}: {{title}} — {{error}}",
        "search_drafts_placeholder": "Search drafts by title, location...",
        "select_all": "Select All ({{count}})",
        "select_format": "స్ప్రెడ్‌షీట్ ఫార్మాట్ ఎంచుకోండి",
        "selected_count": "{{count}} Selected",
        "social_badge": "ఫీచర్ అభివృద్ధిలో ఉంది",
        "social_desc": "Import property listings directly from your social media posts, reels, video walkthroughs, and messaging catalogs using multimodal AI extraction.",
        "social_title": "సోషల్ మీడియా ప్రాపర్టీ దిగుమతి",
        "soon": "Soon",
        "supported_attributes": "Supported Attributes",
        "supports_files": "Supports Microsoft Excel (.xlsx) or CSV (.csv) up to 25 MB",
        "tab_drafts": "సేవ్ చేసిన డ్రాఫ్ట్‌లు",
        "tab_social": "సోషల్ మీడియా",
        "tab_spreadsheet": "స్ప్రెడ్‌షీట్ దిగుమతి",
        "tab_web_scraping": "వెబ్ స్క్రాపింగ్",
        "template_paragraph": "Paragraph Extraction",
        "template_paragraph_desc": "Freeform text per row",
        "template_standard": "Standard Columns",
        "template_standard_desc": "Excel .xlsx template",
        "templates_desc": "Use our sample spreadsheets with mapped headers to ensure maximum accuracy during AI parsing and coordinate lookup.",
        "templates_subtitle": "నింపడానికి సిద్ధంగా ఉన్న ముందుగా కాన్ఫిగర్ చేసిన ఫైళ్లు",
        "templates_title": "అధికారిక టెంప్లేట్‌లు",
        "untitled_draft": "Untitled Draft",
        "upload_desc": "Ingest your properties in bulk via Excel or CSV. Our AI pipeline resolves addresses to exact map coordinates, parses amenities, BHK layouts, and prices automatically.",
        "upload_title": "ప్రాపర్టీ స్ప్రెడ్‌షీట్ అప్‌లోడ్ చేయండి",
        "url_extract_failed": "Could not extract properties from the provided URLs. Please ensure the URLs are accessible.",
        "url_import_failed": "Failed to import property URLs.",
        "urls_desc": "Paste property or project URLs (one per line). Our crawler extracts titles, configurations, floor plans, pricing, amenities, photos, and places pins on the map automatically.",
        "urls_detected_one": "{{count}} listing URL detected",
        "urls_detected_other": "{{count}} listing URLs detected",
        "urls_label": "ప్రాపర్టీ లిస్టింగ్ URLలు (ఒక్కొక్కటి ఒక లైన్)",
        "web_scraping_title": "Universal Web Scraping",
        "whatsapp": "WhatsApp కాటలాగ్",
        "whatsapp_desc": "Sync property listings directly from your WhatsApp Business catalog or forwarded message threads.",
        "youtube": "YouTube టూర్లు",
        "youtube_desc": "AI extracts property features, floor layout descriptions, and keyframe snapshots from walkthrough videos."
      },
      "resume_in_chat_tooltip": "AI ఆస్తి లిస్టింగ్ చాట్‌లో కొనసాగించి సవరించండి",
      "select_user": "వినియోగదారుని ఎంచుకోండి",
      "subtitle": "స్ప్రెడ్‌షీట్‌లు, వెబ్ URLలు లేదా సోషల్ చానెల్స్ నుండి బల్క్‌గా లిస్టింగ్‌లను దిగుమతి చేయండి.",
      "tab_web_import": "వెబ్ దిగుమతి"
    },
    "descriptions": {
      "default": "మీ ప్రాపర్టీలు మరియు లిస్టింగ్‌లను నిర్వహించండి.",
      "show_all": "ప్లాట్‌ఫారమ్‌లోని అన్ని లిస్టింగ్‌లను అన్వేషించండి.",
      "tenant_add": "మా AI సహాయకంతో మీ ప్రాపర్టీని వివరించండి. పోస్ట్ చేసిన తర్వాత, మీ ఖాతా ఆటోమేటిక్‌గా ఓనర్‌గా అప్‌గ్రేడ్ అవుతుంది."
    },
    "filters": {
      "all_purposes": "అన్ని ఉద్దేశ్యాలు",
      "all_types": "అన్ని రకాలు",
      "detect_location": "నా స్థానాన్ని గుర్తించు",
      "property_type": "ప్రాపర్టీ రకం",
      "purpose": "ఉద్దేశ్యం",
      "quick_filters": "త్వరిత ఫిల్టర్లు",
      "reset_all": "అన్నీ రీసెట్ చేయండి",
      "search_location": "స్థానాన్ని శోధించండి",
      "search_location_placeholder": "నగరం, ప్రాంతం...",
      "search_title_placeholder": "శీర్షిక..."
    },
    "headers": {
      "all_properties": "అన్ని ప్రాపర్టీలు",
      "dashboard": "డ్యాష్‌బోర్డ్",
      "list_new_property": "కొత్త ప్రాపర్టీని జాబితా చేయండి",
      "my_properties": "నా ప్రాపర్టీలు",
      "post_your_property": "మీ ప్రాపర్టీని పోస్ట్ చేయండి"
    },
    "pagination": {
      "page": "పేజీ {{page}}",
      "showing": "{{total}}లో {{shown}} ప్రాపర్టీలు చూపిస్తున్నారు"
    },
    "portfolio": {
      "managed": "Managed Portfolio",
      "owned": "Owned"
    },
    "statuses": {
      "archived": "ఆర్కైవ్ చేయబడింది",
      "draft": "డ్రాఫ్ట్",
      "rented": "అద్దెకు ఇచ్చినది",
      "sold": "అమ్మబడింది"
    },
    "unknown_error": "తెలియని లోపం",
    "upgrade_overlay": {
      "description": "మీ ప్రాపర్టీ పోస్ట్ అయింది! మేము మీ ఖాతాను ఓనర్ ఖాతాగా మార్చుతున్నాం. కాసేపు వేచి ఉండండి…",
      "title": "మీ ఖాతాను అప్‌గ్రేడ్ చేస్తున్నాం"
    },
    "view": {
      "grid": "గ్రిడ్",
      "table": "పట్టిక"
    }
  },
  "property_listing_chat": {
    "a11y": {
      "assistant_message": "అసిస్టెంట్ సందేశం",
      "conversation": "ఆస్తి లిస్టింగ్ సంభాషణ",
      "your_message": "మీ సందేశం"
    },
    "empty": {
      "description": "మీ ఆస్తిని వివరించడానికి చాట్ ప్రారంభించండి. వివరాలు సేకరించే కొద్దీ అవి మీ సమీక్ష కోసం ఇక్కడ కనిపిస్తాయి.",
      "title": "ఇంకా వివరాలు లేవు"
    },
    "errors": {
      "chat_generic": "క్షమించండి, లోపం సంభవించింది. దయచేసి మళ్ళీ ప్రయత్నించండి.",
      "hint_prefix": "💡",
      "submit_failed_prefix": "❌ ఆస్తిని సమర్పించడంలో విఫలమైంది.",
      "submit_failed_retry": "❌ ఆస్తిని సమర్పించడంలో విఫలమైంది. దయచేసి మళ్ళీ ప్రయత్నించండి.",
      "supported_locations": "మద్దతు ఉన్న ప్రాంతాలు: {{list}}"
    },
    "input": {
      "aria": "మీ ఆస్తిని వివరించండి",
      "placeholder": "మీ ఆస్తిని వివరించండి... (ఉదా., \"హైదరాబాద్, బంజారా హిల్స్‌లో 3 బెడ్‌రూమ్ అపార్ట్‌మెంట్, 1500 చ. అ., అద్దె 25000/నెల\")",
      "send_aria": "సందేశం పంపండి",
      "send_title": "సందేశం పంపండి"
    },
    "review": {
      "additional_details": "అదనపు వివరాలు",
      "amenities": "సౌకర్యాలు",
      "area": "ప్రాంతం / లోకాలిటీ",
      "bath_short_one": "{{count}} బాత్",
      "bath_short_other": "{{count}} బాత్",
      "bed_short_one": "{{count}} బెడ్",
      "bed_short_other": "{{count}} బెడ్",
      "city": "నగరం",
      "connectivity": "కనెక్టివిటీ",
      "description": "వివరణ",
      "floor": "అంతస్తు:",
      "floor_of_total": "{{total}}లో {{floor}}",
      "furnishing": "ఫర్నిషింగ్:",
      "highlights": "ముఖ్యాంశాలు",
      "location_details": "స్థాన వివరాలు",
      "location_unknown": "స్థానం తెలియదు",
      "more_images_one": "+{{count}} మరిన్ని",
      "more_images_other": "+{{count}} మరిన్ని",
      "nearby": "సమీపంలో",
      "negotiable": "💰 ధర చర్చించదగినది",
      "new_property": "కొత్త ఆస్తి",
      "parking": "పార్కింగ్:",
      "parking_spaces_one": "{{count}} స్థలాలు",
      "parking_spaces_other": "{{count}} స్థలాలు",
      "per_month": "/ నెల",
      "pincode": "పిన్ కోడ్",
      "preview_alt": "ప్రివ్యూ {{index}}",
      "sqft_suffix": "{{value}} చ. అ.",
      "state_country": "రాష్ట్రం & దేశం",
      "street": "వీధి:",
      "title": "ఆస్తి వివరాలను సమీక్షించండి",
      "uploaded_images_one": "అప్‌లోడ్ చేసిన చిత్రాలు ({{count}})",
      "uploaded_images_other": "అప్‌లోడ్ చేసిన చిత్రాలు ({{count}})",
      "views": "వీక్షణలు"
    },
    "submit_listing": "లిస్టింగ్ సమర్పించు",
    "title": "మీ ఆస్తిని లిస్ట్ చేయండి",
    "uploaded_images_message_one": "నేను {{count}} చిత్రం అప్‌లోడ్ చేశాను",
    "uploaded_images_message_other": "నేను {{count}} చిత్రాలు అప్‌లోడ్ చేశాను",
    "voice": {
      "fallback_property_type": "ఆస్తి",
      "summary_complete_no_city": "{{type}}ను లిస్ట్ చేయాలని మీరు అనుకుంటున్నారని నేను అర్థం చేసుకున్నాను. అవసరమైన వివరాలు నాకు అన్నీ ఉన్నాయి!",
      "summary_complete_with_city": "{{city}}లో {{type}}ను లిస్ట్ చేయాలని మీరు అనుకుంటున్నారని నేను అర్థం చేసుకున్నాను. అవసరమైన వివరాలు నాకు అన్నీ ఉన్నాయి!",
      "summary_incomplete_no_city": "{{type}}ను లిస్ట్ చేయాలని మీరు అనుకుంటున్నారని నేను అర్థం చేసుకున్నాను. మరిన్ని వివరాలు జోడించాలనుకుంటే చెప్పండి.",
      "summary_incomplete_with_city": "{{city}}లో {{type}}ను లిస్ట్ చేయాలని మీరు అనుకుంటున్నారని నేను అర్థం చేసుకున్నాను. మరిన్ని వివరాలు జోడించాలనుకుంటే చెప్పండి."
    },
    "welcome": "నమస్కారం! మీ ఆస్తిని లిస్ట్ చేయడంలో సహాయం చేయడానికి నేను ఇక్కడ ఉన్నాను. మీరు టెక్స్ట్‌లో వివరించవచ్చు లేదా వాయిస్ ఉపయోగించవచ్చు. మీ ఆస్తి గురించి చెప్పండి - రకం, స్థానం, పరిమాణం, ధర మరియు ప్రత్యేక ఫీచర్లు.",
    "widgets": {
      "bathrooms": "బాత్‌రూమ్‌లు",
      "bedrooms": "బెడ్‌రూమ్‌లు",
      "locality_label": "ప్రాంతం",
      "parking_spaces": "పార్కింగ్ స్థలాలు"
    }
  },
  "property_listing_form": {
    "amenities_hint": "ℹ️ లిఫ్టులు మరియు బాల్కనీలు ఆటోమేటిక్‌గా సౌకర్యాల జాబితాలో చేర్చబడతాయి",
    "complete_required_fields": "ప్రచురించడానికి అవసరమైన ఫీల్డ్‌లను పూర్తి చేయండి:",
    "display_only_amenities": "ఇది ప్రదర్శన కోసం మాత్రమే - విలువ amenities లో ఉంది",
    "done": "పూర్తయింది",
    "edit_location": "స్థానాన్ని సవరించండి",
    "edit_location_description": "మీ ఆస్తి కోఆర్డినేట్‌లను అప్‌డేట్ చేయడానికి మ్యాప్ పిన్‌ను సర్దుబాటు చేయండి.",
    "errors": {
      "failed_to_create": "ప్రాపర్టీ సృష్టించడంలో విఫలమైంది",
      "submit_failed": "ప్రాపర్టీ సమర్పణలో లోపం. దయచేసి మళ్లీ ప్రయత్నించండి.",
      "supported_locations": "మద్దతున్న స్థానాలు"
    },
    "extracted_fields": "LetMeIn AI {{total}} ఫీల్డ్‌లలో {{count}} ను పొందింది",
    "labels": {
      "additional_details": "",
      "age_of_construction": "నిర్మాణ వయస్సు",
      "apartment_name": "",
      "area": "విస్తీర్ణం",
      "area_locality": "ప్రాంతం / లోకాలిటీ",
      "area_type": "ఏరియా రకం",
      "assured_returns": "నిర్ధారిత రిటర్న్స్",
      "available_for": "అందుబాటు",
      "available_from": "ఎప్పటి నుండి అందుబాటులో",
      "available_services": "",
      "balconies": "బాల్కనీలు",
      "bathrooms": "బాత్‌రూమ్‌లు",
      "bedrooms": "బెడ్‌రూమ్‌లు",
      "booking_token_amount": "Booking / Token Amount",
      "boundary_wall": "బౌండరీ వాల్",
      "car_spaces_count": "",
      "ceiling_height": "సీలింగ్ ఎత్తు",
      "city": "నగరం",
      "commercial_subtype": "Commercial type",
      "common_area_amenities": "సాధారణ ప్రాంత సౌకర్యాలు",
      "connectivity": "కనెక్టివిటీ",
      "corner_plot": "కార్నర్ ప్లాట్",
      "corner_shop": "కార్నర్ షాప్ / యూనిట్",
      "country": "దేశం",
      "currently_leased_out": "ప్రస్తుతం అద్దెకు ఇచ్చినది",
      "entrance_width": "ప్రవేశం వెడల్పు",
      "expected_price": "అంచనా అద్దె/ధర",
      "extra_pantry": "పాంట్రీ",
      "facing": "దిశ",
      "floor_number": "అంతస్తు సంఖ్య",
      "floors_allowed_for_construction": "అనుమతించిన అంతస్తులు",
      "food_available": "ఆహారం అందుబాటులో",
      "furnishing": "ఫర్నిషింగ్",
      "gate_closing_time": "గేట్ మూసివేత సమయం",
      "ideal_for_businesses": "Ideal For",
      "intent": "ఉద్దేశ్యం",
      "land_zoning": "Land zoning",
      "lifts": "లిఫ్ట్‌లు/ఎలివేటర్లు",
      "listing_subtype": "Property sub-type",
      "loading_unloading_access": "లోడింగ్ / అన్‌లోడింగ్",
      "location": "స్థానం",
      "maintenance_charges": "నిర్వహణ ఛార్జీలు",
      "nearby_businesses": "సమీప వ్యాపారాలు",
      "nearby_places": "సమీప ప్రదేశాలు",
      "open_sides": "ఓపెన్ సైడ్స్",
      "parking": "",
      "parking_spaces": "పార్కింగ్ స్థలాలు",
      "personal_washroom": "వ్యక్తిగత వాష్‌రూమ్",
      "pg_name": "PG పేరు",
      "pg_present_in": "PG ఎక్కడ ఉంది",
      "pg_rules": "PG నియమాలు",
      "pg_usps": "ప్రత్యేక ఆకర్షణలు",
      "pincode": "పిన్‌కోడ్",
      "plot_breadth": "ప్లాట్ వెడల్పు (అడుగులు)",
      "plot_length": "ప్లాట్ పొడవు (అడుగులు)",
      "plot_subtype": "Plot type",
      "possession_status": "Possession status",
      "power_supply": "విద్యుత్ సరఫరా",
      "preferred_tenants": "",
      "property_amenities": "ప్రాపర్టీ సౌకర్యాలు",
      "property_name": "",
      "property_type": "ప్రాపర్టీ రకం",
      "road_width": "రోడ్ వెడల్పు",
      "road_width_facing_plot": "ప్లాట్ ముందు రోడ్",
      "room_facilities_short": "గది సౌకర్యాలు",
      "room_sharing": "రూమ్ షేరింగ్",
      "security_deposit": "సెక్యూరిటీ డిపాజిట్",
      "state": "రాష్ట్రం",
      "street_address": "వీధి చిరునామా",
      "tenant_preference": "అద్దెదారు ప్రాధాన్యత",
      "title": "శీర్షిక",
      "total_floors": "Total floors",
      "truck_accessibility": "ట్రక్ యాక్సెస్",
      "washroom_available": "వాష్‌రూమ్ అందుబాటులో",
      "washroom_count": "వాష్‌రూమ్ సంఖ్య"
    },
    "listing_progress": "లిస్టింగ్ పురోగతి",
    "map_pin_needed_desc": "మ్యాప్‌లో ఖచ్చితమైన ఆస్తి స్థానాన్ని నిర్ధారించడానికి ఇక్కడ క్లిక్ చేయండి.",
    "map_pin_needed_title": "ప్రచురించడానికి మ్యాప్ పిన్ అవసరం",
    "negotiable_price": "💰 చర్చించగల ధర",
    "pg": {
      "anyone": "ఎవరైనా",
      "available_floors": "అందుబాటులో ఉన్న అంతస్తులు",
      "beds_per_room": "గదికి మంచాలు",
      "boys": "అబ్బాయిలు",
      "girls": "అమ్మాయిలు",
      "rent_per_bed_short": "అద్దె/మంచం",
      "rooms": "గదులు",
      "sharing_double": "డబుల్",
      "sharing_four": "నాలుగు షేరింగ్",
      "sharing_single": "సింగిల్",
      "sharing_triple": "ట్రిపుల్"
    },
    "pg_section": "PG వివరాలు (అవసరం)",
    "pin_map_action": "మ్యాప్ పిన్ చేయండి",
    "pincode_resolve_failed": "ఎంచుకున్న నగరానికి ఆ పిన్‌కోడ్ పరిష్కరించలేకపోయాం.",
    "placeholders": {
      "age_of_construction": "ఎంచుకోండి",
      "apartment_name": "",
      "area": "ఉదా. 2250",
      "area_locality": "ఉదా. సౌత్ బ్యాంక్",
      "area_type": "ఉదా. కార్పెట్, బిల్ట్-అప్",
      "available_for": "ఎంచుకోండి",
      "booking_token_amount": "ఉదా. 100000",
      "city": "ఉదా. బ్రిస్బేన్",
      "connectivity": "ఉదా. మెట్రో స్టేషన్, బస్ స్టాప్",
      "country": "ఉదా. ఆస్ట్రేలియా",
      "facing": "ఉదా. తూర్పు",
      "floor_number": "ఉదా. 15",
      "food_available": "ఎంచుకోండి",
      "furnishing": "ఉదా. సెమీ-ఫర్నిష్డ్",
      "highlights": "",
      "intent": "అమ్మకం/అద్దె",
      "maintenance_amount": "ఉదా. 5000",
      "maintenance_frequency": "నెలవారీ",
      "nearby_places": "ఉదా. పాఠశాల, ఆసుపత్రి, మాల్",
      "number_example_2": "ఉదా. 2",
      "number_example_3": "ఉదా. 3",
      "pg_name": "ఉదా. శ్రీ సాయి PG",
      "pg_present_in": "ఎంచుకోండి",
      "pincode": "ఉదా. 500032",
      "price_example": "ఉదా. 80,000",
      "property_name": "",
      "room_sharing": "షేరింగ్ ఎంచుకోండి",
      "security_deposit": "ఉదా. 10000 లేదా 0",
      "select_property_type": "ప్రాపర్టీ రకం ఎంచుకోండి",
      "state": "ఉదా. క్వీన్స్‌ల్యాండ్",
      "street_address": "భవనం పేరు, వీధి, ల్యాండ్‌మార్క్…",
      "street_address_unconfirmed": "వీధి చిరునామా నింపడానికి చాట్ విడ్జెట్‌లో చిరునామాను నిర్ధారించండి…",
      "title": "ఉదా. 3 BHK లగ్జరీ ఫ్లాట్",
      "total_floors": "ఉదా. 10"
    },
    "posting": "ప్రచురిస్తోంది...",
    "preferred_tenants_hint": "",
    "preview": {
      "connectivity": "కనెక్టివిటీ ప్రివ్యూ",
      "nearby_places": "సమీప ప్రదేశాల ప్రివ్యూ"
    },
    "set_location_pin": "మ్యాప్ స్థానం సెట్ చేయండి *",
    "status": {
      "in_progress": "ప్రగతిలో ఉంది",
      "ready_to_list": "జాబితా చేయడానికి సిద్ధం"
    },
    "submit": "ప్రచురించు",
    "title": "ప్రాపర్టీ లిస్టింగ్ ప్రివ్యూ",
    "units": {
      "acres": "ఎకరాలు",
      "bigha": "బీఘా",
      "cents": "సెంట్లు",
      "guntas": "గుంటలు",
      "marla": "మర్లా",
      "sqft": "చ. అ.",
      "sqyd": "చ. గజ."
    },
    "validation": {
      "incomplete_sharing": "దయచేసి అన్ని షేరింగ్ వివరాలను పూర్తి చేయండి",
      "missing_area": "ప్రాంతం / లోకాలిటీ అవసరం",
      "missing_available_for": "అద్దెదారు ప్రాధాన్యత అవసరం",
      "missing_deposit": "చెల్లుబాటు అయ్యే సెక్యూరిటీ డిపాజిట్ అవసరం",
      "missing_intent": "లిస్టింగ్ ఉద్దేశం (అద్దె / అమ్మకం) అవసరం",
      "missing_map_pin": "మ్యాప్ స్థాన పిన్ అవసరం",
      "missing_pg_name": "PG పేరు అవసరం",
      "missing_pg_present_in": "భవన రకం అవసరం",
      "missing_price": "చెల్లుబాటు అయ్యే ధర/అద్దె అవసరం",
      "missing_room_sharing": "రూమ్ షేరింగ్ ఎంపిక అవసరం",
      "missing_type": "ఆస్తి రకం అవసరం"
    }
  },
  "property_manager_details": {
    "actions": {
      "back": "వెనక్కి",
      "back_home": "హోమ్‌కు తిరిగి వెళ్ళండి",
      "contact_agent": "ఏజెంట్‌ను సంప్రదించండి",
      "view_details": "వివరాలు చూడండి"
    },
    "badges": {
      "preferred": "ప్రాధాన్యత"
    },
    "empty": {
      "no_active_listings": "క్రియాశీల లిస్టింగ్స్ లేవు",
      "no_active_listings_desc": "ఈ ఏజెంట్ ప్రస్తుతం పబ్లిక్ ప్రాపర్టీలు లిస్టు చేయలేదు."
    },
    "errors": {
      "load_failed": "మేనేజర్ వివరాలు లోడ్ చేయడంలో విఫలమైంది",
      "not_found": "మేనేజర్ కనిపించలేదు"
    },
    "fallback": {
      "agent": "ఏజెంట్",
      "city": "హైదరాబాద్",
      "deal_types": {
        "rent_lease": "అద్దె/లీజ్",
        "sale": "అమ్మకం"
      },
      "independent_agent": "స్వతంత్ర ఏజెంట్",
      "initials": "PM"
    },
    "labels": {
      "baths": "స్నానాలు",
      "beds": "పడకలు",
      "company": "కంపెనీ",
      "member_since": "సభ్యత్వం ప్రారంభం",
      "no_images": "చిత్రాలు లేవు",
      "sqft": "చ.అ."
    },
    "loading_profile": "ప్రొఫైల్ లోడ్ అవుతోంది...",
    "results_count_one": "",
    "results_count_other": "",
    "sections": {
      "active_listings": "క్రియాశీల లిస్టింగ్స్",
      "active_listings_desc": "{{name}} నిర్వహిస్తున్న ప్రీమియం ప్రాపర్టీలను కనుగొనండి",
      "operating_areas": "సేవా ప్రాంతాలు",
      "specializations": "ప్రత్యేకతలు"
    },
    "stats": {
      "buyers_served": "సేవలందించిన కొనుగోలుదారులు",
      "deals_closed": "పూర్తయిన డీల్స్",
      "for_rent": "అద్దెకు ప్రాపర్టీలు",
      "for_sale": "అమ్మకానికి ప్రాపర్టీలు"
    }
  },
  "rbac": {
    "matrix": {
      "cancel_btn": "రద్దు చేయి",
      "edit_btn": "అనుమతులను సవరించండి",
      "role_column": "పాత్ర",
      "save_btn": "మార్పులను సేవ్ చేయి",
      "title": "అనుమతి మ్యాట్రిక్స్"
    },
    "roles": {
      "create_btn": "పాత్రను సృష్టించండి",
      "create_dialog": {
        "description": "కొత్త పాత్రను సృష్టించండి మరియు దానికి అనుమతులు కేటాయించండి.",
        "title": "కొత్త పాత్రను సృష్టించండి"
      },
      "description": "పాత్రలు మరియు వాటి అనుమతులను నిర్వహించండి.",
      "search_placeholder": "పాత్రల కోసం శోధించండి...",
      "title": "పాత్రలు"
    }
  },
  "redisInsight": {
    "appCache": "",
    "colDesc": "",
    "colPrefix": "",
    "colTtl": "",
    "colType": "",
    "connection": "",
    "connectionDesc": "",
    "error": "",
    "key": "",
    "keyDetails": "",
    "match": "",
    "next": "",
    "nextCursor": "",
    "noKeys": "",
    "prefixTableDesc": "",
    "prefixTableTitle": "",
    "refresh": "",
    "runScan": "",
    "scanComplete": "",
    "scanDesc": "",
    "scanTitle": "",
    "sensitiveBody": "",
    "sensitiveTitle": "",
    "stats": "",
    "subtitle": "",
    "tabBrowse": "",
    "tabOverview": "",
    "tabPrefixes": "",
    "title": "",
    "view": ""
  },
  "reports": {
    "access_logs_desc": "సిస్టమ్-వ్యాప్త యాక్సెస్ లాగ్‌లను ట్రాక్ చేయండి",
    "bulk_export": "బల్క్ ఎగుమతి",
    "categories": {
      "analytics": "విశ్లేషణలు",
      "billing": "బిల్లింగ్",
      "growth": "వృద్ధి",
      "management": "నిర్వహణ",
      "messages": "సందేశాలు",
      "security": "భద్రత"
    },
    "coming_soon_message": "సమగ్ర రిపోర్టింగ్ మాడ్యూల్ ప్రస్తుతం అభివృద్ధిలో ఉంది. త్వరలో మీరు అనుకూల నివేదికలను రూపొందించగలరు, స్వయంచాలక ఎగుమతులను షెడ్యూల్ చేయగలరు మరియు ఈ డాష్‌బోర్డ్ నుండి నేరుగా లోతైన పనితీరు కొలమానాలను విశ్లేషించగలరు.",
    "coming_soon_title": "త్వరలో రాబోతోంది: అధునాతన నివేదన",
    "compliance_log_desc": "పూర్తి సమ్మతి మరియు స్థితి లాగ్",
    "demographic_desc": "ప్లాట్‌ఫారమ్ వినియోగదారుల జనాభా సమాచారం",
    "description_superadmin": "ఉన్నత-స్థాయి ప్లాట్‌ఫారమ్ ఆడిట్‌లు, ఆదాయ మార్గాలు మరియు సిస్టమ్ లాగ్‌లను యాక్సెస్ చేయండి.",
    "description_user": "వివరణాత్మక సిస్టమ్ మరియు ఆస్తి నివేదికలను రూపొందించండి, వీక్షించండి మరియు ఎగుమతి చేయండి.",
    "executive_desc": "ఒక పేజీ కార్యనిర్వాహక సారాంశం",
    "filter": "ఫిల్టర్",
    "financial_desc": "ఆర్థిక పనితీరు యొక్క అవలోకనం",
    "generate_new": "కొత్తది రూపొందించండి",
    "items": {
      "compliance_check": {
        "description": "నమోదిత వ్యాపార సంస్థలన్నింటి యొక్క ఆడిట్ స్థితి.",
        "name": "సంస్థ సమ్మతి తనిఖీ"
      },
      "consolidated_revenue": {
        "description": "స్ట్రైప్ లావాదేవీల పరిమాణం మరియు సబ్‌స్క్రిప్షన్ MRR విభజన.",
        "name": "ఏకీకృత రాబడి నివేదిక"
      },
      "growth_analysis": {
        "description": "వినియోగదారులు మరియు సంస్థల కోసం సంవత్సరానికి వృద్ధి కొలమానాలు.",
        "name": "ప్లాట్‌ఫారమ్ వృద్ధి విశ్లేషణ - Q1 2026"
      },
      "maintenance_report": {
        "description": "కొనసాగుతున్న మరియు పూర్తయిన అన్ని నిర్వహణ పనుల స్థితి అప్‌డేట్.",
        "name": "ఆస్తి నిర్వహణ నివేదిక"
      },
      "monthly_review": {
        "description": "ఆస్తి పనితీరు, ట్రాఫిక్ మరియు లీడ్‌ల యొక్క సమగ్ర అవలోకనం.",
        "name": "నెలవారీ పనితీరు సమీక్ష - జనవరి 2026"
      },
      "revenue_export": {
        "description": "స్ట్రైప్ లావాదేవీ చరిత్ర మరియు సబ్‌స్క్రిప్షన్ స్థితి వివరాలు.",
        "name": "రాబడి & సభ్యత్వ ఎగుమతి"
      },
      "security_audit": {
        "description": "యాక్సెస్ లాగ్‌లు మరియు సున్నితమైన సిస్టమ్ మార్పుల పూర్తి ట్రేస్.",
        "name": "భద్రతా ఆడిట్ & సిస్టమ్ లాగ్‌లు"
      },
      "tenant_log": {
        "description": "భావి అద్దెదారుల నుండి అన్ని సందేశాలు మరియు విచారణల వివరాల విశ్లేషణ.",
        "name": "అద్దెదారుల పరస్పర చర్య లాగ్"
      }
    },
    "load_more": "మరిన్ని నివేదికలను లోడ్ చేయండి",
    "property_audit": "ఆస్తి ఆడిట్",
    "raw_export_desc": "అన్ని డేటాను RAW ఫార్మాట్‌కు ఎగుమతి చేయండి",
    "recent_reports": "ఇటీవలి నివేదికలు",
    "reports_list_desc": "మీరు ఇటీవల రూపొందించిన డేటా ఎగుమతుల జాబితా.",
    "revenue_matrix": "ఆదాయ మాతృక",
    "sample_data_badge": "",
    "sample_file_type": "",
    "security_logs": "భద్రతా లాగ్‌లు",
    "title_superadmin": "ప్లాట్‌ఫారమ్ విశ్లేషణలు",
    "title_user": "సిస్టమ్ నివేదికలు",
    "user_analytics": "వినియోగదారుల విశ్లేషణలు",
    "view": "చూడండి",
    "visual_summary": "దృశ్య సారాంశం"
  },
  "reset_password": {
    "actions": {
      "reset": "పాస్‌వర్డ్ రీసెట్ చేయండి",
      "resetting": "రీసెట్ అవుతోంది..."
    },
    "description": "క్రింద మీ కొత్త పాస్‌వర్డ్ నమోదు చేయండి.",
    "errors": {
      "expired_link": "రీసెట్ లింక్ చెల్లదు లేదా గడువు ముగిసింది. కొత్త లింక్‌ను కోరండి.",
      "invalid_token": "చెల్లని లేదా లేని టోకెన్.",
      "min_length": "పాస్‌వర్డ్ కనీసం 8 అక్షరాలు ఉండాలి.",
      "password_mismatch": "పాస్‌వర్డ్లు సరిపోలలేదు."
    },
    "fields": {
      "confirm_password_label": "కొత్త పాస్‌వర్డ్ నిర్ధారించండి",
      "confirm_password_placeholder": "కొత్త పాస్‌వర్డ్ మళ్లీ నమోదు చేయండి",
      "new_password_label": "కొత్త పాస్‌వర్డ్",
      "new_password_placeholder": "కొత్త పాస్‌వర్డ్ నమోదు చేయండి"
    },
    "success": {
      "redirecting": "లాగిన్‌కు మళ్లిస్తున్నాం...",
      "title": "మీ పాస్‌వర్డ్ రీసెట్ అయింది!"
    },
    "title": "మీ పాస్‌వర్డ్ రీసెట్ చేయండి"
  },
  "roles": {
    "admin": "అడ్మిన్",
    "individual": "",
    "org_admin": "సంస్థ అడ్మిన్",
    "org_user": "సంస్థ వినియోగదారు",
    "owner": "యజమాని",
    "property_manager": "ఆస్తి నిర్వాహకుడు",
    "super_admin": "సూపర్ అడ్మిన్",
    "tenant": "అద్దెదారు"
  },
  "search": {
    "all_results_desc": "{{total}} ప్రాపర్టీలలో {{shown}} చూపబడ్డాయి",
    "all_results_title": "శోధన ఫలితాలన్నీ",
    "featured_listing": "ప్రత్యేక జాబితా",
    "load_more_failed": "మరిన్ని ప్రాపర్టీలను లోడ్ చేయడం సాధ్యం కాలేదు. దయచేసి మళ్లీ ప్రయత్నించండి.",
    "loading_more": "లోడ్ అవుతోంది…",
    "matches_found_one": "{{count}} సరిపోలిక కనుగొనబడింది",
    "matches_found_other": "{{count}} సరిపోలికలు కనుగొనబడ్డాయి",
    "modify_btn": "శోధనను సవరించండి",
    "modify_placeholder": "మీ శోధనను ఎలా మెరుగుపరచాలో వివరించండి…",
    "more_matches": "మరిన్ని మ్యాచ్‌లు",
    "show_more": "మరిన్ని చూపు",
    "sponsored": "స్పాన్సర్",
    "view_all_results_one": "అన్ని {{count}} ఫలితాలను వీక్షించండి",
    "view_all_results_other": "అన్ని {{count}} ఫలితాలను వీక్షించండి"
  },
  "search_chips": {
    "clear_all": "అన్నీ తొలగించు",
    "within_km": "{{n}} కి.మీ లోపల",
    "within_m": "{{n}} మీ లోపల"
  },
  "settings": {
    "choose_language": "మీ అనుభవం కోసం భాషను ఎంచుకోండి",
    "features": {
      "controls": {
        "description": "అన్ని వినియోగదారుల కోసం ఫీచర్‌లను ఆన్ లేదా ఆఫ్ చేయండి",
        "title": "ఫీచర్ నియంత్రణలు"
      },
      "description": "అప్లికేషన్ ఫీచర్‌లను ఎనేబుల్ లేదా డిసేబుల్ చేయండి",
      "items": {
        "aadhaar_verification": {
          "description": "వినియోగదారుల కోసం ఆధార్ OTP ధృవీకరణను ప్రారంభించండి",
          "title": "ఆధార్ ధృవీకరణ"
        },
        "ai_chat": {
          "description": "AI-ఆధారిత చాట్ అసిస్టెంట్‌ని ఎనేబుల్ చేయండి",
          "title": "AI చాట్"
        },
        "geo_search": {
          "description": "PostGIS రేడియస్ శోధన, మ్యాప్ ఫలితాలు, మరియు /assistant",
          "title": "జియో మ్యాప్ శోధన"
        },
        "property_comparison": {
          "description": "వినియోగదారులు బహుళ ఆస్తులను పోల్చడానికి అనుమతించండి",
          "title": "ఆస్తి పోలిక"
        },
        "toon_format": {
          "description": "LLM నుండి TOON ఫార్మాట్ ప్రతిస్పందనలను ఎనేబుల్ చేయండి",
          "title": "LLM కోసం TOON ఫార్మాట్"
        },
        "voice_search": {
          "description": "వాయిస్ ఆధారిత ఆస్తి శోధనను ఎనేబుల్ చేయండి",
          "title": "వాయిస్ శోధన"
        }
      },
      "storage": {
        "firestore": {
          "db_info": "Firestore డేటాబేస్ ఉపయోగిస్తోంది",
          "description": "Firestore ఉపయోగిస్తున్నప్పుడు టోకెన్ వినియోగం మరియు కార్యాచరణ లాగ్‌లు ఎక్కడ నిల్వ చేయబడతాయో కాన్ఫిగర్ చేయండి.",
          "status_label": "Firestore కనెక్షన్",
          "test_btn": "కనెక్షన్‌ని పరీక్షించండి",
          "title": "Firebase / Firestore నిల్వ"
        }
      },
      "title": "ఫీచర్ ఫ్లాగ్‌లు"
    },
    "firebase": {
      "description": "టోకెన్ వినియోగం మరియు కార్యాచరణ లాగ్‌ల కోసం Firestore కనెక్షన్ మరియు నిల్వ బ్యాకెండ్ (డేటాబేస్ వర్సెస్ Firestore).",
      "test_to_verify": "Firestore కాన్ఫిగర్ చేయబడిందని ధృవీకరించడానికి కనెక్షన్‌ని పరీక్షించండి."
    },
    "general": {
      "description": "ప్రాథమిక అప్లికేషన్ సెట్టింగ్‌లను కాన్ఫిగర్ చేయండి",
      "site_config": {
        "contact_email": "సంప్రదింపు ఇమెయిల్",
        "contact_email_placeholder": "contact@example.com",
        "description": "మీ అప్లికేషన్ గురించిన ప్రాథమిక సమాచారం",
        "max_image_upload_mb": "గరిష్ట చిత్రం అప్లోడ్ పరిమాణం (MB)",
        "max_image_upload_mb_description": "ఒక అప్లోడ్ ఆస్తి చిత్రం గరిష్ట పరిమాణం (MB).",
        "max_media_limit": "ఆస్తి జాబితాకి గరిష్ట మీడియా (ఫోటోలు & వీడియో టూర్లు)",
        "max_media_limit_description": "ప్రతి ఆస్తి జాబితాకి అనుమతినిచబడే మొత్తం మీడియా.",
        "max_scraper_video_limit": "ఆస్తికి గరిష్ట స్క్రేప్ వీడియోలు (వెబ్ స్క్రేపింగ్)",
        "max_scraper_video_limit_description": "ప్రతి జాబితా నుండి స్క్రేప్ చేయాల్సిన గరిష్ట వీడియో టూర్లు.",
        "max_video_upload_mb": "గరిష్ట వీడియో అప్లోడ్ పరిమాణం (MB)",
        "max_video_upload_mb_description": "ఒక అప్లోడ్ ఆస్తి వీడియో గరిష్ట పరిమాణం (MB).",
        "site_description": "సైట్ వివరణ",
        "site_description_placeholder": "AI-ఆధారిత రియల్ ఎస్టేట్ ప్లాట్‌ఫారమ్",
        "site_name": "సైట్ పేరు",
        "site_name_placeholder": "నా రియల్ ఎస్టేట్ యాప్",
        "title": "సైట్ కాన్ఫిగరేషన్"
      },
      "title": "సాధారణ సెట్టింగ్‌లు"
    },
    "interface_language": "ఇంటర్ఫేస్ భాష",
    "language": "భాష",
    "language_preferences": "భాషా ప్రాధాన్యతలు",
    "language_saved": "భాష ప్రాధాన్యతలు విజయవంతంగా నవీకరించబడ్డాయి",
    "languages": "భాషలు",
    "media": {
      "description": "ప్రాపర్టీ మీడియా పరిమితులు, వీడియో అప్‌లోడ్ పరిమాణాలు మరియు వెబ్ స్క్రాపర్ సెట్టింగ్‌లను కాన్ఫిగర్ చేయండి",
      "subtitle": "ప్రతి లిస్టింగ్‌కు ఫోటో గణనలు, వీడియో టూర్ పరిమితులు మరియు గరిష్ట ఫైల్ అప్‌లోడ్ పరిమాణాలను నియంత్రించండి",
      "title": "మీడియా & వీడియో అప్‌లోడ్ పరిమితులు"
    },
    "mobile": {
      "open_sections": "సెట్టింగ్లు విభాగాలను తెరవెయ్యి"
    },
    "no_permission": "మీకు సిస్టమ్ సెట్టింగ్‌లను యాక్సెస్ చేయడానికి అనుమతి లేదు. నిర్వాహకులు మాత్రమే సిస్టమ్ సెట్టింగ్‌లను నిర్వహించగలరు.",
    "save": "మార్పులను సేవ్ చేయండి",
    "sections": {
      "advanced": "అధునాతన",
      "api": "API కాన్ఫిగ్",
      "auth": "ప్రామాణీకరణ",
      "email": "ఇమెయిల్ కాన్ఫిగ్",
      "features": "ఫీచర్ ఫ్లాగ్‌లు",
      "firebase": "ఫైర్‌బేస్",
      "general": "సాధారణ",
      "media": "మీడియా & అప్‌లోడ్‌లు",
      "payment": "చెల్లింపు"
    },
    "select_from_available": "అందుబాటులో ఉన్న భాషల నుండి ఎంచుకోండి",
    "select_language": "మీకు నచ్చిన భాషను ఎంచుకోండి",
    "sidebar": {
      "description": "గ్లోబల్ అప్లికేషన్ సెట్టింగ్‌లను నిర్వహించండి",
      "title": "సిస్టమ్ సెట్టింగ్‌లు"
    }
  },
  "sidebar": {
    "activity_logs": "కార్యకలాప లాగ్లు",
    "administration": "పరిపాలన",
    "all_properties": "అన్ని ఆస్తులు",
    "all_subscriptions": "అన్ని చందాలు",
    "analytics": "విశ్లేషణ",
    "analytics_reports": "విశ్లేషణ & నివేదికలు",
    "api_usage": "API వినియోగం",
    "auth_matrix": "అధికార మాతృక",
    "brokerage_hub": "బ్రోకరేజ్ హబ్",
    "dashboard": "డ్యాష్‌బోర్డ్",
    "feedback": "అభిప్రాయం",
    "google_maps_usage": "మ్యాప్స్ & ప్లేసెస్ ఖర్చు",
    "help_support": "సహాయం & మద్దతు",
    "import_properties": "ఆస్తులను దిగుమతి చేయండి",
    "list_my_properties": "నా ఆస్తుల జాబితా",
    "list_properties": "ఆస్తులను జాబితా చేయండి",
    "logout": "లాగ్ అవుట్",
    "manage_plans": "ప్రణాళికలను నిర్వహించండి",
    "manage_roles": "పాత్రలను నిర్వహించండి",
    "messages": "సందేశాలు",
    "my_favourites": "నా ఇష్టమైనవి",
    "my_leases": "నా లీజులు",
    "my_properties": "నా ఆస్తులు",
    "my_subscription": "నా చందా",
    "org_properties": "సంస్థ ఆస్తులు",
    "org_users": "సంస్థ వినియోగదారులు",
    "organizations": "బిల్డర్‌లు",
    "owner": "యజమాని",
    "profile": "ప్రొఫైల్",
    "property_search": "ఆస్తి శోధన",
    "redis_insight": "రెడిస్ ఇన్‌సైట్",
    "reports": "నివేదికలు",
    "revenue": "ఆదాయం",
    "reviews": "సమీక్షలు",
    "roles_perms": "పాత్రలు & అనుమతులు",
    "settings": "సెట్టింగ్‌లు",
    "subscription": "చందా",
    "tenant": "అద్దెదారు",
    "tenants": "అద్దెదారులు & విచారణలు",
    "token_usage": "టోకెన్ వినియోగం",
    "transactions": "లావాదేవీలు",
    "usage_billing": "వినియోగం & బిల్లింగ్",
    "users": "వినియోగదారులు"
  },
  "simple_test": {
    "button": "నన్ను క్లిక్ చేయండి",
    "description": "ఈ కనీస పేజీని గుర్తించి, అనువదించండి.",
    "title": "సాధారణ అనువాద పరీక్ష"
  },
  "single_phase": "",
  "subscription": {
    "active": "చురుకైన",
    "auto_renewal": "స్వయంచాలక పునరుద్ధరణ",
    "billing_info": "బిల్లింగ్ సమాచారం",
    "cancel_btn": "చందా రద్దు చేయండి",
    "cancel_desc": "మీరు మీ సభ్యత్వాన్ని రద్దు చేయాలనుకుంటున్నారా? ఇది మీ బిల్లింగ్ సైకిల్ ముగింపులో మిమ్మల్ని ఉచిత ప్లాన్‌కి డౌన్‌గ్రేడ్ చేస్తుంది.",
    "change_btn": "ప్లాన్ మార్చండి",
    "choose_plan": {
      "back_to_manage": "ప్లాన్‌ల నిర్వహణకు తిరిగి వెళ్ళు",
      "back_to_sub": "నా చందాకు తిరిగి వెళ్ళు",
      "forever": "ఎప్పటికీ",
      "monthly": "నెలవారీ",
      "regular_desc": "మీ ప్రధాన చందా ప్లాన్‌ని ఎంచుకోండి",
      "regular_plans": "సాధారణ ప్లాన్‌లు",
      "subscribe": "చందా పొందండి",
      "subtitle": "మీ అవసరాలకు సరైన ప్లాన్‌ను ఎంచుకోండి.",
      "title": "మీ ప్లాన్‌ని ఎంచుకోండి",
      "yearly": "వార్షిక"
    },
    "confirm_cancel": "రద్దును నిర్ధారించండి",
    "current_plan": "ప్రస్తుత ప్లాన్",
    "disabled": "నిలిపివేయబడింది",
    "enabled": "ప్రారంభించబడింది",
    "free_tier": "ఉచిత శ్రేణి",
    "inactive": "అచేతన",
    "keep_btn": "చందా ఉంచండి",
    "next_billing": "తదుపరి బిల్లింగ్ తేదీ",
    "org_plan_desc": "మీ సభ్యత్వం మీ సంస్థ ద్వారా అందించబడుతుంది.",
    "plan_details": "ప్లాన్ వివరాలు",
    "status": "స్థితి",
    "title": "మీ చందా",
    "upgrade_btn": "ప్లాన్ అప్‌గ్రేడ్ చేయండి",
    "using_org_plan": "సంస్థ ప్లాన్‌ను ఉపయోగిస్తున్నారు"
  },
  "terms_of_service": {
    "contact": {
      "prefix": ""
    },
    "last_updated": "చివరి నవీకరణ: జనవరి 30, 2026",
    "sections": {
      "accounts": {
        "body": "ఖాతా సృష్టించే సమయంలో మీరు ఇచ్చే సమాచారం సరైనది, పూర్తిగా, నవీకరించబడినదిగా ఉండాలి.",
        "title": "3. వినియోగదారు ఖాతాలు"
      },
      "agreement": {
        "body": "LetMeIn AI ను ఉపయోగించడం ద్వారా, మీరు ఈ సేవా నిబంధనలకు అంగీకరిస్తారు.",
        "title": "1. నిబంధనలకు అంగీకారం"
      },
      "changes": {
        "body": "మేము ఎప్పుడైనా ఈ నిబంధనలను సవరించవచ్చు. సేవను కొనసాగిస్తూ ఉపయోగిస్తే మార్పులను అంగీకరించినట్లే.",
        "title": "7. నిబంధనల మార్పులు"
      },
      "description": {
        "body": "LetMeIn AI యజమానులు ఆస్తులు జాబితా చేయడానికి, వినియోగదారులు వసతి ఎంపికలు కనుగొనడానికి ఒక వేదికను అందిస్తుంది.",
        "title": "2. సేవ వివరణ"
      },
      "liability": {
        "body": "LetMeIn AI పరోక్ష లేదా అనుబంధ నష్టాలకు బాధ్యత వహించదు.",
        "title": "6. బాధ్యత పరిమితం"
      },
      "listings": {
        "body": "యజమానులు మరియు మేనేజర్లు తమ జాబితాల ఖచ్చితత్వం మరియు చట్టబద్ధతకు బాధ్యత వహిస్తారు.",
        "title": "4. ఆస్తి జాబితాలు"
      },
      "prohibited": {
        "body": "మీరు ఈ క్రింది కార్యకలాపాల్లో పాల్గొనకూడదు:",
        "items": {
          "automation": "\"robots\", \"spiders\" వంటి ఆటోమేటెడ్ వ్యవస్థలను ఉపయోగించడం.",
          "copying": "సేవలోని ఏ భాగాన్నైనా కాపీ చేయడం, పంపిణీ చేయడం లేదా వెల్లడించడం.",
          "interference": "సిస్టమ్ భద్రత/అఖండతను భంగం చేసేందుకు లేదా సర్వర్ ప్రసారాలను డీకోడ్ చేయడానికి ప్రయత్నించడం."
        },
        "title": "5. నిషేధిత కార్యకలాపాలు"
      }
    },
    "title": "సేవా నిబంధనలు"
  },
  "three_phase": "",
  "token_usage": {
    "by_endpoint": "ఎండ్పాయింట్ వారీ",
    "by_member": "సభ్యుడు వారీ",
    "calls": "కాల్లు",
    "days": "రోజులు",
    "description": "టోకెన్ వినియోగం, ప్రొవైడర్ మరియు ఎండ్‌పాయింట్ వారీగా ఖర్చును వీక్షించండి మరియు CSVని ఎగుమతి చేయండి. నిర్వాహకులకు మాత్రమే.",
    "endpoint": "ఎండ్పాయింట్",
    "export_csv": "టోకెన్ వినియోగం CSVని ఎగుమతి చేయండి",
    "export_ledger_csv": "లెడ్జర్ CSVని ఎగుమతి చేయండి",
    "member": "సభ్యుడు",
    "no_org_data": "సంస్థ వినియోగ డేటా లేదు. ముందు Summary ట్యాబ్ లోడ్ చేయండి.",
    "org_name": "సంస్థ",
    "org_overview": "సంస్థ అవలోకనం",
    "organization": "సంస్థ",
    "summary": {
      "card_description": "ప్రొవైడర్ మరియు ఎండ్‌పాయింట్ వారీగా మొత్తం టోకెన్లు మరియు ఖర్చు.",
      "card_title": "సారాంశం"
    },
    "tabs": {
      "by_format": "ఫార్మాట్ వారీ",
      "by_org": "సంస్థ వారీ",
      "by_user": "వినియోగదారుని ద్వారా",
      "daily": "రోజువారీ",
      "recent": "ఇటీవలి",
      "summary": "సారాంశం"
    },
    "title": "టోకెన్ / LLM వినియోగం",
    "tokens": "టోకెన్లు",
    "total_calls": "మొత్తం కాల్లు",
    "total_tokens": "మొత్తం టోకెన్లు"
  },
  "topup_page": {
    "actions": {
      "change_amount": "మొత్తాన్ని మార్చండి",
      "continue_to_payment": "చెల్లింపుకు కొనసాగండి",
      "pay_with_razorpay": "Razorpayతో చెల్లించండి"
    },
    "amount_help": "{{description}} కనిష్ఠం {{min}}, గరిష్ఠం {{max}}.",
    "amount_label": "మొత్తం (USD)",
    "amount_label_inr": "మొత్తం (INR)",
    "amount_placeholder": "ఉదా. 20",
    "amount_placeholder_inr": "ఉదా. 500",
    "checkout": {
      "amount_label": "మొత్తం",
      "description": "{{target}}కు {{amount}} జోడించడానికి చెల్లింపు వివరాలు నమోదు చేయండి.",
      "loading_form": "చెల్లింపు ఫారం లోడ్ అవుతోంది...",
      "pay_amount": "{{amount}} చెల్లించండి",
      "processing": "ప్రాసెస్ అవుతోంది..."
    },
    "description": {
      "org": "క్రెడిట్లు మీ సంస్థ యొక్క భాగస్వామ్య వాలెట్‌కు జోడించబడతాయి.",
      "personal": "క్రెడిట్లు మీ వ్యక్తిగత బ్యాలెన్స్‌కు జోడించబడతాయి."
    },
    "errors": {
      "payment_failed": "చెల్లింపు విఫలమైంది",
      "razorpay_load_failed": "Razorpay చెక్అవుట్ లోడ్ చేయడంలో విఫలమైంది",
      "start_payment_failed": "చెల్లింపును ప్రారంభించడంలో విఫలమైంది"
    },
    "loading": "లోడ్ అవుతోంది...",
    "org_notice_amount": {
      "prefix": "ఈ క్రెడిట్లు",
      "suffix": "కి జోడించబడతాయి మరియు అన్ని సభ్యులు వినియోగిస్తారు.",
      "wallet": "సంస్థ భాగస్వామ్య వాలెట్"
    },
    "org_notice_checkout": {
      "prefix": "మీరు",
      "suffix": "కి టాప్-అప్ చేస్తున్నారు — అన్ని సభ్యులు ఈ క్రెడిట్లను ఉపయోగించగలరు.",
      "wallet": "సంస్థ వాలెట్"
    },
    "razorpay_description": "మీ వాలెట్కి క్రెడిట్లు జోడండి",
    "razorpay_notice": "మీరు Razorpay (UPI, కార్డులు, నెట్బ్యాంకింగ్) ద్వారా చెల్లిస్తారు. చెల్లిಂపి తర్వాత క్రెడిట్లు జోడబడతాయి.",
    "targets": {
      "org_wallet": "సంస్థ వాలెట్",
      "personal_balance": "మీ బ్యాలెన్స్"
    },
    "title": {
      "org": "సంస్థకు క్రెడిట్లు జోడించండి",
      "personal": "క్రెడిట్లు జోడించండి"
    }
  },
  "transactions": {
    "description": "అన్ని చెల్లింపు లావాదేవీలను వీక్షించండి మరియు నిర్వహించండి.",
    "headers": {
      "credited": "క్రెడిట్ జోడబడింది",
      "download": "ఇన్‌వాయిస్‌ను డౌన్‌లోడ్ చేయండి",
      "item": "అంశం",
      "paid": "చెల్లించాబడింది",
      "payment_method": "చెల్లింపు పద్ధతి",
      "transaction_id": "లావాదేవీ ID",
      "type": "రకం",
      "user": "వినియోగదారు"
    },
    "items": {
      "org_topup": "సంస్థ వాలెట్ ({{gateway}})",
      "personal_topup": "వ్యక్తిగత వాలెట్ ({{gateway}})"
    },
    "search_placeholder": "లావాదేవీలను శోధించండి...",
    "table": {
      "description": "మీ సిస్టమ్‌లోని అన్ని చెల్లింపు లావాదేవీల జాబితా.",
      "title": "అన్ని లావాదేవీలు"
    },
    "title": "లావాదేవీలు",
    "types": {
      "other": "ఇతర",
      "plan": "ప్లాన్",
      "topup": "క్రెడిట్ టాప్-అప్"
    }
  },
  "translationDemo": {
    "actions": {
      "decrement": "అనువాద డెమో చర్యలు తగ్గించు",
      "increment": "అనువాద డెమో చర్యలు పెంచు",
      "loading": "అనువాద డెమో చర్యలు లోడ్ అవుతున్నాయి",
      "reset": "అనువాద డెమో చర్యలు రీసెట్ చేయండి",
      "submit": "అనువాద డెమో చర్యలు సమర్పించండి"
    },
    "badge": "అనువాద డెమో బ్యాడ్జ్",
    "bestPractices": {
      "tip1": "అనువాద డెమో ఉత్తమ పద్ధతులు చిట్కా 1",
      "tip2": "అనువాద డెమో ఉత్తమ పద్ధతులు చిట్కా 2",
      "tip3": "అనువాద డెమో ఉత్తమ పద్ధతులు చిట్కా 3",
      "tip4": "అనువాద డెమో ఉత్తమ పద్ధతులు చిట్కా 4"
    },
    "counter": {
      "label": "అనువాద డెమో కౌంటర్ లేబుల్",
      "message_one": "అనువాద డెమో కౌంటర్ సందేశం",
      "message_other": "అనువాద డెమో కౌంటర్ సందేశం"
    },
    "description": "అనువాద డెమో వివరణ",
    "examples": {
      "greeting": {
        "label": "అనువాద డెమో ఉదాహరణలు శుభాకాంక్షల లేబుల్",
        "message": "అనువాద డెమో ఉదాహరణలు శుభాకాంక్షల సందేశం"
      },
      "simple": {
        "label": "అనువాద డెమో ఉదాహరణలు సాధారణ లేబుల్",
        "text": "అనువాద డెమో ఉదాహరణలు సాధారణ వచనం"
      }
    },
    "footer": {
      "text": "అనువాద డెమో ఫూటర్ వచనం"
    },
    "notifications": {
      "error": "అనువాద డెమో నోటిఫికేషన్లు లోపం",
      "info": "అనువాద డెమో నోటిఫికేషన్లు సమాచారం",
      "success": "అనువాద డెమో నోటిఫికేషన్లు విజయం"
    },
    "sections": {
      "basic": {
        "description": "అనువాద డెమో విభాగాలు ప్రాథమిక వివరణ",
        "title": "అనువాద డెమో విభాగాలు ప్రాథమిక శీర్షిక"
      },
      "bestPractices": {
        "description": "అనువాద డెమో విభాగాలు ఉత్తమ పద్ధతుల వివరణ",
        "title": "అనువాద డెమో విభాగాలు ఉత్తమ పద్ధతుల శీర్షిక"
      },
      "conditional": {
        "description": "అనువాద డెమో విభాగాలు షరతులతో కూడిన వివరణ",
        "title": "అనువాద డెమో విభాగాలు షరతులతో కూడిన శీర్షిక"
      },
      "pluralization": {
        "description": "అనువాద డెమో విభాగాలు బహువచనీకరణ వివరణ",
        "title": "అనువాద డెమో విభాగాలు బహువచనీకరణ శీర్షిక"
      },
      "statuses": {
        "description": "అనువాద డెమో విభాగాలు స్థితి వివరణ",
        "title": "అనువాద డెమో విభాగాలు స్థితి శీర్షిక"
      }
    },
    "status": {
      "error": "అనువాద డెమో స్థితి లోపం",
      "success": "అనువాద డెమో స్థితి విజయం"
    },
    "title": "అనువాద డెమో శీర్షిక"
  },
  "user_roles_page": {
    "access_denied": {
      "description": "యూజర్ రోల్ నిర్వహణను చూడటానికి మీకు అనుమతి లేదు.",
      "title": "ప్రవేశం నిరాకరించబడింది"
    },
    "actions": {
      "assign_role": "రోల్ కేటాయించు"
    },
    "alerts": {
      "assign_failed": "రోల్ కేటాయించడం విఫలమైంది.",
      "role_assigned": "రోల్ విజయవంతంగా కేటాయించబడింది!",
      "select_user_role": "దయచేసి యూజర్ మరియు రోల్ రెండూ ఎంచుకోండి."
    },
    "dialog": {
      "global_role": "గ్లోబల్ రోల్",
      "organization_label": "సంస్థ (ఐచ్చికం)",
      "organization_placeholder": "గ్లోబల్ రోల్",
      "role_label": "రోల్",
      "role_placeholder": "రోల్ ఎంచుకోండి",
      "title": "యూజర్‌కు రోల్ కేటాయించు",
      "user_label": "యూజర్",
      "user_placeholder": "యూజర్ ఎంచుకోండి"
    },
    "loading": "యూజర్ రోల్స్ లోడ్ అవుతున్నాయి...",
    "search_placeholder": "యూజర్లను వెతకండి...",
    "showing_users_one": "",
    "showing_users_other": "",
    "subtitle": "యూజర్లకు రోల్స్ కేటాయించి నిర్వహించండి",
    "table": {
      "name": "పేరు",
      "roles": "రోల్స్",
      "status": "స్థితి"
    },
    "title": "యూజర్ రోల్ నిర్వహణ"
  },
  "validation": {
    "accept_terms": "మీరు నిబంధనలు మరియు షరతులను అంగీకరించాలి",
    "billing_country_required": "",
    "city_required_signup": "నగరం అవసరం",
    "invalid_email": "దయచేసి సరైన ఇమెయిల్ చిరునామాను నమోదు చేయండి",
    "org_name_min": "సంస్థ పేరు కనీసం 4 అక్షరాలు ఉండాలి",
    "password_complexity": "పాస్‌వర్డ్ కనీసం ఒక పెద్ద అక్షరం, ఒక చిన్న అక్షరం మరియు ఒక సంఖ్యను కలిగి ఉండాలి",
    "password_min": "పాస్‌వర్డ్ కనీసం 8 అక్షరాలు ఉండాలి",
    "passwords_mismatch": "పాస్‌వర్డ్‌లు సరిపోలడం లేదు",
    "phone_country": "",
    "username_min": "యూజర్‌నేమ్ కనీసం 2 అక్షరాలు ఉండాలి"
  },
  "verify_email": {
    "actions": {
      "go_to_login": "లాగిన్‌కి వెళ్ళండి"
    },
    "descriptions": {
      "error": "మీ ఇమెయిల్ ధృవీకరణలో సమస్య వచ్చింది.",
      "pending": "దయచేసి వేచి ఉండండి, మీ ఇమెయిల్‌ను ధృవీకరిస్తున్నాం.",
      "success": "మీ ఇమెయిల్ ధృవీకరించబడింది! లాగిన్ పేజీకి మళ్లిస్తున్నాం..."
    },
    "messages": {
      "invalid_token": "చెల్లని లేదా లేని ధృవీకరణ టోకెన్.",
      "verification_failed": "ధృవీకరణ విఫలమైంది. లింక్ చెల్లకపోవచ్చు లేదా గడువు ముగిసివుండవచ్చు.",
      "verified": "మీ ఇమెయిల్ ధృవీకరించబడింది!",
      "verifying": "మీ ఇమెయిల్‌ను ధృవీకరిస్తున్నాం..."
    },
    "title": "ఇమెయిల్ ధృవీకరణ"
  },
  "voice": {
    "failed_start": "",
    "hold_to_speak": "మాట్లాడటానికి నొక్కి పట్టుకోండి, టోగుల్ చేయడానికి ట్యాప్ చేయండి",
    "live_connect_failed": "",
    "mic_denied": "మైక్రోఫోన్ యాక్సెస్ తిరస్కరించబడింది",
    "no_mic": "మైక్రోఫోన్ కనుగొనబడలేదు",
    "no_speech": "వాయిస్ గుర్తించబడలేదు",
    "not_supported": "ఈ బ్రౌజర్‌లో వాయిస్ ఇన్‌పుట్ సపోర్ట్ చేయదు",
    "permission_denied": "మైక్రోఫోన్ అనుమతి తిరస్కరించబడింది",
    "recognition_error": "వాయిస్ గుర్తింపు లోపం",
    "stop_recording": "రికార్డింగ్ ఆపివేయి",
    "transcribing": "ఆడియో ట్రాన్స్‌క్రైబ్ అవుతోంది...",
    "transcribing_btn": "ట్రాన్స్‌క్రైబ్ అవుతోంది...",
    "transcription_failed": "ట్రాన్స్‌క్రిప్షన్ విఫలమైంది"
  }
}
